import { Component, ElementRef, HostListener, NgZone, OnDestroy, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { DndDropEvent, DropEffect } from 'ngx-drag-drop';
import { ToastrService } from 'ngx-toastr';
import { finalize, firstValueFrom, Subscription } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { Animacao } from '../../core/tools/animacao';
import { PdfService } from '../../core/tools/pdf.service';

import { MotivoNaoVenda } from '../../core/models/motivos-nao-venda/motivo-nao-venda';
import { CallCenterLigacaoAnalitica } from '../../core/models/call-center/call-center-ligacao-analitica';
import { CallCenterTipo } from '../../core/models/call-center/call-center-tipo';
import { Visita } from '../../core/models/visitas/visita';
import { WhatsAppOfficialAtendimento } from '../../core/models/whatsapp-oficial/whatsapp-oficial-atendimento';
import { WhatsAppOfficialClienteVinculo } from '../../core/models/whatsapp-oficial/whatsapp-oficial-cliente-vinculo';
import { Cliente } from '../../core/models/clientes/cliente';
import { ClienteVinculado } from '../../core/models/clientes/cliente-vinculado';
import { ClienteService } from '../../core/services/clientes/cliente.service';
import { WhatsAppOfficialConfiguracao } from '../../core/models/whatsapp-oficial/whatsapp-oficial-configuracao';
import { WhatsAppOfficialEtapa } from '../../core/models/whatsapp-oficial/whatsapp-oficial-etapa';
import { WhatsAppOfficialForwardSeller } from '../../core/models/whatsapp-oficial/whatsapp-oficial-forward-seller';
import { WhatsAppOfficialKanban } from '../../core/models/whatsapp-oficial/whatsapp-oficial-kanban';
import { WhatsAppOfficialMensagem, mesclarEstadoMensagem } from '../../core/models/whatsapp-oficial/whatsapp-oficial-mensagem';
import { WhatsAppOficialIaSugestao } from '../../core/models/whatsapp-oficial/whatsapp-oficial-ia-sugestao';
import { IaPagamentosWhatsApp } from '../../core/models/ia/ia';
import { WhatsAppTemplateMensagem, WhatsAppTemplateMensagemItem, WhatsAppTemplateOpcao, WhatsAppTemplateSeller } from '../../core/models/whatsapp-oficial/whatsapp-template-mensagem';
import { WhatsAppOfficialTemplate, WhatsAppOfficialTemplateVariable } from '../../core/models/whatsapp-oficial/whatsapp-oficial-template';
import { WhatsAppUazapiSellerConfig } from '../../core/models/whatsapp-oficial/whatsapp-uazapi-seller-config';

import { CallCenterService } from '../../core/services/call-center/call-center.service';
import { IaService } from '../../core/services/ia/ia.service';
import { VisitaService } from '../../core/services/visitas/visita.service';
import { WhatsAppOfficialService } from '../../core/services/whatsapp-oficial/whatsapp-oficial.service';
import { WhatsAppOfficialRealtimeService } from '../../core/services/whatsapp-oficial/whatsapp-oficial-realtime.service';
import { WhatsAppGruposComponent } from '../whatsapp-grupos/whatsapp-grupos.component';

declare var require: any;
declare var MicRecorder: any;

@Component({
  standalone: false,
  selector: 'app-whatsapp-oficial',
  templateUrl: './whatsapp-oficial.component.html',
  styleUrls: ['./whatsapp-oficial.component.css'],
  preserveWhitespaces: false,
  animations: [Animacao]
})

export class WhatsappOficialComponent implements OnInit, OnDestroy {
  @ViewChild(WhatsAppGruposComponent) gruposPainel: WhatsAppGruposComponent;
  @ViewChild("mensagensContainer", { static: false }) mensagensContainer: ElementRef;
  @ViewChild("documentInput", { static: false }) documentInput: ElementRef;
  @ViewChild("imageInput", { static: false }) imageInput: ElementRef;
  @ViewChild("mensagemInput", { static: false }) mensagemInput: ElementRef;

  public carregando: boolean = false;
  public carregandoMensagens: boolean = false;
  public abaAtiva: string = "conversas";
  public gruposNaoLidos = 0;
  public usaWhatsappOficial: boolean = false;
  public configuracao: WhatsAppOfficialConfiguracao = new WhatsAppOfficialConfiguracao();
  public inbox: WhatsAppOfficialAtendimento[] = [];
  public filtroInbox: string = "";
  public limiteExibicaoConversas: number = 50;
  private readonly passoCarregarMaisConversas: number = 50;
  public atendimentoSelecionado: WhatsAppOfficialAtendimento = null;
  public mensagens: WhatsAppOfficialMensagem[] = [];
  public carregandoMaisMensagens: boolean = false;
  public temMaisMensagens: boolean = false;
  public kanban: WhatsAppOfficialKanban = new WhatsAppOfficialKanban();
  public etapas: WhatsAppOfficialEtapa[] = [];
  public motivosPerda: MotivoNaoVenda[] = [];
  public textoMensagem: string = "";
  public mensagemRespondendoA: WhatsAppOfficialMensagem = null;
  public mensagemDestacadaId: number = null;
  public mensagemMenuAbertaId: number = null;
  public contatoCallCenterCliente: string = null;
  public contatoCallCenterClientIdCarregada: number = null;
  public editandoContatoCallCenter: boolean = false;
  public textoContatoCallCenterEdicao: string = "";
  public salvandoContatoCallCenter: boolean = false;
  public observacaoGeralCliente: string = null;
  public observacaoGeralClientIdCarregada: number = null;
  public editandoObservacaoGeral: boolean = false;
  public textoObservacaoGeralEdicao: string = "";
  public salvandoObservacaoGeral: boolean = false;
  public etapaDestinoId: number = null;
  public motivoPerdaId: number = null;
  public complementoPerda: string = "";
  public exibirFormularioPerda: boolean = false;
  public refreshTimer: any = null;
  public syncTimer: any = null;
  public uazapiStatusTimer: any = null;
  public atendimentoArrastandoId: number = null;
  public tempoRealConectado: boolean = false;
  public exibirPopupAnalise: boolean = false;
  public urlAnaliseCliente: SafeResourceUrl = null;
  public pedidoRetornoAtendimentoId: number = null;
  public pedidoRetornoNumero: number = null;
  public pedidoRetornoVendedorId: number = null;
  public enviandoPdfPedido: boolean = false;
  public pedidoRetornoMensagem: string = "";
  public exibirPopupVincularCliente: boolean = false;
  public exibirPopupVendedorCliente: boolean = false;
  public filtroClienteVinculo: string = "";
  public clientesVinculo: WhatsAppOfficialClienteVinculo[] = [];
  public clienteVinculoSelecionado: WhatsAppOfficialClienteVinculo = null;
  public buscandoClientesVinculo: boolean = false;
  public vinculandoCliente: boolean = false;
  public desvinculandoCliente: boolean = false;
  public exibirFormNovoCliente: boolean = false;
  public novoCliente: Cliente = null;
  public cadastrandoCliente: boolean = false;
  public exibirPopupClientesVinculados: boolean = false;
  public clientesVinculados: ClienteVinculado[] = [];
  public exibirPopupSelecionarClienteAcao: boolean = false;
  private acaoPendenteSelecaoCliente: string = null;
  public clienteSelecionadoParaAcaoId: number = null;
  private clienteSelecionadoParaAcaoErp: string = null;
  public clienteSelecionadoParaAcaoNome: string = null;
  public carregandoClientesVinculados: boolean = false;
  public filtroClienteParaVincular: string = "";
  public clientesParaVincular: WhatsAppOfficialClienteVinculo[] = [];
  public buscandoClientesParaVincular: boolean = false;
  public vinculandoClienteAdicional: boolean = false;
  public desvinculandoClienteId: number = null;
  public exibirPopupNovoAtendimento: boolean = false;
  public modoNovoAtendimento: string = "cliente";
  public filtroClienteNovoAtendimento: string = "";
  public clientesNovoAtendimento: WhatsAppOfficialClienteVinculo[] = [];
  public clienteNovoAtendimentoSelecionado: WhatsAppOfficialClienteVinculo = null;
  public buscandoClientesNovoAtendimento: boolean = false;
  public abrindoNovoAtendimento: boolean = false;
  public novoAtendimentoTelefoneDdd: string = "";
  public novoAtendimentoTelefone: string = "";
  public novoAtendimentoNumeroLivre: string = "";
  public exibirPopupEncaminhar: boolean = false;
  public vendedoresEncaminhamento: WhatsAppOfficialForwardSeller[] = [];
  public vendedorEncaminhamentoId: number = null;
  public carregandoVendedoresEncaminhamento: boolean = false;
  public encaminhandoAtendimento: boolean = false;
  public exibirPopupTemplate: boolean = false;
  public carregandoTemplatesMarketing: boolean = false;
  public enviandoTemplateMarketing: boolean = false;
  public templatesMarketing: WhatsAppOfficialTemplate[] = [];
  public templateSelecionadoNome: string = "";
  public templateSelecionado: WhatsAppOfficialTemplate = null;
  public templateValores: any = {};
  public abrindoLigacao: boolean = false;
  public statusUazapi: WhatsAppUazapiSellerConfig = new WhatsAppUazapiSellerConfig();
  public carregandoStatusUazapi: boolean = false;
  public atualizandoQrCodeUazapi: boolean = false;
  public exibirPopupUazapiStatus: boolean = false;
  public mensagemErroUazapi: string = "";
  public mostrarMenuAnexo: boolean = false;
  public mostrarSeletorEmoji: boolean = false;
  public filtroEmoji: string = "";
  public categoriaEmojiSelecionada: string = "smileys";
  public emojisRecentes: string[] = [];
  public categoriasEmoji: any[] = [
    { id: "recentes", label: "Recentes", icon: "clock-o" },
    { id: "smileys", label: "Smileys e pessoas", icon: "smile-o" },
    { id: "natureza", label: "Natureza", icon: "leaf" },
    { id: "comida", label: "Comidas e bebidas", icon: "coffee" },
    { id: "atividades", label: "Atividades", icon: "futbol-o" },
    { id: "objetos", label: "Objetos", icon: "lightbulb-o" },
    { id: "simbolos", label: "Simbolos", icon: "heart-o" }
  ];
  public emojisPorCategoria: any = {
    recentes: [],
    smileys: ["😀","😃","😄","😁","😆","🥹","😅","😂","🤣","🥲","😊","🙂","😉","😌","😍","🥰","😘","😗","😙","😚","😋","😛","😝","😜","🤪","🤨","🧐","🤓","😎","🥸","🤩","🥳","😏","😒","😞","😔","😟","😕","🙁","☹️","😣","😖","😫","😩","🥺","😢","😭","😤","😠","😡","🤬","😳","🥵","🥶","😱","😨","😰","😥","😓","🤗","🫶","🙏","👍","👎","👏","🙌","👀"],
    natureza: ["🌱","🌿","🍀","🌵","🌴","🌳","🌸","🌼","🌻","🌺","🌹","🪻","🌷","🌞","🌈","⭐","🌙","🔥","🌊","☔","❄️","🐶","🐱","🐭","🐹","🐰","🦊","🐻","🐼","🐨","🦁","🐯","🐸","🐵","🐧","🐦","🦋","🐢","🐟"],
    comida: ["☕","🫖","🥤","🧃","🍵","🍺","🍻","🍷","🥂","🍾","🍕","🍔","🍟","🌭","🥪","🌮","🌯","🍝","🍜","🍣","🍱","🍛","🍚","🥗","🍿","🍩","🍪","🎂","🍰","🧁","🍫","🍎","🍉","🍇","🍓","🍌"],
    atividades: ["⚽","🏀","🏈","⚾","🎾","🏐","🏉","🎱","🏓","🥊","🥋","🎮","🕹️","🎲","🧩","🎯","🎳","🎸","🎹","🥁","🎤","🎧","🎬","🎨","🧵","🪡","✈️","🚗","🏖️","🏕️","🛫","🛬"],
    objetos: ["💡","📱","💻","⌚","📷","🎥","📞","🖨️","⌨️","🖱️","💾","📀","🔋","🔌","💸","💰","💳","🧾","📦","🎁","🛒","🔒","🔑","🧰","🪛","🔨","⚙️","🧲","🪑","🛏️"],
    simbolos: ["❤️","🧡","💛","💚","💙","💜","🖤","🤍","🤎","💔","❣️","💕","💞","💓","💗","💖","💘","💝","✅","✔️","☑️","❌","⚠️","🚫","❗","❓","💯","✨","⭐","🔔","🎵","🎶"]
  };
  public baixandoDocumento: any = {};
  public baixandoImagem: any = {};
  public baixandoAudio: any = {};
  public baixandoVideo: any = {};
  public exibirPreviewImagemEnvio: boolean = false;
  public imagemPreviewArquivo: File = null;
  public imagemPreviewUrl: string = "";
  public imagemPreviewLegenda: string = "";
  public gravandoAudio: boolean = false;
  public processandoAudio: boolean = false;
  public segundosGravacaoAudio: number = 0;
  public audioTocando: any = {};
  public audioProgressoSegundos: any = {};
  public audioDuracaoSegundos: any = {};
  public audioWaveformBars: number[] = [10, 16, 22, 14, 18, 26, 34, 24, 18, 30, 38, 42, 28, 22, 36, 44, 40, 32, 24, 30, 36, 42, 34, 28, 22, 18, 14, 20];
  public iaSugestaoPendente: WhatsAppOficialIaSugestao = null;
  public iaEditandoSugestao: boolean = false;
  public iaTextoEdicao: string = "";
  public iaProcessandoAcao: boolean = false;
  public iaGerandoSugestao: boolean = false;
  public iaModoGlobal: string = "DESATIVADO";
  public iaAgenteHabilitado: boolean = false;
  public readonly podeVerPagamentos: boolean = (localStorage.getItem("is_master") == "true") || (localStorage.getItem("is_diretor") == "true");
  public iaPagamentosConfigurado: boolean = false;
  public exibirPopupPagamentos: boolean = false;
  public carregandoPagamentos: boolean = false;
  public iaPagamentos: IaPagamentosWhatsApp = new IaPagamentosWhatsApp();
  public iaAtualizandoModo: boolean = false;

  /* Templates de Mensagem - gestao (is_master/is_diretor) */
  public readonly podeGerenciarTemplatesMensagem: boolean = (localStorage.getItem("is_master") == "true") || (localStorage.getItem("is_diretor") == "true");
  public exibirPopupTemplatesGestao: boolean = false;
  public carregandoTemplatesGestao: boolean = false;
  public templatesGestao: WhatsAppTemplateMensagem[] = [];
  public sellersAptosTemplate: WhatsAppTemplateSeller[] = [];
  public templateEdicao: WhatsAppTemplateMensagem = null;
  public salvandoTemplate: boolean = false;
  public enviandoArquivoTemplateItem: number = -1;

  /* Templates de Mensagem - selecionar e enviar (qualquer vendedor com acesso liberado) */
  public exibirPopupTemplatesSelecionar: boolean = false;
  public carregandoTemplatesDisponiveis: boolean = false;
  public templatesDisponiveis: WhatsAppTemplateMensagem[] = [];
  public templateSelecionadoPreview: WhatsAppTemplateMensagem = null;
  public enviandoTemplateSelecionado: boolean = false;
  public iaReativandoHandoff: boolean = false;
  public iaDispensandoHandoff: boolean = false;
  public iaGerandoConversas: any = {};
  private iaGerandoTimeouts: any = {};
  private ultimaAtualizacaoTempoReal: Date = null;
  private guidclientenapis: string = localStorage.getItem("guidclientenapis");
  private realtimeSubscriptions: Subscription[] = [];
  private routeSubscription: Subscription = null;
  private atendimentoRetornoId: number = null;
  private recorderAudio: any = null;
  private recorderAudioModule: any = null;
  private timerGravacaoAudio: any = null;
  private audioPlayers: any = {};
  private readonly quantidadeMensagensPagina = 20;
  private versaoMensagens = 0;

  public readonly sellerId: number = parseInt(localStorage.getItem("id"), 10);
  private readonly isMasterSeller: boolean = (localStorage.getItem("is_master_seller") == "true");
  private readonly isMaster: boolean = (localStorage.getItem("is_master") == "true");
  private readonly isManager: boolean = (localStorage.getItem("is_manager") == "true");
  private readonly isDiretor: boolean = (localStorage.getItem("is_diretor") == "true");
  private readonly isFinanceiro: boolean = (localStorage.getItem("is_financeiro") == "true");
  public readonly podeGerenciar: boolean = this.isMasterSeller || this.isMaster || this.isManager || this.isDiretor || this.isFinanceiro;
  public readonly podeVerVendedorResponsavel: boolean = this.isMaster || this.isDiretor;

  constructor(
    private modalService: NgbModal,
    private toastr: ToastrService,
    private pdfService: PdfService,
    private callCenterService: CallCenterService,
    private iaService: IaService,
    private visitaService: VisitaService,
    private whatsAppOfficialService: WhatsAppOfficialService,
    private whatsAppOfficialRealtimeService: WhatsAppOfficialRealtimeService,
    private clienteService: ClienteService,
    private ngZone: NgZone,
    private sanitizer: DomSanitizer,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  public filtroStatus: string = "TODAS";
  public filtroEtapaId: number = null;
  public filtroSellerId: number = null;
  public exibirPainelEtapa: boolean = false;

  public get inboxFiltrado(): WhatsAppOfficialAtendimento[] {
    return this.aplicarFiltroStatus(this.aplicarFiltroEtapa(this.aplicarFiltroVendedor(this.aplicarFiltroTexto(this.inbox || []))));
  }

  public get conversasExibidas(): WhatsAppOfficialAtendimento[] {
    return this.inboxFiltrado.slice(0, this.limiteExibicaoConversas);
  }

  public get temMaisConversasParaCarregar(): boolean {
    return this.limiteExibicaoConversas < this.inboxFiltrado.length;
  }

  public onFiltroInboxChange(valor: string) {
    this.filtroInbox = valor;
    this.limiteExibicaoConversas = this.passoCarregarMaisConversas;
  }

  public onScrollConversas(event: Event) {
    let elemento = event.target as HTMLElement;

    if (elemento == null || !this.temMaisConversasParaCarregar) {
      return;
    }

    let distanciaAteFim = elemento.scrollHeight - elemento.scrollTop - elemento.clientHeight;

    if (distanciaAteFim < 150) {
      this.carregarMaisConversas();
    }
  }

  public carregarMaisConversas() {
    this.limiteExibicaoConversas = Math.min(this.limiteExibicaoConversas + this.passoCarregarMaisConversas, this.inboxFiltrado.length);
  }

  private aplicarFiltroTexto(lista: WhatsAppOfficialAtendimento[]): WhatsAppOfficialAtendimento[] {
    let filtroTexto = this.normalizarTextoBusca(this.filtroInbox);
    let filtroNumero = this.normalizarNumeroBusca(this.filtroInbox);

    if (filtroTexto == "" && filtroNumero == "") {
      return lista;
    }

    return lista.filter(atendimento => {
      let nomeExibicao = this.normalizarTextoBusca(this.getNomeExibicaoAtendimento(atendimento));
      let nomeCliente = this.normalizarTextoBusca(atendimento.client_name_snapshot);
      let nomeContato = this.normalizarTextoBusca(atendimento.contato_nome);
      let contatoCliente = this.normalizarTextoBusca(atendimento.contato_callcenter);
      let codigoErp = this.normalizarTextoBusca(atendimento.client_codigo_erp_snapshot);
      let telefone = this.normalizarNumeroBusca(atendimento.telefone);
      let telefoneNormalizado = this.normalizarNumeroBusca(atendimento.telefone_normalizado);

      return (filtroTexto != "" && (
        nomeExibicao.indexOf(filtroTexto) >= 0 ||
        nomeCliente.indexOf(filtroTexto) >= 0 ||
        nomeContato.indexOf(filtroTexto) >= 0 ||
        contatoCliente.indexOf(filtroTexto) >= 0 ||
        codigoErp.indexOf(filtroTexto) >= 0
      )) ||
      (filtroNumero != "" && (
        telefone.indexOf(filtroNumero) >= 0 ||
        telefoneNormalizado.indexOf(filtroNumero) >= 0
      ));
    });
  }

  private aplicarFiltroStatus(lista: WhatsAppOfficialAtendimento[]): WhatsAppOfficialAtendimento[] {
    switch (this.filtroStatus) {
      case "NAO_LIDAS":
        return lista.filter(atendimento => atendimento.qtde_mensagens_nao_lidas > 0);
      case "AGUARDANDO_APROVACAO":
        return lista.filter(atendimento => atendimento.ia_sugestao_pendente);
      case "PRECISA_HUMANO":
        return lista.filter(atendimento => atendimento.ia_dt_handoff != null);
      default:
        return lista;
    }
  }

  public selecionarFiltroStatus(status: string) {
    this.filtroStatus = status;
    this.limiteExibicaoConversas = this.passoCarregarMaisConversas;
  }

  private aplicarFiltroEtapa(lista: WhatsAppOfficialAtendimento[]): WhatsAppOfficialAtendimento[] {
    if (this.filtroEtapaId == null) {
      return lista;
    }

    return lista.filter(atendimento => atendimento.whatsapp_oficial_etapa_id == this.filtroEtapaId);
  }

  private aplicarFiltroVendedor(lista: WhatsAppOfficialAtendimento[]): WhatsAppOfficialAtendimento[] {
    if (!this.podeFiltrarConversasPorVendedor || this.filtroSellerId == null) {
      return lista;
    }

    return lista.filter(atendimento => this.getSellerIdFiltroAtendimento(atendimento) == this.filtroSellerId);
  }

  public get podeFiltrarConversasPorVendedor(): boolean {
    return this.isMaster || this.isDiretor;
  }

  public alternarPainelEtapa(event?: Event) {
    if (event != null) {
      event.preventDefault();
      event.stopPropagation();
    }

    this.exibirPainelEtapa = !this.exibirPainelEtapa;
  }

  public selecionarFiltroEtapa(etapaId: number, event?: Event) {
    if (event != null) {
      event.preventDefault();
      event.stopPropagation();
    }

    this.filtroEtapaId = etapaId;
    this.exibirPainelEtapa = false;
    this.limiteExibicaoConversas = this.passoCarregarMaisConversas;
  }

  public selecionarFiltroVendedor(sellerId: number, event?: Event) {
    if (event != null) {
      event.preventDefault();
      event.stopPropagation();
    }

    this.filtroSellerId = sellerId;
    this.exibirPainelEtapa = false;
    this.limiteExibicaoConversas = this.passoCarregarMaisConversas;
  }

  public getNomeFiltroEtapaAtual(): string {
    let filtros: string[] = [];

    if (this.filtroEtapaId != null) {
      let etapa = this.getEtapaById(this.filtroEtapaId);
      filtros.push("Etapa: " + (etapa != null ? etapa.nome : ""));
    }

    if (this.filtroSellerId != null) {
      let vendedor = this.getVendedorFiltroById(this.filtroSellerId);
      filtros.push("Vendedor: " + (vendedor != null ? vendedor.nome : ""));
    }

    return filtros.length > 0 ? filtros.join(" | ") : "Filtros";
  }

  public getContagemPorEtapa(etapaId: number): number {
    return (this.inbox || []).filter(atendimento => atendimento.whatsapp_oficial_etapa_id == etapaId).length;
  }

  public get vendedoresFiltroConversas(): any[] {
    let vendedores = new Map<number, any>();

    (this.inbox || []).forEach(atendimento => {
      let sellerId = this.getSellerIdFiltroAtendimento(atendimento);
      let nome = ((atendimento.seller_nome_atual || "") + "").trim();

      if (sellerId == null || nome == "") {
        return;
      }

      if (!vendedores.has(sellerId)) {
        vendedores.set(sellerId, { id: sellerId, nome: nome, total: 0 });
      }

      vendedores.get(sellerId).total++;
    });

    return Array.from(vendedores.values()).sort((a, b) => a.nome.localeCompare(b.nome));
  }

  public trackByVendedorFiltro(indice: number, vendedor: { id: number }): number {
    // O getter recria os objetos; manter o elemento evita perder o clique entre eventos.
    return vendedor.id;
  }

  public getContagemTodosVendedoresFiltro(): number {
    return (this.inbox || []).filter(atendimento => this.getSellerIdFiltroAtendimento(atendimento) != null).length;
  }

  private getVendedorFiltroById(sellerId: number): any {
    return this.vendedoresFiltroConversas.find(vendedor => vendedor.id == sellerId) || null;
  }

  private getSellerIdFiltroAtendimento(atendimento: WhatsAppOfficialAtendimento): number {
    if (atendimento == null) {
      return null;
    }

    return atendimento.seller_id_atual || atendimento.seller_id_sugerido || atendimento.seller_id_captura || null;
  }

  @HostListener("document:click")
  public fecharPainelEtapa() {
    this.exibirPainelEtapa = false;
  }

  /* Contadores fixos (sobre o inbox completo) para os chips nao mudarem de numero ao trocar de aba */
  public get qtdeNaoLidasTotal(): number {
    return (this.inbox || []).filter(atendimento => atendimento.qtde_mensagens_nao_lidas > 0).length;
  }

  public get qtdeAguardandoAprovacaoTotal(): number {
    return (this.inbox || []).filter(atendimento => atendimento.ia_sugestao_pendente).length;
  }

  public get qtdePrecisaHumanoTotal(): number {
    return (this.inbox || []).filter(atendimento => atendimento.ia_dt_handoff != null).length;
  }

  ngOnInit() {
    const usaWhatsTipo = this.getUsaWhatsTipoSeller();
    this.usaWhatsappOficial = usaWhatsTipo == "OFICIAL" || usaWhatsTipo == "UAZAPI";

    if (!this.usaWhatsappOficial) {
      return;
    }

    this.carregarEmojisRecentes();
    this.processarParametrosRota();
    this.carregarDadosIniciais();
    this.iniciarAtualizacaoAutomatica();
    this.iniciarSincronizacaoSilenciosa();
    this.conectarTempoReal();
    this.carregarStatusUazapi(false);
    this.carregarConfiguracaoIa();
  }

  private carregarConfiguracaoIa() {
    this.iaService.getConfiguration().subscribe(configuracao => {
      if (configuracao != null) {
        this.iaAgenteHabilitado = configuracao.ia_ativa && configuracao.permitir_whatsapp && configuracao.is_configurada;
        this.iaModoGlobal = this.iaAgenteHabilitado ? (configuracao.whatsapp_modo || "DESATIVADO") : "DESATIVADO";
      }
    });

    if (this.podeVerPagamentos) {
      this.iaService.getPagamentosWhatsApp().subscribe(pagamentos => {
        this.iaPagamentosConfigurado = pagamentos != null && pagamentos.configurado;
      });
    }
  }

  /* Historico de pagamentos gerados pela IA (master/diretor) */

  public abrirPopupPagamentos() {
    this.exibirPopupPagamentos = true;
    this.carregandoPagamentos = true;

    this.iaService.getPagamentosWhatsApp().subscribe(pagamentos => {
      this.carregandoPagamentos = false;
      this.iaPagamentos = pagamentos || new IaPagamentosWhatsApp();
    }, () => this.carregandoPagamentos = false);
  }

  public fecharPopupPagamentos() {
    this.exibirPopupPagamentos = false;
  }

  public getTotalPagamentosPagos(): number {
    return (this.iaPagamentos.cobrancas || [])
      .filter(cobranca => cobranca.status_interno == "PAGO")
      .reduce((soma, cobranca) => soma + (cobranca.valor || 0), 0);
  }

  public getQtdePagamentosPagos(): number {
    return (this.iaPagamentos.cobrancas || []).filter(cobranca => cobranca.status_interno == "PAGO").length;
  }

  public getQtdePagamentosAguardando(): number {
    return (this.iaPagamentos.cobrancas || []).filter(cobranca => cobranca.status_interno == "AGUARDANDO_PAGAMENTO" || cobranca.status_interno == null || cobranca.status_interno == "").length;
  }

  public getRotuloStatusPagamento(cobranca: any): string {
    switch (cobranca.status_interno) {
      case "PAGO": return "Pago";
      case "RECUSADO": return "Recusado";
      default: return "Aguardando";
    }
  }

  public getClasseStatusPagamento(cobranca: any): string {
    switch (cobranca.status_interno) {
      case "PAGO": return "whatsapp_pg_badge_pago";
      case "RECUSADO": return "whatsapp_pg_badge_recusado";
      default: return "whatsapp_pg_badge_aguardando";
    }
  }

  public getMetodoPagamento(cobranca: any): string {
    if (cobranca.payment_method_id == null || cobranca.payment_method_id == "") {
      return "—";
    }

    let metodo = cobranca.payment_method_id == "pix" ? "Pix" : cobranca.payment_method_id;

    if (cobranca.installments != null && cobranca.installments > 1) {
      metodo += " " + cobranca.installments + "x";
    }

    return metodo;
  }

  /* Templates de Mensagem - gestao (is_master/is_diretor) */

  public abrirPopupTemplatesGestao() {
    this.exibirPopupTemplatesGestao = true;
    this.carregandoTemplatesGestao = true;
    this.templateEdicao = null;

    this.whatsAppOfficialService.getSellersAptosTemplateMensagem().subscribe(sellers => {
      this.sellersAptosTemplate = sellers || [];
    });

    this.whatsAppOfficialService.getTemplatesMensagemGestao().subscribe(templates => {
      this.carregandoTemplatesGestao = false;
      this.templatesGestao = templates || [];
    }, () => this.carregandoTemplatesGestao = false);
  }

  public fecharPopupTemplatesGestao() {
    this.exibirPopupTemplatesGestao = false;
    this.templateEdicao = null;
  }

  public novoTemplateMensagem() {
    let template = new WhatsAppTemplateMensagem();
    template.itens = [];
    template.seller_ids = [];
    this.templateEdicao = template;
  }

  public editarTemplateMensagem(template: WhatsAppTemplateMensagem) {
    /* Clona para nao alterar a lista em tela antes de salvar */
    this.templateEdicao = JSON.parse(JSON.stringify(template));
  }

  public cancelarEdicaoTemplate() {
    this.templateEdicao = null;
  }

  public adicionarItemTemplate(tipo: string) {
    if (this.templateEdicao == null) return;

    let item = new WhatsAppTemplateMensagemItem();
    item.tipo = tipo;
    item.ordem = (this.templateEdicao.itens.length + 1) * 10;

    if (tipo == "LISTA_OPCOES") {
      item.opcoes = [new WhatsAppTemplateOpcao()];
    }

    this.templateEdicao.itens.push(item);
  }

  public removerItemTemplate(index: number) {
    if (this.templateEdicao == null) return;
    this.templateEdicao.itens.splice(index, 1);
  }

  public moverItemTemplate(index: number, direcao: number) {
    if (this.templateEdicao == null) return;

    let novoIndex = index + direcao;

    if (novoIndex < 0 || novoIndex >= this.templateEdicao.itens.length) return;

    let itens = this.templateEdicao.itens;
    let temp = itens[index];
    itens[index] = itens[novoIndex];
    itens[novoIndex] = temp;
    itens.forEach((item, i) => item.ordem = (i + 1) * 10);
  }

  public adicionarOpcaoItem(item: WhatsAppTemplateMensagemItem) {
    item.opcoes.push(new WhatsAppTemplateOpcao());
  }

  public removerOpcaoItem(item: WhatsAppTemplateMensagemItem, index: number) {
    item.opcoes.splice(index, 1);
  }

  public selecionarArquivoItemTemplate(event: any, item: WhatsAppTemplateMensagemItem, index: number) {
    if (event == null || event.target == null || event.target.files == null || event.target.files.length == 0) return;

    let arquivo: File = event.target.files[0];
    event.target.value = "";

    if (arquivo.size > 20 * 1024 * 1024) {
      this.toastr.warning("", "O arquivo excede o limite de 20 MB.");
      return;
    }

    this.enviandoArquivoTemplateItem = index;
    this.whatsAppOfficialService.uploadArquivoTemplateMensagem(arquivo).subscribe(resultado => {
      this.enviandoArquivoTemplateItem = -1;

      if (resultado != null) {
        item.arquivo_url = resultado.arquivo_url;
        item.arquivo_nome = resultado.arquivo_nome;
        item.arquivo_mime = resultado.arquivo_mime;
      }
    }, () => this.enviandoArquivoTemplateItem = -1);
  }

  public alternarSellerTemplate(sellerId: number) {
    if (this.templateEdicao == null) return;

    let index = this.templateEdicao.seller_ids.indexOf(sellerId);

    if (index >= 0) {
      this.templateEdicao.seller_ids.splice(index, 1);
    } else {
      this.templateEdicao.seller_ids.push(sellerId);
    }
  }

  public isSellerSelecionadoTemplate(sellerId: number): boolean {
    return this.templateEdicao != null && this.templateEdicao.seller_ids.indexOf(sellerId) >= 0;
  }

  public salvarTemplateMensagem() {
    if (this.templateEdicao == null || this.salvandoTemplate) return;

    if (!this.templateEdicao.nome || this.templateEdicao.nome.trim() == "") {
      this.toastr.warning("", "Informe o nome do template.");
      return;
    }

    if (this.templateEdicao.itens.length == 0) {
      this.toastr.warning("", "Adicione ao menos um bloco de conteúdo.");
      return;
    }

    this.salvandoTemplate = true;
    this.whatsAppOfficialService.salvarTemplateMensagem(this.templateEdicao).subscribe(id => {
      this.salvandoTemplate = false;

      if (id > 0) {
        this.toastr.success("", "Template salvo com sucesso.");
        this.templateEdicao = null;
        this.abrirPopupTemplatesGestao();
      }
    }, () => this.salvandoTemplate = false);
  }

  public alternarAtivoTemplateMensagem(template: WhatsAppTemplateMensagem) {
    this.whatsAppOfficialService.alternarAtivoTemplateMensagem(template.id, !template.ativo).subscribe(sucesso => {
      if (sucesso) {
        template.ativo = !template.ativo;
      }
    });
  }

  /* Templates de Mensagem - selecionar e enviar (qualquer vendedor com acesso liberado) */

  public podeUsarTemplateMensagem(): boolean {
    return this.podeInteragirAtendimento() && this.isConversaUazapi();
  }

  public abrirPopupTemplatesSelecionar() {
    if (this.atendimentoSelecionado == null) return;

    this.exibirPopupTemplatesSelecionar = true;
    this.carregandoTemplatesDisponiveis = true;
    this.templateSelecionadoPreview = null;

    this.whatsAppOfficialService.getTemplatesMensagemDisponiveis().subscribe(templates => {
      this.carregandoTemplatesDisponiveis = false;
      this.templatesDisponiveis = templates || [];
    }, () => this.carregandoTemplatesDisponiveis = false);
  }

  public fecharPopupTemplatesSelecionar() {
    this.exibirPopupTemplatesSelecionar = false;
    this.templateSelecionadoPreview = null;
  }

  public previewTemplateMensagem(template: WhatsAppTemplateMensagem) {
    this.templateSelecionadoPreview = template;
  }

  public enviarTemplateSelecionado() {
    if (this.templateSelecionadoPreview == null || this.atendimentoSelecionado == null || this.enviandoTemplateSelecionado) return;

    this.enviandoTemplateSelecionado = true;
    this.whatsAppOfficialService.enviarTemplateMensagem(this.atendimentoSelecionado.id, this.templateSelecionadoPreview.id).subscribe(sucesso => {
      this.enviandoTemplateSelecionado = false;

      if (sucesso) {
        this.toastr.success("", "Template enviado.");
        this.fecharPopupTemplatesSelecionar();
      }
    }, () => this.enviandoTemplateSelecionado = false);
  }

  ngOnDestroy() {
    if (this.refreshTimer != null) {
      clearInterval(this.refreshTimer);
    }

    if (this.syncTimer != null) {
      clearInterval(this.syncTimer);
    }

    this.desconectarTempoReal();

    if (this.routeSubscription != null) {
      this.routeSubscription.unsubscribe();
    }

    this.encerrarGravacaoAudioLocal();
    this.encerrarPlayersAudio();
    this.pararMonitoramentoStatusUazapi();
  }

  public carregarDadosIniciais() {
    this.carregando = true;

    this.whatsAppOfficialService.getConfiguration().subscribe(
      configuracao => this.configuracao = configuracao,
      error => { console.log("Erro: " + error) }
    );

    this.whatsAppOfficialService.getStages().subscribe(
      etapas => this.etapas = etapas,
      error => { console.log("Erro: " + error) }
    );

    this.whatsAppOfficialService.getLossReasons().subscribe(
      motivos => this.motivosPerda = motivos,
      error => { console.log("Erro: " + error) }
    );

    this.atualizarListas(true);
  }

  public iniciarAtualizacaoAutomatica() {
    this.refreshTimer = setInterval(() => {
      this.atualizarListas(false);
    }, 60000);
  }

  public iniciarSincronizacaoSilenciosa() {
    this.syncTimer = setInterval(() => {
      if (this.tempoRealConectado && !this.deveUsarPollingDeContingencia()) {
        return;
      }

      this.atualizarInboxKanbanTempoReal();

      if (this.atendimentoSelecionado != null) {
        this.carregarMensagens(this.atendimentoSelecionado.id, false, true, true);
      }
    }, 60000);
  }

  public atualizarListas(exibirCarregando: boolean) {
    let deveExibirLoader = exibirCarregando &&
      this.inbox.length == 0 &&
      (this.kanban == null || this.kanban.etapas == null || this.kanban.etapas.length == 0);

    if (deveExibirLoader) {
      this.carregando = true;
    }

    this.whatsAppOfficialService.getInbox().subscribe(
      inbox => {
        this.inbox = this.ordenarInboxLocal((inbox || []).map(atendimento => this.normalizarJanelaAtendimento(atendimento)));
        this.abrirAtendimentoRetornoPendente();

        if (this.atendimentoSelecionado != null) {
          let atendimentoAtualizado = this.inbox.find(x => x.id == this.atendimentoSelecionado.id);

          if (atendimentoAtualizado != null) {
            this.atendimentoSelecionado = atendimentoAtualizado;
          }
        }
      },
      error => { console.log("Erro: " + error) }
    );

    this.whatsAppOfficialService.getKanban().subscribe(
      kanban => this.kanban = this.normalizarJanelaKanban(kanban),
      error => { console.log("Erro: " + error) },
      () => {
        if (deveExibirLoader) {
          this.carregando = false;
        }
      }
    );

    if (this.atendimentoSelecionado != null) {
      this.carregarMensagens(this.atendimentoSelecionado.id);
    }
  }

  public selecionarAba(aba: string) {
    this.abaAtiva = aba;
  }

  public selecionarAtendimento(atendimento: WhatsAppOfficialAtendimento) {
    this.atendimentoSelecionado = atendimento;
    this.cancelarResposta();
    this.resetarPaginacaoMensagens();
    this.fecharAnaliseCliente();
    this.fecharPopupVincularCliente();
    this.fecharPopupNovoAtendimento();
    this.fecharPopupVendedorCliente();
    this.fecharPopupEncaminhar();
    this.fecharPopupTemplateMarketing();
    this.etapaDestinoId = atendimento != null ? atendimento.whatsapp_oficial_etapa_id : null;
    this.exibirFormularioPerda = false;
    this.motivoPerdaId = atendimento != null ? atendimento.no_order_done_reason_id : null;
    this.complementoPerda = atendimento != null ? atendimento.motivo_perda_complemento : "";

    this.limparEstadoIaSugestao();

    this.cancelarEdicaoObservacaoGeral();
    this.observacaoGeralCliente = null;
    this.observacaoGeralClientIdCarregada = null;
    this.cancelarEdicaoContatoCallCenter();
    this.contatoCallCenterCliente = null;
    this.contatoCallCenterClientIdCarregada = null;
    this.clientesVinculados = [];

    if (atendimento != null) {
      this.marcarAtendimentoComoLido(atendimento.id);
      this.carregarMensagens(atendimento.id);
      this.carregarIaSugestaoPendente(atendimento.id);
      this.sincronizarAtendimentoSelecionado(atendimento.id);
      this.carregarObservacaoGeralCliente(atendimento.client_id);
      this.carregarContatoCallCenterCliente(atendimento.client_id);
      this.carregarClientesVinculados();
    }
  }

  public carregarContatoCallCenterCliente(clientId: number) {
    if (clientId == null) {
      this.contatoCallCenterCliente = null;
      this.contatoCallCenterClientIdCarregada = null;
      return;
    }

    this.clienteService.getContatoCallCenterById(clientId, false).subscribe(contato => {
      this.contatoCallCenterCliente = contato;
      this.contatoCallCenterClientIdCarregada = clientId;
    });
  }

  public iniciarEdicaoContatoCallCenter() {
    this.textoContatoCallCenterEdicao = this.contatoCallCenterCliente || "";
    this.editandoContatoCallCenter = true;

    setTimeout(() => {
      let input = document.getElementById("whatsapp_contato_callcenter_input") as HTMLInputElement;

      if (input != null) {
        input.focus();
        input.select();
      }
    });
  }

  public cancelarEdicaoContatoCallCenter() {
    this.editandoContatoCallCenter = false;
    this.textoContatoCallCenterEdicao = "";
  }

  public salvarContatoCallCenter() {
    if (this.atendimentoSelecionado == null || this.atendimentoSelecionado.client_id == null) {
      return;
    }

    let clientId = this.atendimentoSelecionado.client_id;
    let texto = (this.textoContatoCallCenterEdicao || "").trim();

    this.salvandoContatoCallCenter = true;

    this.clienteService.updateContatoCallCenterById(clientId, texto).subscribe(sucesso => {
      this.salvandoContatoCallCenter = false;

      if (sucesso) {
        this.contatoCallCenterCliente = texto == "" ? null : texto;
        this.atualizarContatoBuscaLocal(clientId, this.contatoCallCenterCliente);
        this.contatoCallCenterClientIdCarregada = clientId;
        this.editandoContatoCallCenter = false;
      }
    });
  }

  public removerContatoCallCenter(event?: Event) {
    if (event != null) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (this.atendimentoSelecionado == null || this.atendimentoSelecionado.client_id == null) {
      return;
    }

    let clientId = this.atendimentoSelecionado.client_id;

    this.clienteService.updateContatoCallCenterById(clientId, null).subscribe(sucesso => {
      if (sucesso) {
        this.contatoCallCenterCliente = null;
        this.atualizarContatoBuscaLocal(clientId, null);
      }
    });
  }

  private atualizarContatoBuscaLocal(clientId: number, contato: string) {
    const atualizar = (atendimento: WhatsAppOfficialAtendimento) => {
      if (atendimento?.client_id === clientId) atendimento.contato_callcenter = contato;
    };
    (this.inbox || []).forEach(atualizar);
    (this.kanban?.atendimentos || []).forEach(atualizar);
    atualizar(this.atendimentoSelecionado);
  }
  public carregarObservacaoGeralCliente(clientId: number) {
    if (clientId == null) {
      this.observacaoGeralCliente = null;
      this.observacaoGeralClientIdCarregada = null;
      return;
    }

    this.clienteService.getObservacaoGeralById(clientId, false).subscribe(observacao => {
      this.observacaoGeralCliente = observacao;
      this.observacaoGeralClientIdCarregada = clientId;
    });
  }

  public iniciarEdicaoObservacaoGeral() {
    this.textoObservacaoGeralEdicao = this.observacaoGeralCliente || "";
    this.editandoObservacaoGeral = true;

    setTimeout(() => {
      let input = document.getElementById("whatsapp_observacao_geral_input") as HTMLInputElement;

      if (input != null) {
        input.focus();
        input.select();
      }
    });
  }

  public cancelarEdicaoObservacaoGeral() {
    this.editandoObservacaoGeral = false;
    this.textoObservacaoGeralEdicao = "";
  }

  public salvarObservacaoGeral() {
    if (this.atendimentoSelecionado == null || this.atendimentoSelecionado.client_id == null) {
      return;
    }

    let clientId = this.atendimentoSelecionado.client_id;
    let texto = (this.textoObservacaoGeralEdicao || "").trim();

    this.salvandoObservacaoGeral = true;

    this.clienteService.updateObservacaoGeralById(clientId, texto).subscribe(sucesso => {
      this.salvandoObservacaoGeral = false;

      if (sucesso) {
        this.observacaoGeralCliente = texto == "" ? null : texto;
        this.observacaoGeralClientIdCarregada = clientId;
        this.editandoObservacaoGeral = false;
      }
    });
  }

  public removerObservacaoGeral(event?: Event) {
    if (event != null) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (this.atendimentoSelecionado == null || this.atendimentoSelecionado.client_id == null) {
      return;
    }

    let clientId = this.atendimentoSelecionado.client_id;

    this.clienteService.updateObservacaoGeralById(clientId, null).subscribe(sucesso => {
      if (sucesso) {
        this.observacaoGeralCliente = null;
      }
    });
  }

  public getIniciaisAtendimento(atendimento: WhatsAppOfficialAtendimento): string {
    let nome = (this.getNomeExibicaoAtendimento(atendimento) || "").trim();

    if (nome == "") {
      return "?";
    }

    let partes = nome.split(" ").filter(parte => parte != "");

    if (partes.length == 1) {
      return partes[0].substring(0, 2).toUpperCase();
    }

    return (partes[0].charAt(0) + partes[partes.length - 1].charAt(0)).toUpperCase();
  }

  /* Busca a versão atual do atendimento no servidor ao abrir a conversa (evita exibir modo IA/etapa desatualizados da lista) */
  private sincronizarAtendimentoSelecionado(conversationId: number) {
    this.whatsAppOfficialService.getConversationById(conversationId, false).subscribe(atendimento => {
      if (atendimento != null && this.atendimentoSelecionado != null && this.atendimentoSelecionado.id == conversationId) {
        this.atualizarAtendimentoLocal(this.mapearAtendimentoTempoReal(atendimento));
      }
    });
  }

  /* IA - Agente WhatsApp */

  public limparEstadoIaSugestao() {
    this.iaSugestaoPendente = null;
    this.iaEditandoSugestao = false;
    this.iaTextoEdicao = "";
    this.iaProcessandoAcao = false;
    this.iaGerandoSugestao = false;
  }

  public carregarIaSugestaoPendente(conversationId: number) {
    this.whatsAppOfficialService.getIaSugestaoPendente(conversationId).subscribe(sugestao => {
      if (this.atendimentoSelecionado != null && this.atendimentoSelecionado.id == conversationId) {
        this.iaSugestaoPendente = sugestao != null && sugestao.id > 0 ? sugestao : null;
        this.iaEditandoSugestao = false;
        this.iaTextoEdicao = "";
      }
    });
  }

  public isEtapaFluxoPedido(): boolean {
    return this.iaSugestaoPendente != null && this.iaSugestaoPendente.tipo == "WHATSAPP_FLUXO_COMBUSTIVEL";
  }

  public aprovarIaSugestao() {
    if (this.iaSugestaoPendente == null || this.iaProcessandoAcao) {
      return;
    }

    this.iaProcessandoAcao = true;

    /* Etapa do fluxo guiado de pedido: nao ha texto livre para editar, so reenviar a lista/pergunta da etapa atual */
    if (this.isEtapaFluxoPedido()) {
      this.whatsAppOfficialService.aprovarEtapaFluxoPedido(this.iaSugestaoPendente.id).subscribe(aprovado => {
        this.iaProcessandoAcao = false;

        if (aprovado) {
          this.limparEstadoIaSugestao();

          if (this.atendimentoSelecionado != null) {
            this.atualizarFlagIaSugestaoLocal(this.atendimentoSelecionado.id, false);
            this.carregarMensagens(this.atendimentoSelecionado.id);
          }
        }
      });
      return;
    }

    let textoFinal = this.iaEditandoSugestao ? this.iaTextoEdicao.trim() : null;

    if (this.iaEditandoSugestao && textoFinal == "") {
      this.toastr.warning("", "A resposta não pode ser vazia.");
      this.iaProcessandoAcao = false;
      return;
    }

    this.whatsAppOfficialService.aprovarIaSugestao(this.iaSugestaoPendente.id, textoFinal).subscribe(aprovado => {
      this.iaProcessandoAcao = false;

      if (aprovado) {
        this.limparEstadoIaSugestao();

        if (this.atendimentoSelecionado != null) {
          this.atualizarFlagIaSugestaoLocal(this.atendimentoSelecionado.id, false);
          this.carregarMensagens(this.atendimentoSelecionado.id);
        }
      }
    });
  }

  /* Atualiza o badge "IA aguardando aprovação" imediatamente, sem esperar o evento em tempo real */
  private atualizarFlagIaSugestaoLocal(conversationId: number, pendente: boolean) {
    if (this.atendimentoSelecionado != null && this.atendimentoSelecionado.id == conversationId) {
      this.atendimentoSelecionado.ia_sugestao_pendente = pendente;
    }

    (this.inbox || []).forEach(atendimento => {
      if (atendimento.id == conversationId) {
        atendimento.ia_sugestao_pendente = pendente;
      }
    });

    if (this.kanban != null && this.kanban.atendimentos != null) {
      this.kanban.atendimentos.forEach(atendimento => {
        if (atendimento.id == conversationId) {
          atendimento.ia_sugestao_pendente = pendente;
        }
      });
    }
  }

  public editarIaSugestao() {
    if (this.iaSugestaoPendente == null) {
      return;
    }

    this.iaEditandoSugestao = true;
    this.iaTextoEdicao = this.iaSugestaoPendente.resposta_texto;
  }

  public cancelarEdicaoIaSugestao() {
    this.iaEditandoSugestao = false;
    this.iaTextoEdicao = "";
  }

  public recusarIaSugestao() {
    if (this.iaSugestaoPendente == null || this.iaProcessandoAcao) {
      return;
    }

    this.iaProcessandoAcao = true;

    this.whatsAppOfficialService.recusarIaSugestao(this.iaSugestaoPendente.id).subscribe(recusado => {
      this.iaProcessandoAcao = false;

      if (recusado) {
        this.limparEstadoIaSugestao();

        if (this.atendimentoSelecionado != null) {
          this.atualizarFlagIaSugestaoLocal(this.atendimentoSelecionado.id, false);
        }
      }
    });
  }

  public gerarOutraIaSugestao() {
    if (this.atendimentoSelecionado == null || this.iaGerandoSugestao) {
      return;
    }

    this.iaGerandoSugestao = true;

    this.whatsAppOfficialService.gerarIaSugestao(this.atendimentoSelecionado.id).subscribe(sugestao => {
      this.iaGerandoSugestao = false;

      if (sugestao != null && sugestao.id > 0) {
        this.iaSugestaoPendente = sugestao;
        this.iaEditandoSugestao = false;
        this.iaTextoEdicao = "";
      }
    });
  }

  public atualizarIaModoConversa(modo: string) {
    if (!this.iaAgenteHabilitado) {
      this.toastr.warning("", "O agente esta desativado. Solicite ao Gerente para ativar essa funcao.");
      return;
    }

    if (this.atendimentoSelecionado == null || this.iaAtualizandoModo) {
      return;
    }

    /* Clicar no modo já selecionado remove o override (volta a herdar a configuração global) */
    let atendimento = this.atendimentoSelecionado;
    let modoAnterior = atendimento.ia_modo_override;
    let novoModo = modoAnterior == modo ? null : modo;

    /* Atualização otimista: reflete na hora e reverte se a gravação falhar */
    atendimento.ia_modo_override = novoModo;
    this.iaAtualizandoModo = true;

    this.whatsAppOfficialService.atualizarIaModoConversa(atendimento.id, novoModo).subscribe(atualizado => {
      this.iaAtualizandoModo = false;

      if (!atualizado) {
        atendimento.ia_modo_override = modoAnterior;
      }
    }, () => {
      this.iaAtualizandoModo = false;
      atendimento.ia_modo_override = modoAnterior;
    });
  }

  /* Indicador "IA gerando resposta" */

  public marcarIaGerando(conversationId: number) {
    this.iaGerandoConversas[conversationId] = true;

    if (this.iaGerandoTimeouts[conversationId] != null) {
      clearTimeout(this.iaGerandoTimeouts[conversationId]);
    }

    /* Proteção: se nenhum evento de conclusão chegar, limpa sozinho */
    this.iaGerandoTimeouts[conversationId] = setTimeout(() => {
      this.ngZone.run(() => this.limparIaGerando(conversationId));
    }, 90000);
  }

  public limparIaGerando(conversationId: number) {
    delete this.iaGerandoConversas[conversationId];

    if (this.iaGerandoTimeouts[conversationId] != null) {
      clearTimeout(this.iaGerandoTimeouts[conversationId]);
      delete this.iaGerandoTimeouts[conversationId];
    }
  }

  private atualizarIndicadorIaGerando(payload: any): boolean {
    if (payload == null || payload.conversation_id == null) {
      return false;
    }

    if (payload.event_type == "ia_gerando_resposta") {
      this.marcarIaGerando(payload.conversation_id);
      return true;
    }

    if (payload.event_type == "ia_geracao_falhou") {
      this.limparIaGerando(payload.conversation_id);
      return true;
    }

    if (payload.event_type == "ia_handoff") {
      this.limparIaGerando(payload.conversation_id);
      this.toastr.warning("A IA pausou nesta conversa e transferiu para atendimento humano.", "Conversa transferida");
      return false;
    }

    if (payload.event_type == "ia_sugestao_criada" || payload.event_type == "ia_sugestao_resolvida" || payload.event_type == "message_sent") {
      this.limparIaGerando(payload.conversation_id);
    }

    return false;
  }

  /* Modo efetivo de um atendimento da lista (override > global) */
  public getIaModoEfetivoAtendimento(atendimento: WhatsAppOfficialAtendimento): string {
    if (!this.iaAgenteHabilitado || atendimento == null) {
      return "DESATIVADO";
    }

    if (atendimento.ia_modo_override != null && atendimento.ia_modo_override != "") {
      return atendimento.ia_modo_override;
    }

    return this.iaModoGlobal || "DESATIVADO";
  }

  /* Reativa a IA após um handoff: remove o override (volta ao padrão da empresa) e limpa a marcação */
  public reativarIaAposHandoff() {
    if (this.atendimentoSelecionado == null || this.iaAtualizandoModo) {
      return;
    }

    let atendimento = this.atendimentoSelecionado;

    this.iaAtualizandoModo = true;
    this.iaReativandoHandoff = true;

    this.whatsAppOfficialService.atualizarIaModoConversa(atendimento.id, null).subscribe(atualizado => {
      this.iaAtualizandoModo = false;
      this.iaReativandoHandoff = false;

      if (atualizado) {
        atendimento.ia_modo_override = null;
        atendimento.ia_dt_handoff = null;
        this.toastr.success("", "IA reativada nesta conversa.");
      }
    }, () => {
      this.iaAtualizandoModo = false;
      this.iaReativandoHandoff = false;
    });
  }

  /* Fecha o aviso de handoff mantendo a IA desativada nesta conversa */
  public dispensarAvisoHandoff() {
    if (this.atendimentoSelecionado == null || this.iaAtualizandoModo) {
      return;
    }

    let atendimento = this.atendimentoSelecionado;

    this.iaAtualizandoModo = true;
    this.iaDispensandoHandoff = true;

    /* Reenviar DESATIVADO limpa a marcação de handoff no backend e mantém a IA Off */
    this.whatsAppOfficialService.atualizarIaModoConversa(atendimento.id, "DESATIVADO").subscribe(atualizado => {
      this.iaAtualizandoModo = false;
      this.iaDispensandoHandoff = false;

      if (atualizado) {
        atendimento.ia_modo_override = "DESATIVADO";
        atendimento.ia_dt_handoff = null;
      }
    }, () => {
      this.iaAtualizandoModo = false;
      this.iaDispensandoHandoff = false;
    });
  }

  public getIaModoConversa(): string {
    return this.atendimentoSelecionado != null ? this.atendimentoSelecionado.ia_modo_override : null;
  }

  /* Modo efetivo exibido no seletor: override da conversa ou, na ausência dele, o modo global */
  public getIaModoEfetivo(): string {
    let override = this.getIaModoConversa();

    if (override != null && override != "") {
      return override;
    }

    return this.iaModoGlobal || "DESATIVADO";
  }

  public isIaModoHerdado(): boolean {
    let override = this.getIaModoConversa();

    return override == null || override == "";
  }

  private aplicarEventoIaSugestao(payload: any) {
    if (this.atendimentoSelecionado == null || payload == null || payload.conversation_id == null) {
      return;
    }

    if (payload.conversation_id == this.atendimentoSelecionado.id) {
      this.carregarIaSugestaoPendente(this.atendimentoSelecionado.id);
    }
  }

  public abrirAtendimentoNoInbox(atendimento: WhatsAppOfficialAtendimento) {
    this.selecionarAba("conversas");
    this.selecionarAtendimento(atendimento);
  }

  public capturarAtendimentoCard(atendimento: WhatsAppOfficialAtendimento) {
    if (atendimento == null) {
      return;
    }

    this.selecionarAtendimento(atendimento);
    this.capturarAtendimento();
  }

  public carregarMensagens(conversationId: number, exibirLoader: boolean = true, manterQuantidadeAtual: boolean = false, atualizarJanelaPelaUltimaRecebida: boolean = false) {
    const versao = this.versaoMensagens;
    let deveExibirLoader = exibirLoader && (this.mensagens == null || this.mensagens.length == 0);
    let quantidade = manterQuantidadeAtual
      ? Math.max(this.quantidadeMensagensPagina, this.getQuantidadeMensagensPersistidasCarregadas())
      : this.quantidadeMensagensPagina;

    if (deveExibirLoader) {
      this.carregandoMensagens = true;
    }

    this.whatsAppOfficialService.getMessages(conversationId, Math.min(quantidade, 199) + 1).subscribe(
      mensagens => {
        if (this.atendimentoSelecionado?.id !== conversationId || versao !== this.versaoMensagens) return;
        const limite = Math.min(quantidade, 199);
        const lote = mensagens || [];
        const mescladas = this.mesclarMensagensServidor(lote.slice(-limite));
        if (manterQuantidadeAtual) {
          // Preserva as páginas antigas já abertas, inclusive acima do limite do endpoint.
          this.mensagens = this.mesclarMensagensHistorico(mescladas);
        } else {
          this.mensagens = mescladas;
          this.temMaisMensagens = lote.length > limite;
        }
        if (atualizarJanelaPelaUltimaRecebida) {
          this.atualizarJanelaPelaUltimaMensagemRecebidaLocal(conversationId);
        }
        this.rolarMensagensParaFim();
      },
      error => {
        if (this.atendimentoSelecionado?.id === conversationId && versao === this.versaoMensagens && deveExibirLoader) this.carregandoMensagens = false;
        console.log("Erro: " + error);
      },
      () => {
        if (deveExibirLoader && this.atendimentoSelecionado?.id === conversationId && versao === this.versaoMensagens) {
          this.carregandoMensagens = false;
        }
      }
    );
  }

  public capturarAtendimento() {
    if (this.atendimentoSelecionado == null) {
      return;
    }

    this.whatsAppOfficialService.captureConversation(this.atendimentoSelecionado.id).subscribe(
      capturado => {
        if (capturado) {
          this.toastr.success("", "Atendimento capturado com sucesso!");
          this.recarregarAtendimentoSelecionado();
        }
      }
    );
  }

  public reabrirAtendimento(etapaDestinoId: number, atendimento: WhatsAppOfficialAtendimento = null) {
    let atendimentoBase = atendimento || this.atendimentoSelecionado;

    if (atendimentoBase == null || etapaDestinoId == null) {
      return;
    }

    this.whatsAppOfficialService.reopenConversation(atendimentoBase.id, etapaDestinoId).subscribe(
      atendimentoReaberto => {
        if (atendimentoReaberto != null) {
          this.toastr.success("", "Novo atendimento criado com sucesso!");
          this.atendimentoSelecionado = atendimentoReaberto;
          this.etapaDestinoId = atendimentoReaberto.whatsapp_oficial_etapa_id;
          this.motivoPerdaId = atendimentoReaberto.no_order_done_reason_id;
          this.complementoPerda = atendimentoReaberto.motivo_perda_complemento || "";
          this.exibirFormularioPerda = false;
          this.carregarMensagens(atendimentoReaberto.id);
          this.atualizarListas(false);
        }
      }
    );
  }

  public moverEtapaSelecionada() {
    if (this.atendimentoSelecionado == null || this.etapaDestinoId == null) {
      return;
    }

    let etapaDestino = this.getEtapaById(this.etapaDestinoId);

    if (this.isAtendimentoConcluido(this.atendimentoSelecionado)) {
      if (etapaDestino == null || (etapaDestino.tipo != "ABERTO" && etapaDestino.tipo != "ATENDIMENTO")) {
        this.toastr.warning("", "Atendimentos concluídos só podem ser reabertos para Aberto ou Atendimento.");
        return;
      }

      this.reabrirAtendimento(this.etapaDestinoId);
      return;
    }

    if (etapaDestino != null && etapaDestino.tipo == "ABERTO") {
      this.toastr.warning("", "Não é possível voltar o atendimento para Aberto.");
      return;
    }

    if (this.atendimentoSelecionado.etapa_tipo == "ABERTO" && etapaDestino != null && etapaDestino.tipo != "ATENDIMENTO") {
      this.toastr.warning("", "Em Aberto, o atendimento precisa ser capturado e ir para Atendimento.");
      return;
    }

    if (this.isEtapaPerdaSelecionada()) {
      this.exibirFormularioPerda = true;
      return;
    }

    if (this.isEtapaGanhoSelecionada()) {
      this.concluirComoGanho();
      return;
    }

    if (etapaDestino != null && etapaDestino.tipo == "ATENDIMENTO" && this.isAtendimentoCapturavel(this.atendimentoSelecionado)) {
      this.capturarAtendimento();
      return;
    }

    this.whatsAppOfficialService.moveConversationStage(this.atendimentoSelecionado.id, this.etapaDestinoId).subscribe(
      alterado => {
        if (alterado) {
          this.toastr.success("", "Etapa atualizada com sucesso!");
          this.recarregarAtendimentoSelecionado();
        }
      }
    );
  }

  public concluirComoGanho() {
    if (this.atendimentoSelecionado == null) {
      return;
    }

    this.whatsAppOfficialService.finishWonConversation(this.atendimentoSelecionado.id).subscribe(
      concluido => {
        if (concluido) {
          this.toastr.success("", "Atendimento concluído como ganho.");
          this.recarregarAtendimentoSelecionado();
        }
      }
    );
  }

  public podeAbrirNovoPedido(): boolean {
    return this.atendimentoSelecionado != null &&
      this.atendimentoSelecionado.client_id != null &&
      Number(this.atendimentoSelecionado.client_id) > 0 &&
      this.atendimentoSelecionado.client_codigo_erp_snapshot != null &&
      this.atendimentoSelecionado.client_codigo_erp_snapshot.toString().trim() != "";
  }

  public abrirNovoPedido() {
    if (!this.podeAbrirNovoPedido()) {
      this.toastr.warning("", "Este atendimento precisa ter cliente vinculado e codigo ERP para abrir um pedido.");
      return;
    }

    let urlPedido = this.router.serializeUrl(this.router.createUrlTree(["/pedidos-cadastro"], {
      queryParams: {
        cliente: this.clienteSelecionadoParaAcaoErp || this.atendimentoSelecionado.client_codigo_erp_snapshot,
        whatsapp_atendimento: this.atendimentoSelecionado.id,
        vendedor: this.atendimentoSelecionado.seller_id_atual || this.sellerId,
        origem: "whatsapp-oficial"
      }
    }));

    let janelaPedido = window.open(urlPedido, "_blank");

    if (janelaPedido == null) {
      this.toastr.warning("", "O navegador bloqueou a nova janela do pedido. Libere pop-ups para este portal.");
    }
  }

  public limparRetornoPedido() {
    this.pedidoRetornoAtendimentoId = null;
    this.pedidoRetornoNumero = null;
    this.pedidoRetornoVendedorId = null;
    this.pedidoRetornoMensagem = "";
  }

  public async enviarPdfPedidoCliente() {
    if (this.enviandoPdfPedido || !this.pedidoRetornoNumero || !this.atendimentoSelecionado ||
        this.atendimentoSelecionado.id !== this.pedidoRetornoAtendimentoId) {
      return;
    }
    if (!this.podeEnviarMensagem()) {
      this.toastr.warning("", "O atendimento precisa estar disponível para envio de mensagens.");
      return;
    }

    const atendimentoId = this.pedidoRetornoAtendimentoId;
    const numeroPedido = this.pedidoRetornoNumero;
    const vendedorId = this.pedidoRetornoVendedorId || this.atendimentoSelecionado.seller_id_atual || this.sellerId;
    this.enviandoPdfPedido = true;
    try {
      const arquivo = await this.pdfService.gerarArquivoPedidoOrcamento(numeroPedido, vendedorId);
      const mensagem = await firstValueFrom(this.whatsAppOfficialService.sendDocumentMessage(atendimentoId, arquivo));
      if (mensagem == null) {
        if (this.atendimentoSelecionado && this.atendimentoSelecionado.id === atendimentoId) {
          this.tratarErroEnvioUazapi(this.whatsAppOfficialService.ultimoErroEnvioMensagem);
        }
        return;
      }
      this.toastr.success("", "PDF do pedido " + numeroPedido + " enviado com sucesso.");
      if (this.atendimentoSelecionado && this.atendimentoSelecionado.id === atendimentoId) {
        this.recarregarAtendimentoSelecionado(false);
      }
    } catch (error) {
      this.toastr.error("", error instanceof Error ? error.message : "Não foi possível gerar ou enviar o PDF do pedido.");
    } finally {
      this.enviandoPdfPedido = false;
    }
  }

  public concluirComoPerda() {
    if (this.atendimentoSelecionado == null || this.motivoPerdaId == null) {
      this.toastr.warning("", "Selecione um motivo de perda.");
      return;
    }

    this.whatsAppOfficialService.finishLostConversation(this.atendimentoSelecionado.id, this.motivoPerdaId, this.complementoPerda).subscribe(
      concluido => {
        if (concluido) {
          this.toastr.success("", "Atendimento concluído como perda.");
          this.exibirFormularioPerda = false;
          this.recarregarAtendimentoSelecionado();
        }
      }
    );
  }

  public async enviarMensagem() {
    if (this.gravandoAudio) {
      await this.enviarAudioGravado();
      return;
    }

    if (this.atendimentoSelecionado == null || this.textoMensagem.trim() == "") {
      return;
    }

    let texto = this.textoMensagem.trim();
    let isMensagemInterna = this.isTextoMensagemInterna(texto);
    let textoExibicao = isMensagemInterna ? this.limparPrefixoMensagemInterna(texto) : texto;
    let replyToMessageId = this.mensagemRespondendoA != null ? this.mensagemRespondendoA.id : null;
    let mensagemOtimista = this.criarMensagemOtimista(textoExibicao, isMensagemInterna);

    this.textoMensagem = "";
    this.mostrarSeletorEmoji = false;
    this.cancelarResposta();
    this.adicionarMensagemLocal(mensagemOtimista);
    this.atualizarPreviewAtendimentoLocal(this.atendimentoSelecionado.id, textoExibicao);

    this.enviarTextoAtendimento(texto, mensagemOtimista.id, replyToMessageId);
  }

  public mensagemEditandoId: number = null;
  public textoEdicaoMensagem = "";
  public mensagemAlterandoId: number = null;

  public isMensagemDeletada(mensagem: WhatsAppOfficialMensagem): boolean {
    return !!mensagem && (!!mensagem.dt_deletada || (mensagem.status_whatsapp || "").toLowerCase() === "deleted");
  }

  public podeAlterarMensagem(mensagem: WhatsAppOfficialMensagem, deletar: boolean): boolean {
    if (!mensagem || mensagem.id <= 0 || mensagem.direction !== "OUTBOUND" || this.isMensagemInterna(mensagem) ||
        this.isMensagemDeletada(mensagem) || !mensagem.wamid?.startsWith("uazapi-") ||
        mensagem.wamid.startsWith("uazapi-out-") || !["sent", "delivered", "read", "played"].includes((mensagem.status_whatsapp || "").toLowerCase()) ||
        (!deletar && ((mensagem.message_type || "").toUpperCase() !== "TEXT" || this.isMensagemContato(mensagem)))) return false;
    const raw = mensagem.dt_mensagem;
    const value = String(raw || "");
    const sent = raw instanceof Date ? raw.getTime() : Date.parse(value + (/Z$|[+-]\d\d:\d\d$/.test(value) ? "" : "-03:00"));
    const age = Date.now() - sent;
    return Number.isFinite(age) && age >= 0 && age < (deletar ? 24 * 60 : 15) * 60000;
  }

  public iniciarEdicaoMensagem(mensagem: WhatsAppOfficialMensagem, event: Event) {
    event.stopPropagation();
    if (!this.podeAlterarMensagem(mensagem, false) || this.mensagemAlterandoId != null) return;
    this.mensagemMenuAbertaId = null;
    this.mensagemEditandoId = mensagem.id;
    this.textoEdicaoMensagem = mensagem.texto || "";
  }

  public salvarEdicaoMensagem(mensagem: WhatsAppOfficialMensagem) {
    if (!this.podeAlterarMensagem(mensagem, false)) {
      this.toastr.warning("", "O prazo de 15 minutos para editar expirou ou a mensagem não permite edição.");
      this.mensagemEditandoId = null;
      return;
    }
    if (!this.textoEdicaoMensagem.trim()) return;
    this.executarAlteracaoMensagem(mensagem, false, this.textoEdicaoMensagem.trim());
  }

  public apagarMensagem(mensagem: WhatsAppOfficialMensagem, event: Event) {
    event.stopPropagation();
    if (!this.podeAlterarMensagem(mensagem, true) || this.mensagemAlterandoId != null) return;
    if (!window.confirm("Apagar esta mensagem para todos no WhatsApp? Ela continuará visível no Napis com a tag Deletada.")) return;
    this.mensagemMenuAbertaId = null;
    this.executarAlteracaoMensagem(mensagem, true, null);
  }

  private executarAlteracaoMensagem(mensagem: WhatsAppOfficialMensagem, deletar: boolean, texto: string) {
    if (this.mensagemAlterandoId != null) return;
    this.mensagemAlterandoId = mensagem.id;
    this.whatsAppOfficialService.alterarMensagem(mensagem.whatsapp_oficial_atendimento_id, mensagem.id, texto, deletar).subscribe({
      next: atualizada => {
        if (atualizada) {
          Object.assign(mensagem, mesclarEstadoMensagem(mensagem, atualizada));
          this.mensagemEditandoId = null;
          if (this.mensagemRespondendoA?.id === mensagem.id && deletar) this.cancelarResposta();
          if (this.atendimentoSelecionado?.id === mensagem.whatsapp_oficial_atendimento_id)
            this.carregarMensagens(mensagem.whatsapp_oficial_atendimento_id, false, true);
        }
      },
      error: () => { this.mensagemAlterandoId = null; },
      complete: () => { this.mensagemAlterandoId = null; }
    });
  }
  public alternarMenuMensagem(mensagem: WhatsAppOfficialMensagem, event?: Event) {
    if (event != null) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (mensagem == null) {
      return;
    }

    this.mensagemMenuAbertaId = this.mensagemMenuAbertaId == mensagem.id ? null : mensagem.id;
  }

  @HostListener("document:click")
  public fecharMenuMensagem() {
    this.mensagemMenuAbertaId = null;
  }

  public responderMensagem(mensagem: WhatsAppOfficialMensagem, event?: Event) {
    if (event != null) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (mensagem == null || this.isMensagemInterna(mensagem) || this.isMensagemDeletada(mensagem)) {
      return;
    }

    this.mensagemMenuAbertaId = null;
    this.mensagemRespondendoA = mensagem;

    setTimeout(() => {
      if (this.mensagemInput != null) {
        this.mensagemInput.nativeElement.focus();
      }
    });
  }

  public cancelarResposta() {
    this.mensagemRespondendoA = null;
  }

  public irParaMensagem(mensagemId: number, event?: Event) {
    if (event != null) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (mensagemId == null) {
      return;
    }

    let elemento = document.getElementById("whatsapp_msg_" + mensagemId);

    if (elemento == null) {
      this.toastr.info("", "Mensagem original não está carregada nesta janela. Role para cima e carregue mais mensagens.");
      return;
    }

    elemento.scrollIntoView({ behavior: "smooth", block: "center" });
    this.mensagemDestacadaId = mensagemId;

    setTimeout(() => {
      if (this.mensagemDestacadaId == mensagemId) {
        this.mensagemDestacadaId = null;
      }
    }, 1800);
  }

  public abrirSelecaoDocumento(event?: Event) {
    if (event != null) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (!this.podeEnviarMensagem()) {
      return;
    }

    this.mostrarMenuAnexo = false;
    this.mostrarSeletorEmoji = false;

    if (this.documentInput != null && this.documentInput.nativeElement != null) {
      this.documentInput.nativeElement.click();
    }
  }

  public selecionarDocumento(event: Event) {
    let input = event.target as HTMLInputElement;
    let arquivo = input.files != null && input.files.length > 0 ? input.files[0] : null;
    input.value = "";

    if (arquivo == null || this.atendimentoSelecionado == null) {
      return;
    }

    if (!this.podeEnviarMensagem()) {
      this.toastr.warning("", this.getMensagemEnvioBloqueado());
      return;
    }

    if (!this.isDocumentoPermitido(arquivo)) {
      this.toastr.warning("", "Selecione um documento nos formatos PDF, DOC, DOCX, XLS, XLSX, TXT, CSV, PPT ou PPTX.");
      return;
    }

    if (arquivo.size > 100 * 1024 * 1024) {
      this.toastr.warning("", "O documento deve ter no maximo 100 MB.");
      return;
    }

    let mensagemOtimista = this.criarMensagemDocumentoOtimista(arquivo);
    this.adicionarMensagemLocal(mensagemOtimista);
    this.atualizarPreviewAtendimentoLocal(this.atendimentoSelecionado.id, arquivo.name || "[Documento]");

    this.enviarDocumentoAtendimento(arquivo, mensagemOtimista.id);
  }

  public abrirSelecaoImagem(event?: Event) {
    if (event != null) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (!this.podeEnviarMensagem()) {
      return;
    }

    this.mostrarMenuAnexo = false;
    this.mostrarSeletorEmoji = false;

    if (this.imageInput != null && this.imageInput.nativeElement != null) {
      this.imageInput.nativeElement.click();
    }
  }

  public alternarMenuAnexo(event?: Event) {
    if (event != null) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (!this.podeEnviarMensagem()) {
      return;
    }

    this.mostrarMenuAnexo = !this.mostrarMenuAnexo;
    if (this.mostrarMenuAnexo) {
      this.mostrarSeletorEmoji = false;
    }
  }

  public alternarSeletorEmoji(event?: Event) {
    if (event != null) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (!this.podeEnviarMensagem() || this.gravandoAudio) {
      return;
    }

    this.mostrarMenuAnexo = false;
    this.mostrarSeletorEmoji = !this.mostrarSeletorEmoji;
  }

  public selecionarCategoriaEmoji(categoriaId: string, event?: Event) {
    if (event != null) {
      event.preventDefault();
      event.stopPropagation();
    }

    this.categoriaEmojiSelecionada = categoriaId;
  }

  public inserirEmoji(emoji: string, event?: Event) {
    if (event != null) {
      event.preventDefault();
      event.stopPropagation();
    }

    let textoAtual = this.textoMensagem || "";
    let inicio = textoAtual.length;
    let fim = textoAtual.length;

    if (this.mensagemInput != null && this.mensagemInput.nativeElement != null) {
      let textarea = this.mensagemInput.nativeElement as HTMLTextAreaElement;
      inicio = textarea.selectionStart != null ? textarea.selectionStart : textoAtual.length;
      fim = textarea.selectionEnd != null ? textarea.selectionEnd : textoAtual.length;
    }

    this.textoMensagem = textoAtual.substring(0, inicio) + emoji + textoAtual.substring(fim);
    this.registrarEmojiRecente(emoji);

    setTimeout(() => {
      if (this.mensagemInput != null && this.mensagemInput.nativeElement != null) {
        let textarea = this.mensagemInput.nativeElement as HTMLTextAreaElement;
        let posicaoCursor = inicio + emoji.length;
        textarea.focus();
        textarea.setSelectionRange(posicaoCursor, posicaoCursor);
      }
    }, 0);
  }

  public obterEmojisDaCategoriaSelecionada(): string[] {
    let categoria = this.categoriaEmojiSelecionada || "smileys";
    let emojisBase = categoria == "recentes" ? this.emojisRecentes : (this.emojisPorCategoria[categoria] || []);
    let filtro = (this.filtroEmoji || "").trim();

    if (filtro == "") {
      return emojisBase;
    }

    return emojisBase.filter(emoji => emoji.indexOf(filtro) >= 0);
  }

  public obterTituloCategoriaEmojiSelecionada(): string {
    let categoria = this.categoriasEmoji.find(item => item.id == this.categoriaEmojiSelecionada);
    return categoria != null ? categoria.label : "Emojis";
  }

  private carregarEmojisRecentes() {
    try {
      let recentes = JSON.parse(localStorage.getItem("wa_oficial_recent_emojis") || "[]");
      this.emojisRecentes = Array.isArray(recentes) ? recentes.slice(0, 18) : [];
      this.emojisPorCategoria.recentes = this.emojisRecentes;
    } catch {
      this.emojisRecentes = [];
      this.emojisPorCategoria.recentes = [];
    }
  }

  private registrarEmojiRecente(emoji: string) {
    let recentes = [emoji].concat(this.emojisRecentes.filter(item => item != emoji)).slice(0, 18);
    this.emojisRecentes = recentes;
    this.emojisPorCategoria.recentes = recentes;
    localStorage.setItem("wa_oficial_recent_emojis", JSON.stringify(recentes));
  }

  public selecionarImagem(event: Event) {
    let input = event.target as HTMLInputElement;
    let arquivo = input.files != null && input.files.length > 0 ? input.files[0] : null;
    input.value = "";

    this.enviarArquivoImagem(arquivo);
  }

  public onMensagemPaste(event: ClipboardEvent) {
    if (event == null || event.clipboardData == null) {
      return;
    }

    let arquivoImagem: File = null;
    let items = event.clipboardData.items;

    if (items != null) {
      for (let i = 0; i < items.length; i++) {
        let item = items[i];

        if (item != null && item.kind == "file" && (item.type || "").toLowerCase().indexOf("image/") == 0) {
          arquivoImagem = item.getAsFile();
          break;
        }
      }
    }

    if (arquivoImagem == null && event.clipboardData.files != null) {
      for (let i = 0; i < event.clipboardData.files.length; i++) {
        let arquivo = event.clipboardData.files[i];

        if (arquivo != null && (arquivo.type || "").toLowerCase().indexOf("image/") == 0) {
          arquivoImagem = arquivo;
          break;
        }
      }
    }

    if (arquivoImagem == null) {
      return;
    }

    event.preventDefault();
    this.enviarArquivoImagem(this.normalizarImagemClipboard(arquivoImagem));
  }

  private enviarArquivoImagem(arquivo: File) {
    if (arquivo == null || this.atendimentoSelecionado == null) {
      return;
    }

    if (!this.podeEnviarMensagem()) {
      this.toastr.warning("", this.getMensagemEnvioBloqueado());
      return;
    }

    if (!this.isImagemPermitida(arquivo)) {
      this.toastr.warning("", "Selecione uma imagem nos formatos JPG, PNG ou WEBP.");
      return;
    }

    if (arquivo.size > 5 * 1024 * 1024) {
      this.toastr.warning("", "A imagem deve ter no maximo 5 MB.");
      return;
    }

    this.abrirPreviewImagemEnvio(arquivo);
  }

  private abrirPreviewImagemEnvio(arquivo: File) {
    this.fecharPreviewImagemEnvio(false);
    this.imagemPreviewArquivo = arquivo;
    this.imagemPreviewUrl = "";
    this.imagemPreviewLegenda = "";
    this.exibirPreviewImagemEnvio = true;
    this.mostrarMenuAnexo = false;
    this.mostrarSeletorEmoji = false;

    let reader = new FileReader();
    reader.onload = () => {
      this.imagemPreviewUrl = reader.result != null ? reader.result.toString() : "";
    };
    reader.onerror = () => {
      this.imagemPreviewUrl = URL.createObjectURL(arquivo);
    };
    reader.readAsDataURL(arquivo);
  }

  public fecharPreviewImagemEnvio(limparArquivo: boolean = true) {
    this.exibirPreviewImagemEnvio = false;

    if (this.imagemPreviewUrl != null && this.imagemPreviewUrl.indexOf("blob:") == 0) {
      URL.revokeObjectURL(this.imagemPreviewUrl);
    }

    this.imagemPreviewUrl = "";
    this.imagemPreviewLegenda = "";

    if (limparArquivo) {
      this.imagemPreviewArquivo = null;
    }
  }

  public confirmarEnvioImagemPreview() {
    if (this.imagemPreviewArquivo == null) {
      this.fecharPreviewImagemEnvio();
      return;
    }

    let arquivo = this.imagemPreviewArquivo;
    let legenda = (this.imagemPreviewLegenda || "").trim();
    this.fecharPreviewImagemEnvio(false);
    this.imagemPreviewArquivo = null;

    let mensagemOtimista = this.criarMensagemImagemOtimista(arquivo, legenda);
    this.adicionarMensagemLocal(mensagemOtimista);
    this.atualizarPreviewAtendimentoLocal(this.atendimentoSelecionado.id, legenda || "[Imagem]");

    this.enviarImagemAtendimento(arquivo, mensagemOtimista.id, legenda);
  }

  public async alternarGravacaoAudio(event?: Event) {
    if (event != null) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (!this.podeEnviarMensagem()) {
      return;
    }

    this.mostrarMenuAnexo = false;
    this.mostrarSeletorEmoji = false;

    if (this.gravandoAudio) {
      this.cancelarGravacaoAudio();
      return;
    }

    try {
      this.processandoAudio = true;
      await this.validarSuporteMicrofone();
      await this.carregarGravadorAudio();

      this.recorderAudio = new this.recorderAudioModule({
        bitRate: 128
      });

      await this.recorderAudio.start();
      this.gravandoAudio = true;
      this.segundosGravacaoAudio = 0;
      this.iniciarTimerGravacaoAudio();
    } catch (error) {
      console.error("Erro ao iniciar gravação de áudio:", error);
      this.toastr.error("", this.getMensagemErroMicrofone(error));
    } finally {
      this.processandoAudio = false;
    }
  }

  public async enviarAudioGravado() {
    if (!this.gravandoAudio || this.recorderAudio == null || this.atendimentoSelecionado == null) {
      return;
    }

    this.processandoAudio = true;

    try {
      let arquivo = await this.finalizarAudioMp3();
      let preview = URL.createObjectURL(arquivo);
      this.encerrarGravacaoAudioLocal();

      let mensagemOtimista = this.criarMensagemAudioOtimista(arquivo, preview);
      this.adicionarMensagemLocal(mensagemOtimista);
      this.atualizarPreviewAtendimentoLocal(this.atendimentoSelecionado.id, "[Áudio]");

      this.enviarAudioAtendimento(arquivo, mensagemOtimista.id);
    } catch (error) {
      this.toastr.error("", "Falha ao finalizar o áudio.");
      this.encerrarGravacaoAudioLocal();
    } finally {
      this.processandoAudio = false;
    }
  }

  public onMensagemEnter(event: KeyboardEvent) {
    if (event.altKey) {
      return;
    }

    event.preventDefault();
    this.enviarMensagem();
  }

  public podeReenviarMensagem(mensagem: WhatsAppOfficialMensagem): boolean {
    return mensagem != null &&
      mensagem.direction == "OUTBOUND" &&
      !this.isMensagemInterna(mensagem) &&
      !this.isMensagemDeletada(mensagem) &&
      mensagem.status_whatsapp == "failed" &&
      (!this.isMensagemDocumento(mensagem) || mensagem.local_file != null) &&
      (!this.isMensagemImagem(mensagem) || mensagem.local_file != null) &&
      (!this.isMensagemAudio(mensagem) || mensagem.local_file != null) &&
      this.podeEnviarMensagem();
  }

  public isMensagemInterna(mensagem: WhatsAppOfficialMensagem): boolean {
    return mensagem != null &&
      (mensagem.is_internal == true ||
        mensagem.internal_type == "INTERNAL_NOTE" ||
        mensagem.internal_type == "FORWARD_NOTICE" ||
        mensagem.meta_status_raw == "INTERNAL_NOTE" ||
        mensagem.meta_status_raw == "FORWARD_NOTICE" ||
        mensagem.status_whatsapp == "internal" ||
        (mensagem.wamid != null && mensagem.wamid.indexOf("internal-") == 0));
  }

  public getNomeAtendenteMensagem(mensagem: WhatsAppOfficialMensagem): string {
    let partes = this.extrairMensagemComAtendente(mensagem != null ? mensagem.texto : null);
    return partes != null ? partes.nome : null;
  }

  public getTextoMensagemSemAtendente(mensagem: WhatsAppOfficialMensagem): string {
    let texto = mensagem != null ? mensagem.texto : "";
    let partes = this.extrairMensagemComAtendente(texto);

    return partes != null ? partes.texto : texto;
  }

  public isMensagemTemplate(mensagem: WhatsAppOfficialMensagem): boolean {
    let payload = this.getPayloadMensagem(mensagem);
    return (payload.content_type || "").toLowerCase() == "template";
  }

  public getCabecalhoTemplateMensagem(mensagem: WhatsAppOfficialMensagem): string {
    let payload = this.getPayloadMensagem(mensagem);

    if (payload.template_header_text != null && payload.template_header_text != "") {
      return payload.template_header_text;
    }

    let components = payload.components || [];
    let header = components.find(component => (component.type || "").toUpperCase() == "HEADER");

    return header != null && header.text != null ? header.text : "";
  }

  public getBotoesTemplateMensagem(mensagem: WhatsAppOfficialMensagem): any[] {
    let payload = this.getPayloadMensagem(mensagem);
    let buttons = payload.template_buttons || [];

    if ((!buttons || buttons.length == 0) && payload.components != null) {
      let buttonComponent = payload.components.find(component => (component.type || "").toUpperCase() == "BUTTONS");
      buttons = buttonComponent != null ? (buttonComponent.buttons || []) : [];
    }

    return (buttons || [])
      .map(button => {
        return {
          text: button.text || button.title || button.name || "",
          type: button.type || "QUICK_REPLY"
        };
      })
      .filter(button => button.text != null && button.text != "");
  }

  public isMensagemRespostaBotao(mensagem: WhatsAppOfficialMensagem): boolean {
    let payload = this.getPayloadMensagem(mensagem);
    let contentType = (payload.content_type || "").toLowerCase();

    return contentType == "button_reply" || contentType == "list_reply";
  }

  public getTextoRespostaBotao(mensagem: WhatsAppOfficialMensagem): string {
    let payload = this.getPayloadMensagem(mensagem);

    return payload.button_text || payload.title || this.getTextoMensagemSemAtendente(mensagem);
  }

  public reenviarMensagem(mensagem: WhatsAppOfficialMensagem) {
    if (!this.podeReenviarMensagem(mensagem)) {
      return;
    }

    mensagem.status_whatsapp = "delivering";
    mensagem.dt_mensagem = new Date();
    this.mensagens = [...(this.mensagens || [])];

    if (this.isMensagemDocumento(mensagem)) {
      this.enviarDocumentoAtendimento(mensagem.local_file, mensagem.id);
      return;
    }

    if (this.isMensagemImagem(mensagem)) {
      this.enviarImagemAtendimento(mensagem.local_file, mensagem.id);
      return;
    }

    if (this.isMensagemAudio(mensagem)) {
      this.enviarAudioAtendimento(mensagem.local_file, mensagem.id);
      return;
    }

    this.enviarTextoAtendimento(mensagem.texto, mensagem.id, mensagem.reply_to_message_id);
  }

  public isMensagemDocumento(mensagem: WhatsAppOfficialMensagem): boolean {
    if (mensagem == null) {
      return false;
    }

    let payload = this.getPayloadMensagem(mensagem);
    let contentType = (payload.content_type || "").toLowerCase();
    let mimeType = (payload.mime_type || mensagem.mime_type || "").toLowerCase();

    if (contentType == "audio" || contentType == "image" || contentType == "video" || contentType == "location" || contentType == "contact" || mimeType.indexOf("audio/") == 0 || mimeType.indexOf("image/") == 0 || mimeType.indexOf("video/") == 0) {
      return false;
    }

    return (mensagem.message_type || "").toUpperCase() == "DOCUMENT" ||
      contentType == "document" ||
      (payload.media_url != null && payload.file_name != null);
  }

  public isMensagemImagem(mensagem: WhatsAppOfficialMensagem): boolean {
    if (mensagem == null) {
      return false;
    }

    let payload = this.getPayloadMensagem(mensagem);

    return (mensagem.message_type || "").toUpperCase() == "IMAGE" ||
      payload.content_type == "image" ||
      ((payload.media_url != null || mensagem.local_preview_url != null) && (payload.mime_type || mensagem.mime_type || "").toLowerCase().indexOf("image/") == 0);
  }

  public isMensagemAudio(mensagem: WhatsAppOfficialMensagem): boolean {
    if (mensagem == null) {
      return false;
    }

    let payload = this.getPayloadMensagem(mensagem);

    return (mensagem.message_type || "").toUpperCase() == "AUDIO" ||
      payload.content_type == "audio" ||
      ((payload.media_url != null || mensagem.local_preview_url != null) && (payload.mime_type || mensagem.mime_type || "").toLowerCase().indexOf("audio/") == 0);
  }

  public isMensagemVideo(mensagem: WhatsAppOfficialMensagem): boolean {
    if (mensagem == null) {
      return false;
    }

    let payload = this.getPayloadMensagem(mensagem);

    return (mensagem.message_type || "").toUpperCase() == "VIDEO" ||
      payload.content_type == "video" ||
      ((payload.media_url != null || mensagem.local_preview_url != null) && (payload.mime_type || mensagem.mime_type || "").toLowerCase().indexOf("video/") == 0);
  }

  public isMensagemLocalizacao(mensagem: WhatsAppOfficialMensagem): boolean {
    let payload = this.getPayloadMensagem(mensagem);
    return payload.content_type == "location";
  }

  public isMensagemContato(mensagem: WhatsAppOfficialMensagem): boolean {
    let payload = this.getPayloadMensagem(mensagem);
    return payload.content_type == "contact";
  }

  public getNomeDocumento(mensagem: WhatsAppOfficialMensagem): string {
    let payload = this.getPayloadMensagem(mensagem);
    return mensagem.file_name || payload.file_name || mensagem.texto || "Documento";
  }

  public getLegendaDocumento(mensagem: WhatsAppOfficialMensagem): string {
    if (mensagem == null) {
      return "";
    }

    let payload = this.getPayloadMensagem(mensagem);
    let mensagemUazapi = payload.uazapi_message || {};
    let conteudoUazapi = mensagemUazapi.content || {};
    let documentoMeta = payload.meta_document || {};
    let mensagemWebhook = payload.webhook_message || {};
    let documentoWebhook = mensagemWebhook.document || {};
    let legenda = (payload.caption ||
      mensagemUazapi.caption ||
      conteudoUazapi.caption ||
      mensagemUazapi.text ||
      documentoMeta.caption ||
      documentoWebhook.caption ||
      "").trim();
    let texto = (mensagem.texto || "").trim();
    let nomeDocumento = (mensagem.file_name || payload.file_name || "").trim();

    if (legenda == "" &&
      texto != "" &&
      texto.toLowerCase() != "[documento]" &&
      texto.toLowerCase() != nomeDocumento.toLowerCase()) {
      legenda = texto;
    }

    return legenda;
  }

  public getUrlDocumento(mensagem: WhatsAppOfficialMensagem): string {
    let payload = this.getPayloadMensagem(mensagem);
    return mensagem.media_url || payload.media_url || "";
  }

  public documentoPrecisaDownload(mensagem: WhatsAppOfficialMensagem): boolean {
    if (!this.isMensagemDocumento(mensagem)) {
      return false;
    }

    let payload = this.getPayloadMensagem(mensagem);
    let url = this.getUrlDocumento(mensagem);

    return url == "" ||
      ((payload.provider || "").toUpperCase() == "UAZAPI" && this.isUrlDocumentoCriptografado(url));
  }

  public isBaixandoDocumento(mensagem: WhatsAppOfficialMensagem): boolean {
    return mensagem != null && this.baixandoDocumento[mensagem.id] == true;
  }

  private isUrlDocumentoCriptografado(url: string): boolean {
    if (url == null || url.trim() == "") {
      return false;
    }

    let cleanUrl = url.split("?")[0].toLowerCase();
    return cleanUrl.endsWith(".enc");
  }

  public baixarDocumentoRecebido(mensagem: WhatsAppOfficialMensagem, event?: Event) {
    if (event != null) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (mensagem == null || this.isBaixandoDocumento(mensagem)) {
      return;
    }

    this.baixandoDocumento[mensagem.id] = true;

    this.whatsAppOfficialService.downloadInboundDocumentMessage(mensagem.id).subscribe(
      mensagemAtualizada => {
        this.baixandoDocumento[mensagem.id] = false;

        if (mensagemAtualizada != null) {
          this.upsertMensagemLocal(mensagemAtualizada);
          this.abrirDocumento(mensagemAtualizada);
        }
      },
      () => {
        this.baixandoDocumento[mensagem.id] = false;
      }
    );
  }

  public carregarMaisMensagens() {
    if (this.atendimentoSelecionado == null || this.carregandoMaisMensagens || !this.temMaisMensagens) return;
    const conversationId = this.atendimentoSelecionado.id;
    const versao = this.versaoMensagens;
    const mensagemMaisAntiga = this.getMensagemPersistidaMaisAntiga();
    if (mensagemMaisAntiga == null) {
      this.temMaisMensagens = false;
      return;
    }
    const scrollAnterior = this.getScrollMensagensAtual();
    this.carregandoMaisMensagens = true;
    this.whatsAppOfficialService.getMessages(conversationId, this.quantidadeMensagensPagina + 1, mensagemMaisAntiga.id)
      .subscribe({
        next: mensagensAntigas => {
          if (this.atendimentoSelecionado?.id !== conversationId || versao !== this.versaoMensagens) return;
          const lote = mensagensAntigas || [];
          this.temMaisMensagens = lote.length > this.quantidadeMensagensPagina;
          this.mensagens = this.mesclarMensagensHistorico(lote.slice(-this.quantidadeMensagensPagina));
          this.restaurarScrollAposCarregarHistorico(scrollAnterior);
        },
        error: () => {
          if (this.atendimentoSelecionado?.id === conversationId && versao === this.versaoMensagens) {
            this.carregandoMaisMensagens = false;
            this.toastr.error('', 'Não foi possível carregar mais mensagens. Tente novamente.');
          }
        },
        complete: () => {
          if (this.atendimentoSelecionado?.id === conversationId && versao === this.versaoMensagens) this.carregandoMaisMensagens = false;
        }
      });
  }

  public abrirDocumento(mensagem: WhatsAppOfficialMensagem, event?: Event) {
    if (event != null) {
      event.preventDefault();
      event.stopPropagation();
    }

    let url = this.getUrlDocumento(mensagem);

    if (url != "") {
      window.open(url, "_blank");
    }
  }

  public getUrlImagem(mensagem: WhatsAppOfficialMensagem): string {
    let payload = this.getPayloadMensagem(mensagem);
    return mensagem.media_url || payload.media_url || mensagem.local_preview_url || "";
  }

  public getLegendaImagem(mensagem: WhatsAppOfficialMensagem): string {
    let payload = this.getPayloadMensagem(mensagem);
    let legenda = payload.caption || "";

    if (legenda == "" && mensagem != null && mensagem.texto != null && mensagem.texto != "[Imagem]") {
      legenda = mensagem.texto;
    }

    return legenda;
  }

  public getUrlAudio(mensagem: WhatsAppOfficialMensagem): string {
    let payload = this.getPayloadMensagem(mensagem);
    return mensagem.media_url || payload.media_url || mensagem.local_preview_url || "";
  }

  public getUrlVideo(mensagem: WhatsAppOfficialMensagem): string {
    let payload = this.getPayloadMensagem(mensagem);
    return mensagem.media_url || payload.media_url || "";
  }

  public getLegendaVideo(mensagem: WhatsAppOfficialMensagem): string {
    let payload = this.getPayloadMensagem(mensagem);
    let legenda = payload.caption || "";

    if (legenda == "" && mensagem != null && mensagem.texto != null && mensagem.texto.indexOf("Vídeo recebido") < 0) {
      legenda = mensagem.texto;
    }

    return legenda;
  }

  public videoPrecisaDownload(mensagem: WhatsAppOfficialMensagem): boolean {
    if (!this.isMensagemVideo(mensagem)) {
      return false;
    }

    let payload = this.getPayloadMensagem(mensagem);
    let url = this.getUrlVideo(mensagem);

    return url == "" ||
      ((payload.provider || "").toUpperCase() == "UAZAPI" && this.isUrlDocumentoCriptografado(url));
  }

  public isBaixandoVideo(mensagem: WhatsAppOfficialMensagem): boolean {
    return mensagem != null && this.baixandoVideo[mensagem.id] == true;
  }

  public baixarVideoRecebido(mensagem: WhatsAppOfficialMensagem, event?: Event) {
    if (event != null) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (mensagem == null || this.isBaixandoVideo(mensagem)) {
      return;
    }

    this.baixandoVideo[mensagem.id] = true;

    this.whatsAppOfficialService.downloadInboundVideoMessage(mensagem.id).subscribe(
      mensagemAtualizada => {
        this.baixandoVideo[mensagem.id] = false;

        if (mensagemAtualizada != null) {
          this.upsertMensagemLocal(mensagemAtualizada);
        }
      },
      () => {
        this.baixandoVideo[mensagem.id] = false;
      }
    );
  }

  public abrirVideo(mensagem: WhatsAppOfficialMensagem, event?: Event) {
    if (event != null) {
      event.preventDefault();
      event.stopPropagation();
    }

    let url = this.getUrlVideo(mensagem);

    if (url != "") {
      window.open(url, "_blank");
    }
  }

  public contatosEnvio: {name: string, phone: string}[] = [];
  public contatoEnvioSelecionado: {name: string, phone: string} = null;
  public filtroContatoEnvio = "";
  public confirmandoContato = false;
  public carregandoContatos = false;
  public enviandoContato = false;
  private contatoDestinoId: number;
  public contatoDestinoNome = "";
  private popupContatoEnvio: any;
  @ViewChild("enviarContatoModal") enviarContatoModal: TemplateRef<any>;

  public get contatosEnvioFiltrados() {
    const filtro = this.normalizarTextoBusca(this.filtroContatoEnvio);
    const numero = this.somenteNumeros(this.filtroContatoEnvio);
    return this.contatosEnvio.filter(c => !filtro || this.normalizarTextoBusca(c.name).includes(filtro) || (!!numero && c.phone.includes(numero))).slice(0, 100);
  }

  public abrirEnvioContato(event: Event) {
    event.stopPropagation();
    if (!this.podeEnviarMensagem() || !this.isConversaUazapi()) return;
    this.mostrarMenuAnexo = false;
    this.contatoDestinoId = this.atendimentoSelecionado.id;
    this.contatoDestinoNome = this.getNomeExibicaoAtendimento(this.atendimentoSelecionado);
    this.contatosEnvio = []; this.contatoEnvioSelecionado = null; this.filtroContatoEnvio = ""; this.confirmandoContato = false;
    this.popupContatoEnvio = this.modalService.open(this.enviarContatoModal, {backdrop: "static", keyboard: false});
    this.carregandoContatos = true;
    this.whatsAppOfficialService.listarContatos(this.contatoDestinoId).subscribe(contatos => { this.contatosEnvio = contatos || []; this.carregandoContatos = false; });
  }

  public fecharEnvioContato() {
    if (!this.enviandoContato) this.popupContatoEnvio?.close();
  }

  public confirmarEnvioContato() {
    if (this.enviandoContato || !this.contatoEnvioSelecionado || !this.confirmandoContato) return;
    this.enviandoContato = true;
    const destino = this.contatoDestinoId;
    this.whatsAppOfficialService.enviarContato(destino, this.contatoEnvioSelecionado).subscribe(mensagem => {
      this.enviandoContato = false;
      if (!mensagem) return;
      this.popupContatoEnvio?.close();
      this.upsertMensagemLocal(mensagem);
      this.toastr.success("", "Contato enviado.");
    });
  }

  public conversarComContato(contato: {name: string, phone: string}, event: Event, mensagem: WhatsAppOfficialMensagem) {
    event.preventDefault();
    event.stopPropagation();
    if (this.isMensagemDeletada(mensagem) || this.abrindoNovoAtendimento) return;
    let telefone = this.somenteNumeros(contato?.phone);
    if (!/^[1-9]\d{7,14}$/.test(telefone)) { this.toastr.warning("", "Telefone do contato inválido."); return; }
    if (!contato.phone.trim().startsWith("+") && (telefone.length === 10 || telefone.length === 11)) telefone = "55" + telefone;

    const existente = (this.inbox || []).find(a => !this.isAtendimentoConcluido(a) &&
      this.somenteNumeros(a.telefone_normalizado || a.telefone) === telefone);
    if (existente) {
      this.selecionarAba("conversas");
      this.selecionarAtendimento(existente);
      return;
    }

    this.abrindoNovoAtendimento = true;
    this.whatsAppOfficialService.openOrCreateConversation(null, "", "+" + telefone, contato.name)
      .pipe(finalize(() => this.abrindoNovoAtendimento = false))
      .subscribe({
        next: atendimento => {
          if (!atendimento?.id) {
            this.toastr.warning("", "Não foi possível abrir a conversa do contato. Tente novamente.");
            return;
          }
          this.atualizarAtendimentoLocal(atendimento);
          this.selecionarAba("conversas");
          this.selecionarAtendimento(atendimento);
        },
        error: () => this.toastr.error("", "Não foi possível abrir a conversa do contato.")
      });
  }

  public getContatosMensagem(mensagem: WhatsAppOfficialMensagem): {name: string, phone: string}[] {
    const payload = this.getPayloadMensagem(mensagem);
    return Array.isArray(payload.contacts) && payload.contacts.length ? payload.contacts : [{name: this.getNomeContato(mensagem), phone: this.getTelefoneContato(mensagem)}];
  }
  public trackByContatoMensagem(indice: number, contato: {name: string, phone: string}): string {
    return `${indice}:${contato?.phone || ""}`;
  }
  public getNomeContato(mensagem: WhatsAppOfficialMensagem): string {
    let payload = this.getPayloadMensagem(mensagem);
    return payload.contact_name || "Contato recebido";
  }

  public getTelefoneContato(mensagem: WhatsAppOfficialMensagem): string {
    let payload = this.getPayloadMensagem(mensagem);
    return payload.contact_phone || "";
  }

  public getTextoLocalizacao(mensagem: WhatsAppOfficialMensagem): string {
    let payload = this.getPayloadMensagem(mensagem);
    return payload.location_name || payload.address || (this.temCoordenadasLocalizacao(payload) ? "Localização atual recebida" : "Localização recebida");
  }

  public getEnderecoLocalizacao(mensagem: WhatsAppOfficialMensagem): string {
    let payload = this.getPayloadMensagem(mensagem);
    if (payload.address) {
      return payload.address;
    }

    if (this.temCoordenadasLocalizacao(payload)) {
      return this.normalizarCoordenada(payload.latitude) + ", " + this.normalizarCoordenada(payload.longitude);
    }

    return "";
  }

  public getUrlLocalizacao(mensagem: WhatsAppOfficialMensagem): string {
    let payload = this.getPayloadMensagem(mensagem);
    if (payload.maps_url) {
      return payload.maps_url;
    }

    if (this.temCoordenadasLocalizacao(payload)) {
      return "https://maps.google.com/?q=" + this.normalizarCoordenada(payload.latitude) + "," + this.normalizarCoordenada(payload.longitude);
    }

    return "";
  }

  private temCoordenadasLocalizacao(payload: any): boolean {
    return payload != null &&
      payload.latitude != null &&
      payload.longitude != null &&
      this.normalizarCoordenada(payload.latitude) != "" &&
      this.normalizarCoordenada(payload.longitude) != "";
  }

  private normalizarCoordenada(valor: any): string {
    if (valor == null) {
      return "";
    }

    return String(valor).trim().replace(",", ".");
  }

  public alternarAudioMensagem(mensagem: WhatsAppOfficialMensagem, event?: Event) {
    if (event != null) {
      event.preventDefault();
      event.stopPropagation();
    }

    let url = this.getUrlAudio(mensagem);

    if (url == "") {
      return;
    }

    let chave = this.getChaveAudio(mensagem);
    let player = this.audioPlayers[chave];

    if (player == null || player.src != url) {
      player = this.criarPlayerAudio(chave, url);
    }

    if (player.paused) {
      this.pausarOutrosAudios(chave);
      player.play().then(
        () => this.ngZone.run(() => this.audioTocando[chave] = true),
        () => this.ngZone.run(() => this.toastr.warning("", "Não foi possível reproduzir o áudio."))
      );
      return;
    }

    player.pause();
    this.audioTocando[chave] = false;
  }

  public isAudioTocando(mensagem: WhatsAppOfficialMensagem): boolean {
    return this.audioTocando[this.getChaveAudio(mensagem)] == true;
  }

  public getPercentualAudio(mensagem: WhatsAppOfficialMensagem): number {
    let chave = this.getChaveAudio(mensagem);
    let duracao = this.audioDuracaoSegundos[chave] || 0;

    if (duracao <= 0) {
      return 0;
    }

    return Math.min(100, Math.max(0, ((this.audioProgressoSegundos[chave] || 0) / duracao) * 100));
  }

  public getTempoAudio(mensagem: WhatsAppOfficialMensagem): string {
    return this.formatarTempoAudio(this.audioProgressoSegundos[this.getChaveAudio(mensagem)] || 0);
  }

  public getDuracaoAudio(mensagem: WhatsAppOfficialMensagem): string {
    return this.formatarTempoAudio(this.audioDuracaoSegundos[this.getChaveAudio(mensagem)] || 0);
  }

  public audioPrecisaDownload(mensagem: WhatsAppOfficialMensagem): boolean {
    if (!this.isMensagemAudio(mensagem)) {
      return false;
    }

    let payload = this.getPayloadMensagem(mensagem);
    let url = this.getUrlAudio(mensagem);

    return url == "" ||
      ((payload.provider || "").toUpperCase() == "UAZAPI" && this.isUrlDocumentoCriptografado(url));
  }

  public isBaixandoAudio(mensagem: WhatsAppOfficialMensagem): boolean {
    return mensagem != null && this.baixandoAudio[mensagem.id] == true;
  }

  public baixarAudioRecebido(mensagem: WhatsAppOfficialMensagem, event?: Event) {
    if (event != null) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (mensagem == null || this.isBaixandoAudio(mensagem)) {
      return;
    }

    this.baixandoAudio[mensagem.id] = true;

    this.whatsAppOfficialService.downloadInboundAudioMessage(mensagem.id).subscribe(
      mensagemAtualizada => {
        this.baixandoAudio[mensagem.id] = false;

        if (mensagemAtualizada != null) {
          this.upsertMensagemLocal(mensagemAtualizada);
        }
      },
      () => {
        this.baixandoAudio[mensagem.id] = false;
      }
    );
  }

  public getTempoGravacaoAudio(): string {
    let minutos = Math.floor(this.segundosGravacaoAudio / 60);
    let segundos = this.segundosGravacaoAudio % 60;

    return `${minutos}:${segundos < 10 ? "0" : ""}${segundos}`;
  }

  public imagemPrecisaDownload(mensagem: WhatsAppOfficialMensagem): boolean {
    if (!this.isMensagemImagem(mensagem)) {
      return false;
    }

    let payload = this.getPayloadMensagem(mensagem);
    let url = this.getUrlImagem(mensagem);

    return url == "" ||
      ((payload.provider || "").toUpperCase() == "UAZAPI" && this.isUrlDocumentoCriptografado(url));
  }

  public isBaixandoImagem(mensagem: WhatsAppOfficialMensagem): boolean {
    return mensagem != null && this.baixandoImagem[mensagem.id] == true;
  }

  public baixarImagemRecebida(mensagem: WhatsAppOfficialMensagem, event?: Event) {
    if (event != null) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (mensagem == null || this.isBaixandoImagem(mensagem)) {
      return;
    }

    this.baixandoImagem[mensagem.id] = true;

    this.whatsAppOfficialService.downloadInboundImageMessage(mensagem.id).subscribe(
      mensagemAtualizada => {
        this.baixandoImagem[mensagem.id] = false;

        if (mensagemAtualizada != null) {
          this.upsertMensagemLocal(mensagemAtualizada);
        }
      },
      () => {
        this.baixandoImagem[mensagem.id] = false;
      }
    );
  }

  public abrirImagem(mensagem: WhatsAppOfficialMensagem, event?: Event) {
    if (event != null) {
      event.preventDefault();
      event.stopPropagation();
    }

    let url = this.getUrlImagem(mensagem);

    if (url != "") {
      window.open(url, "_blank");
    }
  }

  private enviarTextoAtendimento(texto: string, mensagemLocalId: number, replyToMessageId: number = null) {
    if (this.atendimentoSelecionado == null) {
      return;
    }

    this.whatsAppOfficialService.sendTextMessage(this.atendimentoSelecionado.id, texto, replyToMessageId).subscribe(
      enviado => {
        if (enviado) {
          return;
        } else {
          this.marcarMensagemLocalComoFalha(mensagemLocalId);
          this.tratarErroEnvioUazapi(this.whatsAppOfficialService.ultimoErroEnvioMensagem);
        }
      },
      error => {
        console.log("Erro: " + error);
        this.marcarMensagemLocalComoFalha(mensagemLocalId);
        this.tratarErroEnvioUazapi(this.whatsAppOfficialService.ultimoErroEnvioMensagem || (error != null ? error.message : ""));
      }
    );
  }

  public recarregarAtendimentoSelecionado(exibirLoaderMensagens: boolean = true) {
    if (this.atendimentoSelecionado == null) {
      this.atualizarListas(false);
      return;
    }

    this.whatsAppOfficialService.getConversationById(this.atendimentoSelecionado.id).subscribe(
      atendimento => {
        if (atendimento != null) {
          this.atendimentoSelecionado = atendimento;
          this.etapaDestinoId = atendimento.whatsapp_oficial_etapa_id;
          this.motivoPerdaId = atendimento.no_order_done_reason_id;
          this.complementoPerda = atendimento.motivo_perda_complemento || "";
          this.carregarMensagens(atendimento.id, exibirLoaderMensagens, true);

          if (atendimento.client_id != this.observacaoGeralClientIdCarregada) {
            this.cancelarEdicaoObservacaoGeral();
            this.carregarObservacaoGeralCliente(atendimento.client_id);
          }

          if (atendimento.client_id != this.contatoCallCenterClientIdCarregada) {
            this.cancelarEdicaoContatoCallCenter();
            this.carregarContatoCallCenterCliente(atendimento.client_id);
          }
        }
      },
      error => { console.log("Erro: " + error) },
      () => {
        this.atualizarListas(false);
      }
    );
  }

  public isAtendimentoCapturavel(atendimento: WhatsAppOfficialAtendimento): boolean {
    return atendimento != null && (atendimento.seller_id_atual == null || atendimento.etapa_tipo == "ABERTO");
  }

  public isAtendimentoDoUsuario(atendimento: WhatsAppOfficialAtendimento): boolean {
    return atendimento != null &&
      (atendimento.seller_id_atual == this.sellerId ||
       atendimento.seller_id_captura == this.sellerId);
  }

  public isAtendimentoSelecionado(atendimento: WhatsAppOfficialAtendimento): boolean {
    return atendimento != null &&
      this.atendimentoSelecionado != null &&
      atendimento.id == this.atendimentoSelecionado.id;
  }

  public isAtendimentoConcluido(atendimento: WhatsAppOfficialAtendimento): boolean {
    return atendimento != null && (atendimento.etapa_tipo == "GANHO" || atendimento.etapa_tipo == "PERDA");
  }

  public podeExibirBotoesConclusao(atendimento: WhatsAppOfficialAtendimento): boolean {
    return atendimento != null &&
      this.podeGerenciarEtapaAtendimento(atendimento) &&
      atendimento.etapa_tipo != "ABERTO" &&
      atendimento.etapa_tipo != "GANHO" &&
      atendimento.etapa_tipo != "PERDA";
  }

  public podeGerenciarEtapaAtendimento(atendimento: WhatsAppOfficialAtendimento): boolean {
    if (!this.podeGerenciar || atendimento == null) {
      return false;
    }

    if (atendimento.etapa_tipo == "ABERTO" || atendimento.etapa_tipo == "GANHO" || atendimento.etapa_tipo == "PERDA") {
      return true;
    }

    return this.isAtendimentoDoUsuario(atendimento);
  }

  public podeEnviarMensagem(): boolean {
    if (!this.podeInteragirAtendimento()) {
      return false;
    }

    if (this.isConversaUazapi()) {
      return true;
    }

    return this.isJanelaAtendimentoClienteAberta();
  }

  public podeInteragirAtendimento(): boolean {
    return this.atendimentoSelecionado != null &&
      this.isAtendimentoDoUsuario(this.atendimentoSelecionado) &&
      !this.isAtendimentoCapturavel(this.atendimentoSelecionado) &&
      !this.isAtendimentoConcluido(this.atendimentoSelecionado);
  }

  public podeEnviarTemplateMarketing(): boolean {
    return this.podeInteragirAtendimento() &&
      this.isStatusUazapiConhecido() &&
      !this.isConversaUazapi() &&
      !this.isJanelaAtendimentoClienteAberta();
  }

  public getUsaWhatsTipoSeller(): string {
    return ((localStorage.getItem("usa_whats_tipo") || "") + "").trim().toUpperCase();
  }

  public isSellerUazapi(): boolean {
    return this.getUsaWhatsTipoSeller() == "UAZAPI";
  }

  public isSellerOficial(): boolean {
    return this.getUsaWhatsTipoSeller() == "OFICIAL";
  }

  public carregarStatusUazapi(abrirPopup: boolean = false) {
    if (!this.isSellerUazapi() || this.sellerId == null || isNaN(this.sellerId)) {
      return;
    }

    if (this.carregandoStatusUazapi) {
      if (abrirPopup) {
        this.exibirPopupUazapiStatus = true;
        this.iniciarMonitoramentoStatusUazapi();
      }

      return;
    }

    this.carregandoStatusUazapi = true;

    this.whatsAppOfficialService.getUazapiInstanceStatus(this.sellerId).subscribe(
      status => {
        this.statusUazapi = status || new WhatsAppUazapiSellerConfig();
        this.carregandoStatusUazapi = false;

        if (abrirPopup) {
          this.exibirPopupUazapiStatus = true;
        }

        if (this.exibirPopupUazapiStatus && this.statusUazapi != null && !this.statusUazapi.conectado && !this.statusUazapi.configuracao_inexistente) {
          this.iniciarMonitoramentoStatusUazapi();
        } else if (this.statusUazapi != null && (this.statusUazapi.conectado || this.statusUazapi.configuracao_inexistente)) {
          this.pararMonitoramentoStatusUazapi();
        }
      },
      error => {
        console.log("Erro: " + error);
        this.carregandoStatusUazapi = false;

        if (abrirPopup) {
          this.exibirPopupUazapiStatus = true;
          this.iniciarMonitoramentoStatusUazapi();
        }
      }
    );
  }

  public atualizarQrCodeUazapi() {
    if (!this.isSellerUazapi() || this.sellerId == null || isNaN(this.sellerId) || this.atualizandoQrCodeUazapi) {
      return;
    }

    if (this.statusUazapi != null && this.statusUazapi.configuracao_inexistente) {
      return;
    }

    this.atualizandoQrCodeUazapi = true;
    this.mensagemErroUazapi = "";

    this.whatsAppOfficialService.atualizarQrCodeUazapi(this.sellerId).subscribe(
      status => {
        this.statusUazapi = status || new WhatsAppUazapiSellerConfig();
        this.atualizandoQrCodeUazapi = false;

        if (this.statusUazapi != null && !this.statusUazapi.conectado && !this.statusUazapi.configuracao_inexistente) {
          this.iniciarMonitoramentoStatusUazapi();
        }
      },
      error => {
        console.log("Erro: " + error);
        this.atualizandoQrCodeUazapi = false;
      }
    );
  }

  public abrirPopupUazapiStatus() {
    this.mensagemErroUazapi = "";
    this.exibirPopupUazapiStatus = true;
    this.iniciarMonitoramentoStatusUazapi();
    this.carregarStatusUazapi(false);
  }

  public fecharPopupUazapiStatus() {
    this.exibirPopupUazapiStatus = false;
    this.mensagemErroUazapi = "";
    this.pararMonitoramentoStatusUazapi();
  }

  public iniciarMonitoramentoStatusUazapi() {
    if (!this.isSellerUazapi() || this.uazapiStatusTimer != null) {
      return;
    }

    this.uazapiStatusTimer = setInterval(() => {
      if (!this.exibirPopupUazapiStatus) {
        this.pararMonitoramentoStatusUazapi();
        return;
      }

      if (this.statusUazapi != null && (this.statusUazapi.conectado || this.statusUazapi.configuracao_inexistente)) {
        this.pararMonitoramentoStatusUazapi();
        return;
      }

      this.carregarStatusUazapi(false);
    }, 20000);
  }

  public pararMonitoramentoStatusUazapi() {
    if (this.uazapiStatusTimer != null) {
      clearInterval(this.uazapiStatusTimer);
      this.uazapiStatusTimer = null;
    }
  }

  public getTextoStatusUazapi(): string {
    if (this.carregandoStatusUazapi) {
      return "Consultando";
    }

    if (this.statusUazapi != null && this.statusUazapi.configuracao_inexistente) {
      return "Sem configuracao";
    }

    if (this.statusUazapi != null && this.statusUazapi.conectado) {
      return "Conectada";
    }

    if (this.statusUazapi != null && this.statusUazapi.precisa_reconectar) {
      return "Reconectar Instancia";
    }

    return "Instancia";
  }

  public getClasseStatusUazapi(): string {
    if (this.carregandoStatusUazapi) {
      return "uazapi_status_loading";
    }

    if (this.statusUazapi != null && this.statusUazapi.conectado) {
      return "uazapi_status_connected";
    }

    if (this.statusUazapi != null && this.statusUazapi.precisa_reconectar) {
      return "uazapi_status_disconnected";
    }

    return "uazapi_status_unknown";
  }

  public temQrCodeUazapi(): boolean {
    return this.statusUazapi != null && this.statusUazapi.qrcode != null && this.statusUazapi.qrcode != "";
  }

  public getQrCodeUazapiSrc(): string {
    if (!this.temQrCodeUazapi()) {
      return "";
    }

    if (this.statusUazapi.qrcode.indexOf("data:image") == 0) {
      return this.statusUazapi.qrcode;
    }

    return "data:image/png;base64," + this.statusUazapi.qrcode;
  }

  private tratarErroEnvioUazapi(mensagemErro: string) {
    if (!this.isConversaUazapi() || mensagemErro == null || mensagemErro == "") {
      return;
    }

    let erro = (mensagemErro || "").toLowerCase();
    let erroInstancia =
      erro.indexOf("uazapi") >= 0 ||
      erro.indexOf("instancia") >= 0 ||
      erro.indexOf("desconect") >= 0 ||
      erro.indexOf("qr") >= 0 ||
      erro.indexOf("socket") >= 0 ||
      erro.indexOf("unauthorized") >= 0 ||
      erro.indexOf("token") >= 0 ||
      erro.indexOf("configuracao") >= 0 ||
      erro.indexOf("401") >= 0 ||
      erro.indexOf("403") >= 0;

    if (!erroInstancia) {
      return;
    }

    this.mensagemErroUazapi = mensagemErro + " Verifique a conexao da instancia.";
    this.exibirPopupUazapiStatus = true;
    this.carregarStatusUazapi(false);
  }

  public isConversaUazapi(atendimento: WhatsAppOfficialAtendimento = null): boolean {
    if (this.isSellerUazapi()) {
      return true;
    }

    if (this.isSellerOficial()) {
      return false;
    }

    let atendimentoBase = atendimento || this.atendimentoSelecionado;

    if (atendimentoBase == null) {
      return false;
    }

    return atendimentoBase.is_uazapi == true;
  }

  public isStatusUazapiConhecido(atendimento: WhatsAppOfficialAtendimento = null): boolean {
    if (this.isSellerUazapi() || this.isSellerOficial()) {
      return true;
    }

    let atendimentoBase = atendimento || this.atendimentoSelecionado;

    if (atendimentoBase == null) {
      return false;
    }

    return atendimentoBase.is_uazapi === true || atendimentoBase.is_uazapi === false;
  }

  public isJanelaAtendimentoClienteAberta(atendimento: WhatsAppOfficialAtendimento = null): boolean {
    let atendimentoBase = atendimento || this.atendimentoSelecionado;

    if (atendimentoBase == null) {
      return false;
    }

    if (this.isConversaUazapi(atendimentoBase)) {
      return true;
    }

    if (atendimentoBase.janela_24h_aberta == true) {
      return true;
    }

    let dataUltimaMensagemCliente = this.parseDataAtendimento(atendimentoBase.dt_ultima_mensagem_cliente);

    if (dataUltimaMensagemCliente == null || isNaN(dataUltimaMensagemCliente.getTime())) {
      return false;
    }

    let diferencaMs = new Date().getTime() - dataUltimaMensagemCliente.getTime();
    return diferencaMs >= 0 && diferencaMs <= (24 * 60 * 60 * 1000);
  }

  public podeEncaminharAtendimento(): boolean {
    return this.atendimentoSelecionado != null &&
      this.isAtendimentoDoUsuario(this.atendimentoSelecionado) &&
      !this.isAtendimentoConcluido(this.atendimentoSelecionado);
  }

  public getMensagemEnvioBloqueado(): string {
    if (this.atendimentoSelecionado == null) {
      return "";
    }

    if (this.isAtendimentoConcluido(this.atendimentoSelecionado)) {
      return "Atendimento concluído. Reabra ou aguarde uma nova mensagem para iniciar um novo atendimento.";
    }

    if (this.podeInteragirAtendimento() && !this.isStatusUazapiConhecido()) {
      return "";
    }

    if (this.podeInteragirAtendimento() && this.isStatusUazapiConhecido() && !this.isConversaUazapi() && !this.isJanelaAtendimentoClienteAberta()) {
      return "Janela de 24h encerrada. Envie um template Marketing aprovado para retomar o contato.";
    }

    if (this.atendimentoSelecionado.seller_id_atual != null && !this.isAtendimentoDoUsuario(this.atendimentoSelecionado)) {
      let nomeResponsavel = this.getNomeVendedorResponsavel(this.atendimentoSelecionado);
      return "Atendimento capturado pelo usuario " + (nomeResponsavel != "" ? nomeResponsavel : "responsável pelo atendimento") + ".";
    }

    return "Capture o atendimento para iniciar a conversa.";
  }

  public abrirPopupTemplateMarketing() {
    if (!this.podeEnviarTemplateMarketing()) {
      this.toastr.warning("", this.getMensagemEnvioBloqueado());
      return;
    }

    this.exibirPopupTemplate = true;
    this.templateSelecionadoNome = "";
    this.templateSelecionado = null;
    this.templateValores = {};

    if (this.templatesMarketing == null || this.templatesMarketing.length == 0) {
      this.carregarTemplatesMarketing();
    }
  }

  public fecharPopupTemplateMarketing() {
    if (this.enviandoTemplateMarketing) {
      return;
    }

    this.exibirPopupTemplate = false;
    this.templateSelecionadoNome = "";
    this.templateSelecionado = null;
    this.templateValores = {};
  }

  public carregarTemplatesMarketing() {
    this.carregandoTemplatesMarketing = true;

    this.whatsAppOfficialService.getMarketingTemplates().subscribe(
      templates => {
        this.templatesMarketing = (templates || []).map(template => this.normalizarTemplateMarketing(template));
        this.carregandoTemplatesMarketing = false;
      },
      () => this.carregandoTemplatesMarketing = false
    );
  }

  public selecionarTemplateMarketing() {
    this.templateSelecionado = (this.templatesMarketing || []).find(template =>
      this.getTemplateOptionValue(template) == this.templateSelecionadoNome
    ) || null;

    this.templateValores = {};

    this.templateSelecionado = this.normalizarTemplateMarketing(this.templateSelecionado);

    (this.templateSelecionado != null && this.templateSelecionado.variables != null ? this.templateSelecionado.variables : []).forEach(variable => {
      this.templateValores[this.getTemplateVariableKey(variable)] = "";
    });
  }

  public enviarTemplateMarketing() {
    if (this.atendimentoSelecionado == null || this.templateSelecionado == null || this.enviandoTemplateMarketing) {
      return;
    }

    let variables = (this.templateSelecionado.variables || []).map(variable => {
      return {
        component_type: variable.component_type || "BODY",
        index: variable.index,
        name: variable.name,
        value: (this.templateValores[this.getTemplateVariableKey(variable)] || "").trim()
      };
    });

    if (variables.some(variable => variable.value == "")) {
      this.toastr.warning("", "Preencha todas as variáveis do template.");
      return;
    }

    let preview = this.getPreviewTemplateSelecionado();
    this.enviandoTemplateMarketing = true;

    this.whatsAppOfficialService.sendTemplateMessage(
      this.atendimentoSelecionado.id,
      this.templateSelecionado.name,
      this.templateSelecionado.language,
      preview,
      variables,
      this.templateSelecionado.components || []
    ).subscribe(
      mensagem => {
        this.enviandoTemplateMarketing = false;

        if (mensagem != null) {
          this.upsertMensagemLocal(mensagem);
          this.atualizarPreviewAtendimentoLocal(this.atendimentoSelecionado.id, mensagem.texto || preview);
          this.fecharPopupTemplateMarketing();
        }
      },
      () => this.enviandoTemplateMarketing = false
    );
  }

  public getTemplateOptionValue(template: WhatsAppOfficialTemplate): string {
    if (template == null) {
      return "";
    }

    return (template.name || "") + "|" + (template.language || "");
  }

  public getTemplateVariableKey(variable: WhatsAppOfficialTemplateVariable): string {
    return (variable.component_type || "BODY") + "_" + variable.index;
  }

  private normalizarTemplateMarketing(template: WhatsAppOfficialTemplate): WhatsAppOfficialTemplate {
    if (template == null) {
      return template;
    }

    let templateNormalizado = Object.assign(new WhatsAppOfficialTemplate(), template);
    let variaveis = templateNormalizado.variables != null ? templateNormalizado.variables.slice() : [];
    let variaveisTexto = this.extrairVariaveisTemplateDoTexto(templateNormalizado);

    variaveisTexto.forEach(variavelTexto => {
      let existe = variaveis.some(variavel =>
        (variavel.component_type || "BODY").toUpperCase() == (variavelTexto.component_type || "BODY").toUpperCase() &&
        variavel.index == variavelTexto.index
      );

      if (!existe) {
        variaveis.push(variavelTexto);
      }
    });

    templateNormalizado.variables = variaveis
      .map(variavel => {
        let variavelNormalizada = Object.assign(new WhatsAppOfficialTemplateVariable(), variavel);
        variavelNormalizada.component_type = (variavelNormalizada.component_type || "BODY").toUpperCase();

        if (variavelNormalizada.index == null || variavelNormalizada.index <= 0) {
          variavelNormalizada.index = variaveis.indexOf(variavel) + 1;
        }

        if (variavelNormalizada.name == null || variavelNormalizada.name.toString().trim() == "") {
          variavelNormalizada.name = variavelNormalizada.index.toString();
        }

        if (variavelNormalizada.label == null || variavelNormalizada.label.toString().trim() == "") {
          variavelNormalizada.label = this.getTemplateVariableLabel(variavelNormalizada);
        }

        return variavelNormalizada;
      })
      .sort((a, b) => {
        let componenteA = a.component_type || "";
        let componenteB = b.component_type || "";

        if (componenteA != componenteB) {
          return componenteA.localeCompare(componenteB);
        }

        return (a.index || 0) - (b.index || 0);
      });

    return templateNormalizado;
  }

  private extrairVariaveisTemplateDoTexto(template: WhatsAppOfficialTemplate): WhatsAppOfficialTemplateVariable[] {
    let variaveis: WhatsAppOfficialTemplateVariable[] = [];
    let components = template != null && template.components != null ? template.components : [];

    components.forEach(component => {
      let componentType = ((component.type || "BODY").toString()).toUpperCase();
      let text = component.text || "";

      if (text == "") {
        return;
      }

      let regex = /\{\{\s*([A-Za-z0-9_]*)\s*\}\}/g;
      let match: RegExpExecArray;

      while ((match = regex.exec(text)) !== null) {
        let nome = (match[1] || "").trim();
        let index = parseInt(nome, 10);

        if (isNaN(index) || index <= 0) {
          index = variaveis.filter(variavel => variavel.component_type == componentType).length + 1;
        }

        if (nome == "") {
          nome = index.toString();
        }

        let variavel = new WhatsAppOfficialTemplateVariable();
        variavel.component_type = componentType;
        variavel.index = index;
        variavel.name = nome;
        variavel.label = this.getTemplateVariableLabel(variavel);

        variaveis.push(variavel);
      }
    });

    return variaveis;
  }

  private getTemplateVariableLabel(variable: WhatsAppOfficialTemplateVariable): string {
    let nome = variable.name || variable.index.toString();
    let componente = (variable.component_type || "BODY").toUpperCase();

    if (componente == "HEADER") {
      return "Cabeçalho: " + nome;
    }

    return "Corpo: " + nome;
  }

  public getPreviewTemplateSelecionado(): string {
    if (this.templateSelecionado == null) {
      return "";
    }

    let body = this.getTemplateBodyText(this.templateSelecionado);

    (this.templateSelecionado.variables || []).forEach(variable => {
      let valor = (this.templateValores[this.getTemplateVariableKey(variable)] || "").trim();
      let nome = variable.name || variable.index.toString();
      body = body.replace(new RegExp("\\{\\{\\s*" + nome + "\\s*\\}\\}", "g"), valor || "{{" + nome + "}}");
    });

    (this.templateSelecionado.variables || []).forEach(variable => {
      let valor = (this.templateValores[this.getTemplateVariableKey(variable)] || "").trim();
      body = body.replace(/\{\{\s*\}\}/, valor || "{{" + variable.index + "}}");
    });

    return body || ("Template: " + this.templateSelecionado.name);
  }

  private getTemplateBodyText(template: WhatsAppOfficialTemplate): string {
    let components = template != null && template.components != null ? template.components : [];
    let body = components.find(component => (component.type || "").toUpperCase() == "BODY");

    return body != null && body.text != null ? body.text : "";
  }

  public isEtapaPerdaSelecionada(): boolean {
    let etapa = this.getEtapaById(this.etapaDestinoId);

    return etapa != null && etapa.tipo == "PERDA";
  }

  public isEtapaGanhoSelecionada(): boolean {
    let etapa = this.getEtapaById(this.etapaDestinoId);

    return etapa != null && etapa.tipo == "GANHO";
  }

  public getEtapaById(id: number): WhatsAppOfficialEtapa {
    return this.etapas.find(x => x.id == id) || null;
  }

  public getNomeEtapaAtendimento(atendimento: WhatsAppOfficialAtendimento): string {
    if (atendimento == null) {
      return "";
    }

    let etapa = this.getEtapaById(atendimento.whatsapp_oficial_etapa_id);

    if (etapa != null && etapa.nome != null && etapa.nome != "") {
      return etapa.nome;
    }

    return atendimento.etapa_nome || atendimento.etapa_tipo || "";
  }

  public getCorEtapaAtendimento(atendimento: WhatsAppOfficialAtendimento): string {
    if (atendimento == null) {
      return "#6c757d";
    }

    let etapa = this.getEtapaById(atendimento.whatsapp_oficial_etapa_id);
    let tipo = etapa != null ? this.getTipoEtapaKanban(etapa) : (atendimento.etapa_tipo || "").toUpperCase();

    switch (tipo) {
      case "ABERTO":
        return "#0d6efd";
      case "ATENDIMENTO":
      case "PIPELINE":
        return "#ffc107";
      case "GANHO":
        return "#28a745";
      case "PERDA":
        return "#dc3545";
      default:
        return atendimento.etapa_cor_hex || (etapa != null && etapa.cor_hex ? etapa.cor_hex : "#6c757d");
    }
  }

  public getCorTextoEtapaAtendimento(atendimento: WhatsAppOfficialAtendimento): string {
    let etapa = atendimento != null ? this.getEtapaById(atendimento.whatsapp_oficial_etapa_id) : null;
    let tipo = etapa != null ? this.getTipoEtapaKanban(etapa) : (atendimento != null ? (atendimento.etapa_tipo || "").toUpperCase() : "");

    return tipo == "ATENDIMENTO" || tipo == "PIPELINE" ? "#1f2d3d" : "#ffffff";
  }

  public getTipoEtapaKanban(etapa: WhatsAppOfficialEtapa): string {
    if (etapa == null || etapa.tipo == null) {
      return "";
    }

    let tipo = etapa.tipo.toUpperCase();

    if (tipo == "PIPELINE") {
      return "ATENDIMENTO";
    }

    return tipo;
  }

  public getClasseTipoEtapaKanban(etapa: WhatsAppOfficialEtapa): string {
    let tipo = this.getTipoEtapaKanban(etapa);

    switch (tipo) {
      case "ABERTO":
        return "kanban_type_aberto";
      case "ATENDIMENTO":
        return "kanban_type_atendimento";
      case "GANHO":
        return "kanban_type_ganho";
      case "PERDA":
        return "kanban_type_perda";
      default:
        return "kanban_type_default";
    }
  }

  public getAtendimentosPorEtapa(etapaId: number): WhatsAppOfficialAtendimento[] {
    return this.kanban.atendimentos.filter(x => x.whatsapp_oficial_etapa_id == etapaId);
  }

  public getResumoTempo(atendimento: WhatsAppOfficialAtendimento): string {
    if (atendimento == null) {
      return "";
    }

    let dataBase = atendimento.dt_finalizacao || atendimento.dt_inicio_atendimento || atendimento.dt_captura || atendimento.dt_primeira_mensagem || atendimento.created_at;

    if (dataBase == null) {
      return "";
    }

    let diferencaMilisegundos = new Date().getTime() - new Date(dataBase).getTime();
    let minutos = Math.max(0, Math.floor(diferencaMilisegundos / 60000));

    if (minutos < 60) {
      return minutos + " min";
    }

    let horas = Math.floor(minutos / 60);

    if (horas < 24) {
      return horas + " h";
    }

    let dias = Math.floor(horas / 24);

    return dias + " d";
  }

  public getRotuloTempo(atendimento: WhatsAppOfficialAtendimento): string {
    if (atendimento == null) {
      return "";
    }

    if (atendimento.dt_finalizacao != null) {
      return "Finalizado há " + this.getResumoTempo(atendimento);
    }

    if (atendimento.dt_inicio_atendimento != null || atendimento.dt_captura != null) {
      return "Em atendimento há " + this.getResumoTempo(atendimento);
    }

    return "Aberto há " + this.getResumoTempo(atendimento);
  }

  public getClasseTempo(atendimento: WhatsAppOfficialAtendimento): string {
    if (atendimento == null) {
      return "badge-light";
    }

    let dataBase = atendimento.dt_finalizacao || atendimento.dt_inicio_atendimento || atendimento.dt_captura || atendimento.dt_primeira_mensagem || atendimento.created_at;

    if (dataBase == null) {
      return "badge-light";
    }

    let horas = Math.floor((new Date().getTime() - new Date(dataBase).getTime()) / 3600000);

    if (horas >= 24) {
      return "badge-danger";
    }

    if (horas >= 4) {
      return "badge-warning";
    }

    return "badge-info";
  }

  public podeMoverCard(atendimento: WhatsAppOfficialAtendimento): boolean {
    return atendimento != null &&
      (atendimento.seller_id_atual == null || atendimento.seller_id_atual == this.sellerId);
  }

  public onDragStart(evento_drag: DndDropEvent, atendimento: WhatsAppOfficialAtendimento) {
    if (atendimento != null) {
      this.atendimentoArrastandoId = atendimento.id;
    }
  }

  public onDragEnd(evento_drag: DndDropEvent) {
    this.atendimentoArrastandoId = null;
  }

  public onDragged(atendimento: WhatsAppOfficialAtendimento, atendimentos: WhatsAppOfficialAtendimento[], effect: DropEffect) {
    if (effect == "move") {
      let index = atendimentos.indexOf(atendimento);

      if (index > -1) {
        atendimentos.splice(index, 1);
      }
    }
  }

  public onDrop(evento: DndDropEvent, etapaDestino: WhatsAppOfficialEtapa, atendimentos: WhatsAppOfficialAtendimento[]) {
    if (evento == null || evento.data == null || etapaDestino == null) {
      return;
    }

    let atendimento: WhatsAppOfficialAtendimento = evento.data;

    if (!this.podeMoverCard(atendimento)) {
      this.toastr.warning("", "Este atendimento já está vinculado a outro usuário.");
      this.atualizarListas(false);
      return;
    }

    if (atendimento.whatsapp_oficial_etapa_id == etapaDestino.id) {
      this.atualizarListas(false);
      return;
    }

    if (this.isAtendimentoConcluido(atendimento)) {
      if (etapaDestino.tipo != "ABERTO" && etapaDestino.tipo != "ATENDIMENTO") {
        this.toastr.warning("", "Atendimentos concluídos só podem ser reabertos para Aberto ou Atendimento.");
        this.atualizarListas(false);
        return;
      }

      this.selecionarAtendimento(atendimento);
      this.reabrirAtendimento(etapaDestino.id, atendimento);
      return;
    }

    if (etapaDestino.tipo == "ABERTO") {
      this.toastr.warning("", "Não é possível voltar o atendimento para Aberto.");
      this.atualizarListas(false);
      return;
    }

    if (atendimento.etapa_tipo == "ABERTO" && etapaDestino.tipo != "ATENDIMENTO") {
      this.toastr.warning("", "Em Aberto, o atendimento precisa ser capturado e ir para Atendimento.");
      this.atualizarListas(false);
      return;
    }

    if (etapaDestino.tipo == "PERDA") {
      this.selecionarAtendimento(atendimento);
      this.selecionarAba("conversas");
      this.etapaDestinoId = etapaDestino.id;
      this.exibirFormularioPerda = true;
      this.toastr.info("", "Selecione o motivo da perda para concluir o atendimento.");
      this.atualizarListas(false);
      return;
    }

    if (etapaDestino.tipo == "GANHO") {
      if (!this.isAtendimentoDoUsuario(atendimento)) {
        this.toastr.warning("", "Capture o atendimento antes de concluir como ganho.");
        this.atualizarListas(false);
        return;
      }

      this.selecionarAtendimento(atendimento);
      this.concluirComoGanho();
      return;
    }

    if (etapaDestino.tipo == "ATENDIMENTO" && atendimento.seller_id_atual == null) {
      this.selecionarAtendimento(atendimento);
      this.capturarAtendimento();
      return;
    }

    if (!this.isAtendimentoDoUsuario(atendimento) && atendimento.seller_id_atual != null) {
      this.toastr.warning("", "Somente o responsável pode movimentar este atendimento.");
      this.atualizarListas(false);
      return;
    }

    let index = evento.index;

    if (typeof index == "undefined") {
      index = atendimentos.length;
    }

    atendimento.whatsapp_oficial_etapa_id = etapaDestino.id;
    atendimento.etapa_nome = etapaDestino.nome;
    atendimento.etapa_cor_hex = etapaDestino.cor_hex;
    atendimento.etapa_tipo = etapaDestino.tipo;

    atendimentos.splice(index, 0, atendimento);

    this.whatsAppOfficialService.moveConversationStage(atendimento.id, etapaDestino.id).subscribe(
      alterado => {
        if (alterado) {
          this.toastr.success("", "Atendimento movido com sucesso!");
        } else {
          this.atualizarListas(false);
        }
      },
      error => { console.log("Erro: " + error) },
      () => {
        this.atualizarListas(false);
      }
    );
  }

  public getNomeExibicaoAtendimento(atendimento: WhatsAppOfficialAtendimento): string {
    if (atendimento == null) {
      return "";
    }

    if (atendimento.client_name_snapshot != null && atendimento.client_name_snapshot != "") {
      return atendimento.client_name_snapshot;
    }

    if (atendimento.contato_nome != null && atendimento.contato_nome != "") {
      return atendimento.contato_nome;
    }

    return atendimento.telefone;
  }

  public getNomeVendedorResponsavel(atendimento: WhatsAppOfficialAtendimento): string {
    if (atendimento == null || atendimento.seller_id_atual == null) {
      return "";
    }

    if (atendimento.seller_nome_atual != null && atendimento.seller_nome_atual != "") {
      return atendimento.seller_nome_atual;
    }

    return "";
  }

  private normalizarTextoBusca(valor: any): string {
    if (valor == null) {
      return "";
    }

    return valor
      .toString()
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .trim();
  }

  private normalizarNumeroBusca(valor: any): string {
    if (valor == null) {
      return "";
    }

    return valor.toString().replace(/\D/g, "");
  }

  public getPreviewAtendimentoLimitado(atendimento: WhatsAppOfficialAtendimento): string {
    let preview = atendimento != null && atendimento.ultima_mensagem_preview
      ? atendimento.ultima_mensagem_preview.toString().replace(/\s+/g, " ").trim()
      : "Sem mensagens ainda.";

    if (preview.length <= 40) {
      return preview;
    }

    return preview.substring(0, 40).trim() + "...";
  }

  public alternarFormularioPerda() {
    this.exibirFormularioPerda = !this.exibirFormularioPerda;
  }

  public podeAbrirAnalise(): boolean {
    return this.atendimentoSelecionado != null &&
      this.atendimentoSelecionado.client_id != null &&
      Number(this.atendimentoSelecionado.client_id) > 0;
  }

  public podeAbrirLigacao(): boolean {
    return this.podeAbrirAnalise();
  }

  public abrirLigacaoCliente() {
    if (!this.podeAbrirLigacao()) {
      this.toastr.warning("", "Este atendimento ainda não possui cliente vinculado.");
      return;
    }

    if (this.abrindoLigacao) {
      return;
    }

    const janelaLigacao = this.abrirPopup("about:blank", "whatsapp_ligacao", 1200, 800);

    if (janelaLigacao == null) {
      this.toastr.warning("", "O navegador bloqueou a janela da ligação. Libere pop-ups para este portal.");
      return;
    }

    this.abrindoLigacao = true;
    this.criarLigacaoWhatsApp(janelaLigacao);
  }

  private criarLigacaoWhatsApp(janelaLigacao: Window) {
    this.callCenterService.getTipo().subscribe(
      tipos => {
        const tipoRecebida = (tipos || []).find((tipo: CallCenterTipo) => tipo.id === 1) || (tipos || [])[0];

        if (!tipoRecebida) {
          this.fecharPopupEmBranco(janelaLigacao);
          this.toastr.error("", "Não foi possível localizar o tipo da ligação.");
          this.abrindoLigacao = false;
          return;
        }

        const ligacao = new CallCenterLigacaoAnalitica();
        ligacao.client_id = Number(this.clienteSelecionadoParaAcaoId || this.atendimentoSelecionado.client_id);
        ligacao.seller_id = this.atendimentoSelecionado.seller_id_atual || this.sellerId;
        ligacao.manual = true;
        ligacao.tmp = 1;
        ligacao.id_tmk = this.sellerId;
        ligacao.tipo = tipoRecebida.id_tipo;
        ligacao.id_status = 5;
        ligacao.data_ligacao = new Date();

        this.callCenterService.addLigacaoRetornarId(ligacao).subscribe(
          ligacaoId => {
            if (!ligacaoId || ligacaoId <= 0) {
              this.fecharPopupEmBranco(janelaLigacao);
              this.toastr.error("", "Não foi possível criar a ligação.");
              this.abrindoLigacao = false;
              return;
            }

            ligacao.id = ligacaoId;
            this.criarVisitaWhatsApp(janelaLigacao, ligacao, tipoRecebida);
          },
          () => {
            this.fecharPopupEmBranco(janelaLigacao);
            this.abrindoLigacao = false;
          }
        );
      },
      () => {
        this.fecharPopupEmBranco(janelaLigacao);
        this.abrindoLigacao = false;
      }
    );
  }

  private criarVisitaWhatsApp(janelaLigacao: Window, ligacao: CallCenterLigacaoAnalitica, tipo: CallCenterTipo) {
    this.visitaService.getProximoNumeroVisitaBySeller().subscribe(
      nroVisita => {
        if (!nroVisita || nroVisita <= 0) {
          this.abrirPopupLigacaoCriada(janelaLigacao, ligacao.id, null);
          return;
        }

        const visita = new Visita();
        visita.client_id = Number(this.clienteSelecionadoParaAcaoId || this.atendimentoSelecionado.client_id);
        visita.check_in_distance_in_meters = 0;
        visita.no_order_done_reason_id = null;
        visita.note = null;
        visita.is_active = true;
        visita.seller_id = this.sellerId;
        visita.visit_id_app = nroVisita;
        visita.callcenter_tipo = tipo.id_tipo;
        visita.callcenter_status = 5;
        visita.id_call_center_ligacao = ligacao.id;

        this.visitaService.add(visita).subscribe(
          adicionada => {
            if (!adicionada) {
              this.abrirPopupLigacaoCriada(janelaLigacao, ligacao.id, null);
              return;
            }

            this.visitaService.getUltimaVisitaByCliente(visita.client_id).subscribe(
              visitaCriada => this.abrirPopupLigacaoCriada(janelaLigacao, ligacao.id, visitaCriada && visitaCriada.id ? visitaCriada.id : null),
              () => this.abrirPopupLigacaoCriada(janelaLigacao, ligacao.id, null)
            );
          },
          () => this.abrirPopupLigacaoCriada(janelaLigacao, ligacao.id, null)
        );
      },
      () => this.abrirPopupLigacaoCriada(janelaLigacao, ligacao.id, null)
    );
  }

  private abrirPopupLigacaoCriada(janelaLigacao: Window, ligacaoId: number, visitaId: number) {
    let url = "/call-center-ligacao/" + ligacaoId +
      "?whatsapp_atendimento=" + this.atendimentoSelecionado.id;

    if (visitaId) {
      url += "&visita=" + visitaId;
    }

    janelaLigacao.location.href = url;
    janelaLigacao.focus();
    this.abrindoLigacao = false;
  }

  private fecharPopupEmBranco(janelaLigacao: Window) {
    if (janelaLigacao && janelaLigacao.location && janelaLigacao.location.href === "about:blank") {
      janelaLigacao.close();
    }
  }

  private abrirPopup(url: string, nome: string, largura: number, altura: number): Window {
    const esquerda = Math.max(0, Math.floor((window.screen.width - largura) / 2));
    const topo = Math.max(0, Math.floor((window.screen.height - altura) / 2));
    const opcoes = "popup=yes,width=" + largura + ",height=" + altura + ",left=" + esquerda + ",top=" + topo + ",resizable=yes,scrollbars=yes";
    const janela = window.open(url, nome, opcoes);

    if (janela != null) {
      janela.focus();
    }

    return janela;
  }

  public podeVincularCliente(): boolean {
    return this.atendimentoSelecionado != null && !this.podeAbrirAnalise();
  }

  public abrirAnaliseCliente() {
    if (!this.podeAbrirAnalise()) {
      this.toastr.warning("", "Este atendimento ainda não possui cliente vinculado.");
      return;
    }

    let url = window.location.origin + "/call-center-ligacao?cliente_consulta=" + (this.clienteSelecionadoParaAcaoId || this.atendimentoSelecionado.client_id)
      + "&whatsapp_atendimento=" + this.atendimentoSelecionado.id;
    this.urlAnaliseCliente = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    this.exibirPopupAnalise = true;
  }

  public fecharAnaliseCliente() {
    this.exibirPopupAnalise = false;
    this.urlAnaliseCliente = null;
  }

  public abrirPopupClientesVinculados() {
    if (this.atendimentoSelecionado == null || this.atendimentoSelecionado.client_id == null) {
      return;
    }

    this.filtroClienteParaVincular = "";
    this.clientesParaVincular = [];
    this.exibirPopupClientesVinculados = true;
    this.carregarClientesVinculados();
  }

  public fecharPopupClientesVinculados() {
    this.exibirPopupClientesVinculados = false;
    this.filtroClienteParaVincular = "";
    this.clientesParaVincular = [];
  }

  private carregarClientesVinculados() {
    if (this.atendimentoSelecionado == null || this.atendimentoSelecionado.client_id == null) {
      return;
    }

    this.carregandoClientesVinculados = true;

    this.clienteService.getClientesVinculados(this.atendimentoSelecionado.client_id, false).subscribe(vinculados => {
      this.clientesVinculados = vinculados || [];
      this.carregandoClientesVinculados = false;
    }, () => this.carregandoClientesVinculados = false);
  }

  public buscarClientesParaVincular() {
    if (this.filtroClienteParaVincular == null || this.filtroClienteParaVincular.trim().length < 2) {
      this.toastr.warning("", "Digite ao menos 2 caracteres para buscar o cliente.");
      return;
    }

    this.buscandoClientesParaVincular = true;

    this.whatsAppOfficialService.searchClientsForManualLink(this.filtroClienteParaVincular).subscribe(
      clientes => this.clientesParaVincular = clientes || [],
      error => { console.log("Erro: " + error) },
      () => this.buscandoClientesParaVincular = false
    );
  }

  public vincularClienteAdicional(cliente: WhatsAppOfficialClienteVinculo) {
    if (this.atendimentoSelecionado == null || this.atendimentoSelecionado.client_id == null || cliente == null || this.vinculandoClienteAdicional) {
      return;
    }

    this.vinculandoClienteAdicional = true;

    this.clienteService.vincularCliente(this.atendimentoSelecionado.client_id, cliente.id).subscribe(vinculado => {
      this.vinculandoClienteAdicional = false;

      if (vinculado) {
        this.toastr.success("", "Cliente vinculado com sucesso.");
        this.filtroClienteParaVincular = "";
        this.clientesParaVincular = [];
        this.carregarClientesVinculados();
      }
    }, () => this.vinculandoClienteAdicional = false);
  }

  public removerClienteVinculado(vinculo: ClienteVinculado) {
    if (vinculo == null || this.desvinculandoClienteId != null) {
      return;
    }

    if (!confirm("Remover o vínculo com \"" + vinculo.name + "\"?")) {
      return;
    }

    this.desvinculandoClienteId = vinculo.vinculo_id;

    this.clienteService.desvincularCliente(vinculo.vinculo_id).subscribe(desvinculado => {
      this.desvinculandoClienteId = null;

      if (desvinculado) {
        this.toastr.success("", "Vínculo removido.");
        this.clientesVinculados = this.clientesVinculados.filter(x => x.vinculo_id != vinculo.vinculo_id);
      }
    }, () => this.desvinculandoClienteId = null);
  }

  public iniciarAnaliseCliente() {
    this.iniciarAcaoComSelecaoDeCliente("analise");
  }

  public iniciarLigacaoCliente() {
    this.iniciarAcaoComSelecaoDeCliente("ligar");
  }

  public iniciarNovoPedido() {
    this.iniciarAcaoComSelecaoDeCliente("pedido");
  }

  private iniciarAcaoComSelecaoDeCliente(acao: string) {
    if (this.atendimentoSelecionado == null) {
      return;
    }

    if (this.clientesVinculados.length == 0) {
      this.clienteSelecionadoParaAcaoId = this.atendimentoSelecionado.client_id;
      this.clienteSelecionadoParaAcaoErp = this.atendimentoSelecionado.client_codigo_erp_snapshot;
      this.clienteSelecionadoParaAcaoNome = this.atendimentoSelecionado.client_name_snapshot;
      this.executarAcaoComClienteSelecionado(acao);
      return;
    }

    this.acaoPendenteSelecaoCliente = acao;
    this.exibirPopupSelecionarClienteAcao = true;
  }

  public selecionarClienteParaAcao(clientId: number, erp: string, nome: string) {
    this.clienteSelecionadoParaAcaoId = clientId;
    this.clienteSelecionadoParaAcaoErp = erp;
    this.clienteSelecionadoParaAcaoNome = nome;
    this.exibirPopupSelecionarClienteAcao = false;

    let acao = this.acaoPendenteSelecaoCliente;
    this.acaoPendenteSelecaoCliente = null;
    this.executarAcaoComClienteSelecionado(acao);
  }

  public fecharPopupSelecionarClienteAcao() {
    this.exibirPopupSelecionarClienteAcao = false;
    this.acaoPendenteSelecaoCliente = null;
  }

  private executarAcaoComClienteSelecionado(acao: string) {
    if (acao == "analise") {
      this.abrirAnaliseCliente();
    } else if (acao == "ligar") {
      this.abrirLigacaoCliente();
    } else if (acao == "pedido") {
      this.abrirNovoPedido();
    }
  }

  public abrirPopupVincularCliente() {
    if (!this.podeVincularCliente()) {
      return;
    }

    this.filtroClienteVinculo = "";
    this.clientesVinculo = [];
    this.clienteVinculoSelecionado = null;
    this.exibirPopupVincularCliente = true;
  }

  /* Troca o cliente ja vinculado: mesmo popup de busca do "Vincular Cliente", sem a checagem de "ainda sem cliente" */
  public abrirPopupTrocarCliente() {
    if (this.atendimentoSelecionado == null || !this.podeGerenciar) {
      return;
    }

    this.filtroClienteVinculo = "";
    this.clientesVinculo = [];
    this.clienteVinculoSelecionado = null;
    this.exibirPopupVincularCliente = true;
  }

  /* Abre a ficha completa do cliente (todas as abas) numa nova aba, para editar ou completar os dados */
  public alterarDadosCliente() {
    if (this.atendimentoSelecionado == null || this.atendimentoSelecionado.client_id == null) {
      return;
    }

    let urlCliente = this.router.serializeUrl(this.router.createUrlTree(["/clientes-cadastro", this.atendimentoSelecionado.client_id]));
    let janelaCliente = window.open(urlCliente, "_blank");

    if (janelaCliente == null) {
      this.toastr.warning("", "O navegador bloqueou a nova aba do cliente. Libere pop-ups para este portal.");
    }
  }

  public desvincularCliente() {
    if (this.atendimentoSelecionado == null || !this.podeGerenciar || this.desvinculandoCliente) {
      return;
    }

    if (!confirm("Remover o vínculo com \"" + this.atendimentoSelecionado.client_name_snapshot + "\"? Você poderá vincular outro cliente em seguida.")) {
      return;
    }

    this.desvinculandoCliente = true;

    this.whatsAppOfficialService.unlinkConversationClient(this.atendimentoSelecionado.id).subscribe(desvinculado => {
      this.desvinculandoCliente = false;

      if (desvinculado) {
        this.toastr.success("", "Vínculo removido.");
        this.atendimentoSelecionado.client_id = null;
        this.atendimentoSelecionado.client_name_snapshot = null;
        this.atendimentoSelecionado.client_codigo_erp_snapshot = null;
        this.atendimentoSelecionado.seller_id_sugerido = null;
        this.atualizarAtendimentoLocal(this.atendimentoSelecionado);
      }
    }, () => this.desvinculandoCliente = false);
  }

  public fecharPopupVincularCliente() {
    this.exibirPopupVincularCliente = false;
    this.filtroClienteVinculo = "";
    this.clientesVinculo = [];
    this.clienteVinculoSelecionado = null;
    this.buscandoClientesVinculo = false;
    this.vinculandoCliente = false;
    this.exibirFormNovoCliente = false;
    this.novoCliente = null;
  }

  public abrirPopupNovoAtendimento() {
    this.modoNovoAtendimento = "cliente";
    this.filtroClienteNovoAtendimento = "";
    this.clientesNovoAtendimento = [];
    this.clienteNovoAtendimentoSelecionado = null;
    this.buscandoClientesNovoAtendimento = false;
    this.abrindoNovoAtendimento = false;
    this.novoAtendimentoTelefoneDdd = "";
    this.novoAtendimentoTelefone = "";
    this.novoAtendimentoNumeroLivre = "";
    this.exibirPopupNovoAtendimento = true;
  }

  public fecharPopupNovoAtendimento() {
    this.exibirPopupNovoAtendimento = false;
    this.modoNovoAtendimento = "cliente";
    this.filtroClienteNovoAtendimento = "";
    this.clientesNovoAtendimento = [];
    this.clienteNovoAtendimentoSelecionado = null;
    this.buscandoClientesNovoAtendimento = false;
    this.abrindoNovoAtendimento = false;
    this.novoAtendimentoTelefoneDdd = "";
    this.novoAtendimentoTelefone = "";
    this.novoAtendimentoNumeroLivre = "";
  }

  public alterarModoNovoAtendimento(modo: string) {
    this.modoNovoAtendimento = modo;
    this.clienteNovoAtendimentoSelecionado = null;
    this.novoAtendimentoTelefoneDdd = "";
    this.novoAtendimentoTelefone = "";
    this.novoAtendimentoNumeroLivre = "";
  }

  public buscarClientesNovoAtendimento() {
    if (this.filtroClienteNovoAtendimento == null || this.filtroClienteNovoAtendimento.trim().length < 2) {
      this.toastr.warning("", "Digite ao menos 2 caracteres para buscar o cliente.");
      return;
    }

    this.buscandoClientesNovoAtendimento = true;
    this.clienteNovoAtendimentoSelecionado = null;

    this.whatsAppOfficialService.searchClientsForManualLink(this.filtroClienteNovoAtendimento).subscribe(
      clientes => this.clientesNovoAtendimento = clientes || [],
      error => { console.log("Erro: " + error) },
      () => this.buscandoClientesNovoAtendimento = false
    );
  }

  public selecionarClienteNovoAtendimento(cliente: WhatsAppOfficialClienteVinculo) {
    this.clienteNovoAtendimentoSelecionado = cliente;
    this.novoAtendimentoTelefoneDdd = this.somenteNumeros(cliente != null ? cliente.fone_whatss_ddd : "");
    this.novoAtendimentoTelefone = this.somenteNumeros(cliente != null ? cliente.fone_whatss : "");
  }

  public abrirOuCriarNovoAtendimento() {
    if (this.abrindoNovoAtendimento) {
      return;
    }

    let clientId: number = null;
    let contatoNome = "";
    let telefone = { ddd: "", numero: "" };

    if (this.modoNovoAtendimento == "cliente") {
      if (this.clienteNovoAtendimentoSelecionado == null) {
        telefone = this.normalizarTelefoneLivre(this.filtroClienteNovoAtendimento);
        contatoNome = telefone.ddd + telefone.numero;
      }
      else {
        clientId = this.clienteNovoAtendimentoSelecionado.id;
        contatoNome = this.clienteNovoAtendimentoSelecionado.name;
        telefone = this.normalizarTelefoneManual(this.novoAtendimentoTelefoneDdd, this.novoAtendimentoTelefone);
      }
    }
    else {
      telefone = this.normalizarTelefoneLivre(this.novoAtendimentoNumeroLivre);
      contatoNome = telefone.ddd + telefone.numero;
    }

    if (telefone.ddd == "" || telefone.numero == "") {
      this.toastr.warning("", "Informe um WhatsApp válido com DDD.");
      return;
    }

    this.abrindoNovoAtendimento = true;

    this.whatsAppOfficialService.openOrCreateConversation(clientId, telefone.ddd, telefone.numero, contatoNome).subscribe(
      atendimento => {
        if (atendimento == null) {
          return;
        }

        this.toastr.success("", "Atendimento aberto com sucesso.");
        this.fecharPopupNovoAtendimento();
        this.atualizarAtendimentoLocal(atendimento);
        this.selecionarAba("conversas");
        this.selecionarAtendimento(atendimento);
      },
      error => { console.log("Erro: " + error) },
      () => this.abrindoNovoAtendimento = false
    );
  }

  public getWhatsappClienteVinculo(cliente: WhatsAppOfficialClienteVinculo): string {
    if (cliente == null) {
      return "";
    }

    let ddd = this.somenteNumeros(cliente.fone_whatss_ddd);
    let telefone = this.somenteNumeros(cliente.fone_whatss);

    if (ddd == "" || telefone == "") {
      return "";
    }

    return "(" + ddd + ") " + telefone;
  }

  public buscarClientesVinculo() {
    if (this.filtroClienteVinculo == null || this.filtroClienteVinculo.trim().length < 2) {
      this.toastr.warning("", "Digite ao menos 2 caracteres para buscar o cliente.");
      return;
    }

    this.buscandoClientesVinculo = true;
    this.clienteVinculoSelecionado = null;

    this.whatsAppOfficialService.searchClientsForManualLink(this.filtroClienteVinculo).subscribe(
      clientes => this.clientesVinculo = clientes || [],
      error => { console.log("Erro: " + error) },
      () => this.buscandoClientesVinculo = false
    );
  }

  public selecionarClienteVinculo(cliente: WhatsAppOfficialClienteVinculo) {
    this.clienteVinculoSelecionado = cliente;
  }

  public vincularClienteSelecionado() {
    if (this.atendimentoSelecionado == null || this.clienteVinculoSelecionado == null) {
      return;
    }

    this.vinculandoCliente = true;

    this.whatsAppOfficialService.linkConversationClient(this.atendimentoSelecionado.id, this.clienteVinculoSelecionado.id).subscribe(
      vinculado => {
        if (!vinculado) {
          return;
        }

        this.toastr.success("", "Cliente vinculado com sucesso.");
        this.aplicarClienteVinculadoLocal(this.clienteVinculoSelecionado);
        this.exibirPopupVincularCliente = false;
        this.exibirPopupVendedorCliente = true;
        this.recarregarAtendimentoSelecionado(false);
      },
      error => { console.log("Erro: " + error) },
      () => this.vinculandoCliente = false
    );
  }

  /* Cadastro rapido de cliente a partir do popup "Vincular Cliente": so os campos essenciais, sem abrir a tela cheia de cadastro */
  public abrirFormNovoCliente() {
    if (this.atendimentoSelecionado == null) {
      return;
    }

    this.novoCliente = new Cliente();
    this.novoCliente.name = "";
    this.novoCliente.efetivo = false;
    this.novoCliente.is_active = true;
    this.novoCliente.guidclientenapis = this.atendimentoSelecionado.guidclientenapis;
    this.novoCliente.seller_id = this.atendimentoSelecionado.seller_id_atual || this.sellerId;

    let telefoneDigitos = (this.atendimentoSelecionado.telefone_normalizado || this.atendimentoSelecionado.telefone || "").replace(/\D/g, "");

    if (telefoneDigitos.length >= 10) {
      let semDdi = telefoneDigitos.startsWith("55") && telefoneDigitos.length > 11 ? telefoneDigitos.substring(2) : telefoneDigitos;
      this.novoCliente.fone_whatss_ddd = semDdi.substring(0, 2);
      this.novoCliente.fone_whatss = semDdi.substring(2);
      this.novoCliente.phone = semDdi;
    }

    this.clientesVinculo = [];
    this.clienteVinculoSelecionado = null;
    this.exibirFormNovoCliente = true;
  }

  public cancelarFormNovoCliente() {
    this.exibirFormNovoCliente = false;
    this.novoCliente = null;
  }

  public cadastrarNovoClienteEVincular() {
    if (this.novoCliente == null || this.atendimentoSelecionado == null || this.cadastrandoCliente) {
      return;
    }

    if (!this.novoCliente.name || this.novoCliente.name.trim() == "") {
      this.toastr.warning("", "Informe a razão social / nome do cliente.");
      return;
    }

    let documento = (this.novoCliente.client_document || "").trim();

    if (documento == "") {
      this.salvarNovoClienteEVincular();
      return;
    }

    this.cadastrandoCliente = true;

    this.clienteService.getByClientDocument(documento).subscribe(clienteExistente => {
      if (clienteExistente != null && clienteExistente.id > 0) {
        this.cadastrandoCliente = false;
        this.toastr.warning("", "Este CNPJ/CPF já está cadastrado na base (cliente: " + clienteExistente.name + "). Busque e vincule esse cliente em vez de cadastrar um novo.");
        return;
      }

      this.salvarNovoClienteEVincular();
    }, () => this.cadastrandoCliente = false);
  }

  private salvarNovoClienteEVincular() {
    this.cadastrandoCliente = true;

    this.clienteService.add(this.novoCliente).subscribe(novoClienteId => {
      this.cadastrandoCliente = false;

      if (!(novoClienteId > 0)) {
        return;
      }

      this.whatsAppOfficialService.linkConversationClient(this.atendimentoSelecionado.id, novoClienteId).subscribe(vinculado => {
        if (!vinculado) {
          return;
        }

        this.toastr.success("", "Cliente cadastrado e vinculado com sucesso.");

        this.aplicarClienteVinculadoLocal({
          id: novoClienteId,
          name: this.novoCliente.name,
          codigo_no_erp_do_cliente: this.novoCliente.codigo_no_erp_do_cliente,
          client_document: this.novoCliente.client_document,
          fantasia: this.novoCliente.fantasia,
          vendedor_interno_nome: null,
          vendedor_interno_id: null,
          fone_whatss_ddd: this.novoCliente.fone_whatss_ddd,
          fone_whatss: this.novoCliente.fone_whatss
        });

        this.exibirFormNovoCliente = false;
        this.novoCliente = null;
        this.exibirPopupVincularCliente = false;
        this.recarregarAtendimentoSelecionado(false);
      });
    }, () => this.cadastrandoCliente = false);
  }

  public fecharPopupVendedorCliente() {
    this.exibirPopupVendedorCliente = false;
  }

  public abrirPopupEncaminhar() {
    if (!this.podeEncaminharAtendimento()) {
      return;
    }

    this.exibirPopupEncaminhar = true;
    this.vendedorEncaminhamentoId = null;
    this.carregarVendedoresEncaminhamento();
  }

  public fecharPopupEncaminhar() {
    this.exibirPopupEncaminhar = false;
    this.vendedorEncaminhamentoId = null;
    this.encaminhandoAtendimento = false;
  }

  public carregarVendedoresEncaminhamento() {
    this.carregandoVendedoresEncaminhamento = true;

    this.whatsAppOfficialService.getForwardSellers().subscribe(
      vendedores => this.vendedoresEncaminhamento = (vendedores || []).filter(vendedor => vendedor.id != this.sellerId),
      error => { console.log("Erro: " + error) },
      () => this.carregandoVendedoresEncaminhamento = false
    );
  }

  private enviarDocumentoAtendimento(arquivo: File, mensagemLocalId: number) {
    if (this.atendimentoSelecionado == null || arquivo == null) {
      this.marcarMensagemLocalComoFalha(mensagemLocalId);
      this.tratarErroEnvioUazapi(this.whatsAppOfficialService.ultimoErroEnvioMensagem);
      return;
    }

    this.whatsAppOfficialService.sendDocumentMessage(this.atendimentoSelecionado.id, arquivo).subscribe(
      mensagem => {
        if (mensagem != null) {
          this.substituirMensagemLocal(mensagemLocalId, mensagem);
        } else {
          this.marcarMensagemLocalComoFalha(mensagemLocalId);
          this.tratarErroEnvioUazapi(this.whatsAppOfficialService.ultimoErroEnvioMensagem);
        }
      },
      error => {
        console.log("Erro: " + error);
        this.marcarMensagemLocalComoFalha(mensagemLocalId);
        this.tratarErroEnvioUazapi(this.whatsAppOfficialService.ultimoErroEnvioMensagem || (error != null ? error.message : ""));
      }
    );
  }

  private enviarImagemAtendimento(arquivo: File, mensagemLocalId: number, caption: string = "") {
    if (this.atendimentoSelecionado == null || arquivo == null) {
      this.marcarMensagemLocalComoFalha(mensagemLocalId);
      this.tratarErroEnvioUazapi(this.whatsAppOfficialService.ultimoErroEnvioMensagem);
      return;
    }

    this.whatsAppOfficialService.sendImageMessage(this.atendimentoSelecionado.id, arquivo, caption).subscribe(
      mensagem => {
        if (mensagem != null) {
          this.substituirMensagemLocal(mensagemLocalId, mensagem);
        } else {
          this.marcarMensagemLocalComoFalha(mensagemLocalId);
          this.tratarErroEnvioUazapi(this.whatsAppOfficialService.ultimoErroEnvioMensagem);
        }
      },
      error => {
        console.log("Erro: " + error);
        this.marcarMensagemLocalComoFalha(mensagemLocalId);
        this.tratarErroEnvioUazapi(this.whatsAppOfficialService.ultimoErroEnvioMensagem || (error != null ? error.message : ""));
      }
    );
  }

  private enviarAudioAtendimento(arquivo: File, mensagemLocalId: number) {
    if (this.atendimentoSelecionado == null || arquivo == null) {
      this.marcarMensagemLocalComoFalha(mensagemLocalId);
      this.tratarErroEnvioUazapi(this.whatsAppOfficialService.ultimoErroEnvioMensagem);
      return;
    }

    this.whatsAppOfficialService.sendAudioMessage(this.atendimentoSelecionado.id, arquivo).subscribe(
      mensagem => {
        if (mensagem != null) {
          this.substituirMensagemLocal(mensagemLocalId, mensagem);
        } else {
          this.marcarMensagemLocalComoFalha(mensagemLocalId);
          this.tratarErroEnvioUazapi(this.whatsAppOfficialService.ultimoErroEnvioMensagem);
        }
      },
      error => {
        console.log("Erro: " + error);
        this.marcarMensagemLocalComoFalha(mensagemLocalId);
        this.tratarErroEnvioUazapi(this.whatsAppOfficialService.ultimoErroEnvioMensagem || (error != null ? error.message : ""));
      }
    );
  }

  public encaminharAtendimento() {
    if (!this.podeEncaminharAtendimento() || this.vendedorEncaminhamentoId == null) {
      this.toastr.warning("", "Selecione o vendedor para encaminhar o atendimento.");
      return;
    }

    this.encaminhandoAtendimento = true;

    this.whatsAppOfficialService.forwardConversation(this.atendimentoSelecionado.id, this.vendedorEncaminhamentoId).subscribe(
      encaminhado => {
        if (!encaminhado) {
          return;
        }

        this.toastr.success("", "Atendimento encaminhado com sucesso.");
        this.fecharPopupEncaminhar();
        this.recarregarAtendimentoSelecionado(false);
      },
      error => { console.log("Erro: " + error) },
      () => this.encaminhandoAtendimento = false
    );
  }

  public vincularClienteAoVendedorInterno() {
    if (this.atendimentoSelecionado == null || this.clienteVinculoSelecionado == null || this.clienteVinculoSelecionado.vendedor_interno_id == null) {
      this.toastr.warning("", "Este cliente nao possui vendedor interno vinculado.");
      return;
    }

    this.vinculandoCliente = true;

    this.whatsAppOfficialService.linkConversationToSuggestedSeller(this.atendimentoSelecionado.id, this.clienteVinculoSelecionado.id).subscribe(
      vinculado => {
        if (vinculado) {
          this.toastr.success("", "Atendimento vinculado ao vendedor interno.");
          this.fecharPopupVendedorCliente();
          this.recarregarAtendimentoSelecionado(false);
        }
      },
      error => { console.log("Erro: " + error) },
      () => this.vinculandoCliente = false
    );
  }

  public capturarAtendimentoAposVinculo() {
    this.fecharPopupVendedorCliente();
    this.capturarAtendimento();
  }

  public conectarTempoReal() {
    this.desconectarTempoReal();

    this.realtimeSubscriptions.push(
      this.whatsAppOfficialRealtimeService.eventosAtualizados().subscribe(payload => {
        this.ngZone.run(() => {
          this.processarEventoTempoRealPayload(payload);
        });
      })
    );

    this.realtimeSubscriptions.push(
      this.whatsAppOfficialRealtimeService.estadoConexaoAtualizado().subscribe(conectado => {
        this.ngZone.run(() => {
          this.tempoRealConectado = conectado;

          if (conectado) {
            this.ultimaAtualizacaoTempoReal = new Date();
          }
        });
      })
    );

    this.whatsAppOfficialRealtimeService.conectar(this.guidclientenapis, this.sellerId);
  }

  public desconectarTempoReal() {
    this.realtimeSubscriptions.forEach(subscription => subscription.unsubscribe());
    this.realtimeSubscriptions = [];
    this.whatsAppOfficialRealtimeService.desconectar();
    this.tempoRealConectado = false;
  }

  public processarEventoTempoReal(data: string) {
    if (data == null || data == "") {
      return;
    }

    this.ultimaAtualizacaoTempoReal = new Date();

    let payload: any = null;

    try {
      payload = JSON.parse(data);
    } catch (error) {
      return;
    }

    if (payload != null && (payload.event_type == "stages_updated" || payload.event_type == "stages_initialized")) {
      this.recarregarEtapasTempoReal();
      return;
    }

    if (payload != null && payload.event_type == "configuration_updated") {
      this.recarregarConfiguracaoTempoReal();
      return;
    }

    if (payload != null && payload.event_type == "message_status_updated") {
      this.aplicarEventoMensagemStatus(payload);
      return;
    }

    if (this.atualizarIndicadorIaGerando(payload)) {
      return;
    }

    if (payload != null && (payload.event_type == "ia_sugestao_criada" || payload.event_type == "ia_sugestao_resolvida")) {
      this.aplicarEventoIaSugestao(payload);
    }

    if (payload != null && payload.conversation != null) {
      this.aplicarEventoConversa(payload);
      return;
    }

    if (payload != null && payload.conversation_id != null) {
      this.sincronizarMensagensDaConversaAtiva(payload);
    }
  }

  public processarEventoTempoRealPayload(payload: any) {
    if (payload == null) {
      return;
    }

    this.ultimaAtualizacaoTempoReal = new Date();

    if (payload.event_type == "stages_updated" || payload.event_type == "stages_initialized") {
      this.recarregarEtapasTempoReal();
      return;
    }

    if (payload.event_type == "configuration_updated") {
      this.recarregarConfiguracaoTempoReal();
      return;
    }

    if (payload.event_type == "message_status_updated") {
      this.aplicarEventoMensagemStatus(payload);
      return;
    }

    if (this.atualizarIndicadorIaGerando(payload)) {
      return;
    }

    if (payload.event_type == "ia_sugestao_criada" || payload.event_type == "ia_sugestao_resolvida") {
      this.aplicarEventoIaSugestao(payload);
    }

    if (payload.conversation != null) {
      this.aplicarEventoConversa(payload);
      return;
    }

    if (payload.conversation_id != null) {
      this.sincronizarMensagensDaConversaAtiva(payload);
    }
  }

  private recarregarConfiguracaoTempoReal() {
    this.whatsAppOfficialService.getConfiguration().subscribe(
      configuracao => this.configuracao = configuracao,
      error => { console.log("Erro: " + error) }
    );
  }

  private processarParametrosRota() {
    this.routeSubscription = this.route.queryParams.subscribe(parametros => {
      let atendimento = parametros["atendimento"];
      let pedido = parametros["pedido"];
      let acao = parametros["pedido_acao"];
      const vendedorPedido = Number(parametros["pedido_vendedor"]);

      this.atendimentoRetornoId = null;
      this.limparRetornoPedido();

      if (Number.isInteger(vendedorPedido) && vendedorPedido > 0) {
        this.pedidoRetornoVendedorId = vendedorPedido;
      }

      if (atendimento != null && !isNaN(parseInt(atendimento)) && isFinite(parseInt(atendimento))) {
        this.atendimentoRetornoId = parseInt(atendimento);
        this.pedidoRetornoAtendimentoId = this.atendimentoRetornoId;
      }

      if (pedido != null && !isNaN(parseInt(pedido)) && isFinite(parseInt(pedido))) {
        this.pedidoRetornoNumero = parseInt(pedido);
        this.pedidoRetornoMensagem = this.getMensagemRetornoPedido(acao);
      }

      this.abrirAtendimentoRetornoPendente();
    });
  }

  private abrirAtendimentoRetornoPendente() {
    if (this.atendimentoRetornoId == null || this.inbox == null) {
      return;
    }

    if (this.atendimentoSelecionado != null && this.atendimentoSelecionado.id == this.atendimentoRetornoId) {
      this.atendimentoRetornoId = null;
      return;
    }

    let atendimento = this.inbox.find(x => x.id == this.atendimentoRetornoId);

    if (atendimento == null) {
      let atendimentoId = this.atendimentoRetornoId;
      this.atendimentoRetornoId = null;

      this.whatsAppOfficialService.getConversationById(atendimentoId).subscribe(
        atendimentoRetorno => {
          if (atendimentoRetorno == null) {
            return;
          }

          this.inbox = [atendimentoRetorno].concat(this.inbox.filter(x => x.id != atendimentoRetorno.id));
          this.selecionarAba("conversas");
          this.selecionarAtendimento(atendimentoRetorno);
        },
        error => { console.log("Erro: " + error) }
      );

      return;
    }

    this.selecionarAba("conversas");
    this.selecionarAtendimento(atendimento);
    this.atendimentoRetornoId = null;
  }

  private getMensagemRetornoPedido(acao: string): string {
    if (acao == "salvar_enviar") {
      return "Pedido enviado com sucesso.";
    }

    if (acao == "imprimir") {
      return "Pedido impresso com sucesso.";
    }

    return "Pedido salvo com sucesso.";
  }

  private recarregarEtapasTempoReal() {
    this.whatsAppOfficialService.getStages().subscribe(
      etapas => this.etapas = etapas,
      error => { console.log("Erro: " + error) }
    );
  }

  private atualizarInboxKanbanTempoReal() {
    this.whatsAppOfficialService.getInbox().subscribe(
      inbox => {
        this.inbox = this.ordenarInboxLocal((inbox || []).map(atendimento => this.normalizarJanelaAtendimento(atendimento)));

        if (this.atendimentoSelecionado != null) {
          let atendimentoAtualizado = this.inbox.find(x => x.id == this.atendimentoSelecionado.id);

          if (atendimentoAtualizado != null) {
            this.atendimentoSelecionado = atendimentoAtualizado;
            this.etapaDestinoId = atendimentoAtualizado.whatsapp_oficial_etapa_id;
            this.motivoPerdaId = atendimentoAtualizado.no_order_done_reason_id;
            this.complementoPerda = atendimentoAtualizado.motivo_perda_complemento || "";
          }
        }
      },
      error => { console.log("Erro: " + error) }
    );

    this.whatsAppOfficialService.getKanban().subscribe(
      kanban => this.kanban = this.normalizarJanelaKanban(kanban),
      error => { console.log("Erro: " + error) }
    );
  }

  private normalizarJanelaKanban(kanban: WhatsAppOfficialKanban): WhatsAppOfficialKanban {
    if (kanban != null && kanban.atendimentos != null) {
      kanban.atendimentos = kanban.atendimentos.map(atendimento => this.normalizarJanelaAtendimento(atendimento));
    }

    return kanban;
  }

  private normalizarJanelaAtendimento(
    atendimento: WhatsAppOfficialAtendimento,
    atendimentoAnterior: WhatsAppOfficialAtendimento = null
  ): WhatsAppOfficialAtendimento {
    if (atendimento == null) {
      return atendimento;
    }

    let atendimentoNormalizado = Object.assign(new WhatsAppOfficialAtendimento(), atendimento);
    let dataAtualizada = this.parseDataAtendimento(atendimentoNormalizado.dt_ultima_mensagem_cliente);
    let dataAnterior = atendimentoAnterior != null ? this.parseDataAtendimento(atendimentoAnterior.dt_ultima_mensagem_cliente) : null;

    if (this.isSellerOficial()) {
      atendimentoNormalizado.is_uazapi = false;
    }

    if (this.isSellerUazapi()) {
      atendimentoNormalizado.is_uazapi = true;
    }

    if (
      atendimentoAnterior != null &&
      atendimentoAnterior.is_uazapi === true &&
      atendimentoNormalizado.is_uazapi !== false &&
      !this.isSellerOficial()
    ) {
      atendimentoNormalizado.is_uazapi = true;
    }

    if (atendimentoNormalizado.is_uazapi === true) {
      atendimentoNormalizado.janela_24h_aberta = true;
      return atendimentoNormalizado;
    }

    if (
      atendimentoAnterior != null &&
      atendimentoNormalizado.seller_id_atual == atendimentoAnterior.seller_id_atual &&
      (atendimentoNormalizado.seller_nome_atual == null || atendimentoNormalizado.seller_nome_atual == "")
    ) {
      atendimentoNormalizado.seller_nome_atual = atendimentoAnterior.seller_nome_atual;
    }

    if ((dataAtualizada == null || isNaN(dataAtualizada.getTime())) && dataAnterior != null && !isNaN(dataAnterior.getTime())) {
      atendimentoNormalizado.dt_ultima_mensagem_cliente = atendimentoAnterior.dt_ultima_mensagem_cliente;
      dataAtualizada = dataAnterior;
    }

    if (atendimentoNormalizado.janela_24h_aberta != true && dataAtualizada != null && !isNaN(dataAtualizada.getTime())) {
      let diferencaMs = new Date().getTime() - dataAtualizada.getTime();
      atendimentoNormalizado.janela_24h_aberta = diferencaMs >= 0 && diferencaMs <= (24 * 60 * 60 * 1000);
    }

    if (atendimentoAnterior != null && atendimentoAnterior.janela_24h_aberta == true && this.isJanelaAtendimentoClienteAberta(atendimentoNormalizado)) {
      atendimentoNormalizado.janela_24h_aberta = true;
    }

    return atendimentoNormalizado;
  }

  private sincronizarAtendimentoSelecionadoTempoReal() {
    if (this.atendimentoSelecionado == null) {
      return;
    }

    this.whatsAppOfficialService.getConversationById(this.atendimentoSelecionado.id).subscribe(
      atendimento => {
        if (atendimento != null) {
          this.atualizarAtendimentoLocal(atendimento);
        }
      },
      error => { console.log("Erro: " + error) }
    );
  }

  private atualizarJanelaPelaUltimaMensagemRecebidaLocal(conversationId: number) {
    let ultimaMensagemCliente: WhatsAppOfficialMensagem = null;
    let ultimaDataCliente: Date = null;

    (this.mensagens || []).forEach(mensagem => {
      if (mensagem == null || mensagem.whatsapp_oficial_atendimento_id != conversationId || mensagem.direction != "INBOUND") {
        return;
      }

      let dataMensagem = this.parseDataAtendimento(mensagem.dt_mensagem);

      if (dataMensagem == null || isNaN(dataMensagem.getTime())) {
        return;
      }

      if (ultimaDataCliente == null || dataMensagem.getTime() > ultimaDataCliente.getTime()) {
        ultimaDataCliente = dataMensagem;
        ultimaMensagemCliente = mensagem;
      }
    });

    if (ultimaMensagemCliente != null) {
      this.atualizarUltimaMensagemClienteLocal(conversationId, ultimaMensagemCliente.dt_mensagem);
    }
  }

  private aplicarEventoConversa(payload: any) {
    let atendimento = this.mapearAtendimentoTempoReal(payload.conversation);

    if (atendimento == null) {
      this.atualizarInboxKanbanTempoReal();
      return;
    }

    let deveSelecionarNovoAtendimento = this.deveTrocarAtendimentoConcluidoPorNovo(atendimento, payload.event_type);

    this.atualizarAtendimentoLocal(atendimento);

    if (deveSelecionarNovoAtendimento) {
      this.selecionarAtendimentoTempoReal(atendimento);
    }

    let mensagemRecebidaNaConversaSelecionada =
      payload.event_type == "message_received" &&
      this.atendimentoSelecionado != null &&
      this.atendimentoSelecionado.id == atendimento.id;

    if (payload.message != null) {
      let mensagem = this.mapearMensagemTempoReal(payload.message);

      if (mensagem != null) {
        this.upsertMensagemLocal(mensagem);

        if (payload.event_type != "message_edited" && payload.event_type != "message_deleted" && (mensagem.direction == "INBOUND" || mensagemRecebidaNaConversaSelecionada) && this.atendimentoSelecionado != null && this.atendimentoSelecionado.id == atendimento.id) {
          this.atualizarUltimaMensagemClienteLocal(atendimento.id, mensagem.dt_mensagem);
          this.marcarAtendimentoComoLido(atendimento.id);
        }
      }
    }

    if (mensagemRecebidaNaConversaSelecionada) {
      let dataJanelaCliente = atendimento.dt_ultima_mensagem_cliente || atendimento.dt_ultima_mensagem;

      if (dataJanelaCliente != null) {
        this.atualizarUltimaMensagemClienteLocal(atendimento.id, dataJanelaCliente);
      }
    }

    if (
      this.atendimentoSelecionado != null &&
      this.atendimentoSelecionado.id == atendimento.id &&
      payload.event_type == "message_received"
    ) {
      this.carregarMensagens(atendimento.id, false, true, true);
    }
  }

  private aplicarEventoMensagemStatus(payload: any) {
    let mensagem = this.mapearMensagemTempoReal(payload != null ? payload.message : null);

    if (mensagem == null) {
      return;
    }

    let atualizouLocalmente = this.atualizarStatusMensagemLocal(mensagem);

    if (payload != null && payload.conversation != null) {
      this.atualizarAtendimentoLocal(this.mapearAtendimentoTempoReal(payload.conversation));
    }

    if (!atualizouLocalmente && this.atendimentoSelecionado != null && mensagem.whatsapp_oficial_atendimento_id == this.atendimentoSelecionado.id) {
      this.carregarMensagens(this.atendimentoSelecionado.id, false, true);
    }
  }

  private sincronizarMensagensDaConversaAtiva(payload: any) {
    if (payload == null || this.atendimentoSelecionado == null || payload.conversation_id == null) {
      return;
    }

    if (Number(payload.conversation_id) != Number(this.atendimentoSelecionado.id)) {
      return;
    }

    this.carregarMensagens(this.atendimentoSelecionado.id, false, true, true);
  }

  private deveUsarPollingDeContingencia(): boolean {
    if (this.ultimaAtualizacaoTempoReal == null) {
      return true;
    }

    let diferencaSegundos = (new Date().getTime() - this.ultimaAtualizacaoTempoReal.getTime()) / 1000;
    return diferencaSegundos >= 120;
  }

  private criarMensagemOtimista(texto: string, isInterna: boolean = false): WhatsAppOfficialMensagem {
    let mensagem = new WhatsAppOfficialMensagem();

    mensagem.id = -new Date().getTime();
    mensagem.whatsapp_oficial_atendimento_id = this.atendimentoSelecionado.id;
    mensagem.direction = "OUTBOUND";
    mensagem.message_type = "TEXT";
    mensagem.is_internal = isInterna;
    mensagem.internal_type = isInterna ? "INTERNAL_NOTE" : null;
    mensagem.texto = texto;
    mensagem.status_whatsapp = isInterna ? "internal" : "delivering";
    mensagem.dt_mensagem = new Date();
    mensagem.created_at = new Date();

    if (this.mensagemRespondendoA != null) {
      mensagem.reply_to_message_id = this.mensagemRespondendoA.id;
      mensagem.reply_to_preview = this.mensagemRespondendoA.texto;
    }

    return mensagem;
  }

  private criarMensagemDocumentoOtimista(arquivo: File): WhatsAppOfficialMensagem {
    let mensagem = new WhatsAppOfficialMensagem();

    mensagem.id = -new Date().getTime();
    mensagem.whatsapp_oficial_atendimento_id = this.atendimentoSelecionado.id;
    mensagem.direction = "OUTBOUND";
    mensagem.message_type = "DOCUMENT";
    mensagem.texto = arquivo.name || "[Documento]";
    mensagem.file_name = arquivo.name;
    mensagem.mime_type = arquivo.type;
    mensagem.status_whatsapp = "delivering";
    mensagem.dt_mensagem = new Date();
    mensagem.created_at = new Date();
    mensagem.local_file = arquivo;

    return mensagem;
  }

  private criarMensagemImagemOtimista(arquivo: File, legenda: string = ""): WhatsAppOfficialMensagem {
    let mensagem = new WhatsAppOfficialMensagem();
    let legendaNormalizada = (legenda || "").trim();

    mensagem.id = -new Date().getTime();
    mensagem.whatsapp_oficial_atendimento_id = this.atendimentoSelecionado.id;
    mensagem.direction = "OUTBOUND";
    mensagem.message_type = "IMAGE";
    mensagem.texto = legendaNormalizada || "[Imagem]";
    mensagem.file_name = arquivo.name;
    mensagem.mime_type = arquivo.type;
    mensagem.status_whatsapp = "delivering";
    mensagem.dt_mensagem = new Date();
    mensagem.created_at = new Date();
    mensagem.local_file = arquivo;
    mensagem.local_preview_url = URL.createObjectURL(arquivo);
    mensagem.payload_json = JSON.stringify({
      content_type: "image",
      file_name: arquivo.name,
      mime_type: arquivo.type,
      caption: legendaNormalizada
    });

    return mensagem;
  }

  private criarMensagemAudioOtimista(arquivo: File, previewUrl: string): WhatsAppOfficialMensagem {
    let mensagem = new WhatsAppOfficialMensagem();

    mensagem.id = -new Date().getTime();
    mensagem.whatsapp_oficial_atendimento_id = this.atendimentoSelecionado.id;
    mensagem.direction = "OUTBOUND";
    mensagem.message_type = "AUDIO";
    mensagem.texto = "[Áudio]";
    mensagem.file_name = arquivo.name;
    mensagem.mime_type = arquivo.type;
    mensagem.status_whatsapp = "delivering";
    mensagem.dt_mensagem = new Date();
    mensagem.created_at = new Date();
    mensagem.local_file = arquivo;
    mensagem.local_preview_url = previewUrl;

    return mensagem;
  }

  private isTextoMensagemInterna(texto: string): boolean {
    return texto != null && texto.trim().indexOf("#") == 0;
  }

  private limparPrefixoMensagemInterna(texto: string): string {
    return (texto || "").trim().replace(/^#+\s*/, "");
  }

  private adicionarMensagemLocal(mensagem: WhatsAppOfficialMensagem) {
    this.mensagens = [...(this.mensagens || []), mensagem];
    this.rolarMensagensParaFim();
  }

  private limparNaoLidasAtendimento(atendimentoId: number) {
    this.inbox = (this.inbox || []).map(atendimento => {
      if (atendimento.id == atendimentoId) {
        return Object.assign(new WhatsAppOfficialAtendimento(), atendimento, { qtde_mensagens_nao_lidas: 0 });
      }

      return atendimento;
    });

    if (this.kanban != null && this.kanban.atendimentos != null) {
      this.kanban.atendimentos = this.kanban.atendimentos.map(atendimento => {
        if (atendimento.id == atendimentoId) {
          return Object.assign(new WhatsAppOfficialAtendimento(), atendimento, { qtde_mensagens_nao_lidas: 0 });
        }

        return atendimento;
      });
    }

    if (this.atendimentoSelecionado != null && this.atendimentoSelecionado.id == atendimentoId) {
      this.atendimentoSelecionado.qtde_mensagens_nao_lidas = 0;
    }
  }

  private marcarAtendimentoComoLido(atendimentoId: number) {
    this.limparNaoLidasAtendimento(atendimentoId);

    this.whatsAppOfficialService.markConversationAsRead(atendimentoId).subscribe(
      () => { },
      error => { console.log("Erro: " + error) }
    );
  }

  private marcarMensagemLocalComoFalha(id: number) {
    this.mensagens = (this.mensagens || []).map(mensagem => {
      if (mensagem.id == id) {
        mensagem.status_whatsapp = "failed";
      }

      return mensagem;
    });
  }

  private substituirMensagemLocal(idLocal: number, mensagemServidor: WhatsAppOfficialMensagem) {
    this.mensagens = (this.mensagens || []).map(mensagem => {
      if (mensagem.id == idLocal) {
        let mensagemMesclada = mesclarEstadoMensagem(mensagem, mensagemServidor);
        mensagemMesclada.local_file = mensagem.local_file;
        mensagemMesclada.local_preview_url = mensagem.local_preview_url;
        mensagemMesclada.file_name = mensagemServidor.file_name || mensagem.file_name || this.getNomeDocumento(mensagemServidor);
        mensagemMesclada.media_url = mensagemServidor.media_url || this.getUrlDocumento(mensagemServidor) || this.getUrlImagem(mensagemServidor) || this.getUrlAudio(mensagemServidor);

        if (mensagemMesclada.media_url) {
          mensagemMesclada.local_preview_url = null;
        }

        return mensagemMesclada;
      }

      return mensagem;
    });

    this.rolarMensagensParaFim();
  }

  private atualizarPreviewAtendimentoLocal(atendimentoId: number, preview: string) {
    if (this.atendimentoSelecionado != null && this.atendimentoSelecionado.id == atendimentoId) {
      this.atendimentoSelecionado.ultima_mensagem_preview = preview;
      this.atendimentoSelecionado.dt_ultima_mensagem = new Date();
    }

    this.inbox = (this.inbox || []).map(atendimento => {
      if (atendimento.id == atendimentoId) {
        atendimento.ultima_mensagem_preview = preview;
        atendimento.dt_ultima_mensagem = new Date();
      }

      return atendimento;
    });
  }

  private mapearAtendimentoTempoReal(source: any): WhatsAppOfficialAtendimento {
    if (source == null) {
      return null;
    }

    return Object.assign(new WhatsAppOfficialAtendimento(), source);
  }

  private mapearMensagemTempoReal(source: any): WhatsAppOfficialMensagem {
    if (source == null) {
      return null;
    }

    let mensagem = Object.assign(new WhatsAppOfficialMensagem(), source);
    let payload = this.getPayloadMensagem(mensagem);

    mensagem.media_url = mensagem.media_url || payload.media_url;
    mensagem.file_name = mensagem.file_name || payload.file_name;
    mensagem.mime_type = mensagem.mime_type || payload.mime_type;

    return mensagem;
  }

  private atualizarAtendimentoLocal(atualizado: WhatsAppOfficialAtendimento) {
    if (atualizado == null) {
      return;
    }

    let encontrouInbox = false;
    this.inbox = (this.inbox || []).map(atendimento => {
      if (atendimento.id == atualizado.id) {
        encontrouInbox = true;
        return this.normalizarJanelaAtendimento(
          Object.assign(new WhatsAppOfficialAtendimento(), atendimento, atualizado),
          atendimento
        );
      }

      return atendimento;
    });

    if (!encontrouInbox) {
      this.inbox = [this.normalizarJanelaAtendimento(atualizado), ...(this.inbox || [])];
    }

    this.inbox = this.ordenarInboxLocal(this.inbox);
    this.removerAtendimentosConcluidosDuplicadosPorTelefone(atualizado);

    if (this.atendimentoSelecionado != null && this.atendimentoSelecionado.id == atualizado.id) {
      this.atendimentoSelecionado = this.normalizarJanelaAtendimento(
        Object.assign(new WhatsAppOfficialAtendimento(), this.atendimentoSelecionado, atualizado),
        this.atendimentoSelecionado
      );
      this.etapaDestinoId = this.atendimentoSelecionado.whatsapp_oficial_etapa_id;
      this.motivoPerdaId = this.atendimentoSelecionado.no_order_done_reason_id;
      this.complementoPerda = this.atendimentoSelecionado.motivo_perda_complemento || "";
    }

    if (this.kanban != null && this.kanban.atendimentos != null) {
      let encontrouKanban = false;
      this.kanban.atendimentos = this.kanban.atendimentos.map(atendimento => {
        if (atendimento.id == atualizado.id) {
          encontrouKanban = true;
          return this.normalizarJanelaAtendimento(
            Object.assign(new WhatsAppOfficialAtendimento(), atendimento, atualizado),
            atendimento
          );
        }

        return atendimento;
      });

      if (!encontrouKanban) {
        this.kanban.atendimentos = [this.normalizarJanelaAtendimento(atualizado), ...this.kanban.atendimentos];
      }

      this.kanban.atendimentos = this.filtrarAtendimentosConcluidosDuplicadosPorTelefone(this.kanban.atendimentos, atualizado);
    }
  }

  private deveTrocarAtendimentoConcluidoPorNovo(atendimento: WhatsAppOfficialAtendimento, eventType: string): boolean {
    return eventType == "message_received" &&
      this.atendimentoSelecionado != null &&
      this.atendimentoSelecionado.id != atendimento.id &&
      this.isAtendimentoConcluido(this.atendimentoSelecionado) &&
      this.isMesmoTelefone(this.atendimentoSelecionado, atendimento);
  }

  private selecionarAtendimentoTempoReal(atendimento: WhatsAppOfficialAtendimento) {
    this.atendimentoSelecionado = atendimento;
    this.etapaDestinoId = atendimento.whatsapp_oficial_etapa_id;
    this.exibirFormularioPerda = false;
    this.motivoPerdaId = atendimento.no_order_done_reason_id;
    this.complementoPerda = atendimento.motivo_perda_complemento || "";
    this.carregarMensagens(atendimento.id, false, true);
  }

  private removerAtendimentosConcluidosDuplicadosPorTelefone(atualizado: WhatsAppOfficialAtendimento) {
    this.inbox = this.filtrarAtendimentosConcluidosDuplicadosPorTelefone(this.inbox, atualizado);
  }

  private filtrarAtendimentosConcluidosDuplicadosPorTelefone(atendimentos: WhatsAppOfficialAtendimento[], atualizado: WhatsAppOfficialAtendimento): WhatsAppOfficialAtendimento[] {
    if (atendimentos == null || atualizado == null || atualizado.etapa_tipo != "ABERTO") {
      return atendimentos || [];
    }

    return atendimentos.filter(atendimento =>
      atendimento.id == atualizado.id ||
      !this.isMesmoTelefone(atendimento, atualizado) ||
      !this.isAtendimentoConcluido(atendimento)
    );
  }

  private isMesmoTelefone(atendimentoA: WhatsAppOfficialAtendimento, atendimentoB: WhatsAppOfficialAtendimento): boolean {
    let telefoneA = this.normalizarTelefoneAtendimento(atendimentoA);
    let telefoneB = this.normalizarTelefoneAtendimento(atendimentoB);

    return telefoneA != "" && telefoneA == telefoneB;
  }

  private normalizarTelefoneAtendimento(atendimento: WhatsAppOfficialAtendimento): string {
    if (atendimento == null) {
      return "";
    }

    return (atendimento.telefone_normalizado || atendimento.telefone || "").replace(/\D/g, "");
  }

  private somenteNumeros(valor: string): string {
    return (valor || "").replace(/\D/g, "");
  }

  private normalizarTelefoneManual(ddd: string, telefone: string): any {
    let dddLimpo = this.somenteNumeros(ddd);
    let telefoneLimpo = this.somenteNumeros(telefone);

    if (telefoneLimpo.length > 11 && telefoneLimpo.indexOf("55") == 0) {
      telefoneLimpo = telefoneLimpo.substring(2);
    }

    if (dddLimpo == "" && telefoneLimpo.length >= 10) {
      dddLimpo = telefoneLimpo.substring(0, 2);
      telefoneLimpo = telefoneLimpo.substring(2);
    }

    return {
      ddd: dddLimpo.length >= 2 ? dddLimpo.substring(0, 2) : "",
      numero: telefoneLimpo
    };
  }

  private normalizarTelefoneLivre(numeroLivre: string): any {
    let telefone = this.somenteNumeros(numeroLivre);

    if (telefone.length > 11 && telefone.indexOf("55") == 0) {
      telefone = telefone.substring(2);
    }

    if (telefone.length < 10) {
      return { ddd: "", numero: "" };
    }

    return {
      ddd: telefone.substring(0, 2),
      numero: telefone.substring(2)
    };
  }

  private upsertMensagemLocal(mensagemAtualizada: WhatsAppOfficialMensagem) {
    if (mensagemAtualizada == null) {
      return;
    }

    if (this.atendimentoSelecionado == null || this.atendimentoSelecionado.id != mensagemAtualizada.whatsapp_oficial_atendimento_id) {
      return;
    }

    let indiceMensagemExistente = (this.mensagens || []).findIndex(mensagem =>
      (mensagemAtualizada.id != null && mensagem.id == mensagemAtualizada.id) ||
      (!!mensagemAtualizada.wamid && mensagem.wamid == mensagemAtualizada.wamid) ||
      this.isMensagemOtimistaCorrespondente(mensagem, mensagemAtualizada)
    );

    if (indiceMensagemExistente > -1) {
      let mensagemLocal = this.mensagens[indiceMensagemExistente];
      let mensagemMesclada = mesclarEstadoMensagem(mensagemLocal, mensagemAtualizada);
      if (!mensagemMesclada.dt_editada) mensagemMesclada.texto = this.resolverTextoMensagemAtualizada(mensagemLocal, mensagemAtualizada);
      this.mensagens[indiceMensagemExistente] = mensagemMesclada;
      this.mensagens = [...this.mensagens];
      this.rolarMensagensParaFim();
      return;
    }

    this.mensagens = [...(this.mensagens || []), mensagemAtualizada];
    this.rolarMensagensParaFim();
  }

  private rolarMensagensParaFim() {
    setTimeout(() => {
      if (this.mensagensContainer == null || this.mensagensContainer.nativeElement == null) {
        return;
      }

      let elemento = this.mensagensContainer.nativeElement;
      elemento.scrollTop = elemento.scrollHeight;
    }, 0);
  }

  private atualizarStatusMensagemLocal(mensagemAtualizada: WhatsAppOfficialMensagem): boolean {
    if (mensagemAtualizada == null) {
      return false;
    }

    let atualizou = false;

    this.mensagens = (this.mensagens || []).map(mensagem =>
      {
        if (!this.isMesmaMensagemLocal(mensagem, mensagemAtualizada)) {
          return mensagem;
        }

        atualizou = true;

        if (this.getStatusRank(mensagemAtualizada.status_whatsapp) < this.getStatusRank(mensagem.status_whatsapp)) {
          return mensagem;
        }

        let mensagemMesclada = mesclarEstadoMensagem(mensagem, mensagemAtualizada);
        if (!mensagemMesclada.dt_editada) mensagemMesclada.texto = this.resolverTextoMensagemAtualizada(mensagem, mensagemAtualizada);

        return mensagemMesclada;
      }
    );

    return atualizou;
  }

  private getStatusRank(statusWhatsapp: string): number {
    switch ((statusWhatsapp || "").toLowerCase()) {
      case "failed":
        return 0;
      case "sent":
        return 1;
      case "delivered":
        return 2;
      case "read":
        return 3;
      default:
        return 1;
    }
  }

  private ordenarInboxLocal(inbox: WhatsAppOfficialAtendimento[]): WhatsAppOfficialAtendimento[] {
    return (inbox || []).slice().sort((a, b) => {
      let dataA = a != null && a.dt_ultima_mensagem != null ? new Date(a.dt_ultima_mensagem).getTime() : 0;
      let dataB = b != null && b.dt_ultima_mensagem != null ? new Date(b.dt_ultima_mensagem).getTime() : 0;

      return dataB - dataA;
    });
  }

  private extrairMensagemComAtendente(texto: string): any {
    if (texto == null || texto == "") {
      return null;
    }

    let match = texto.match(/^\*([^*]+):\*\r?\n([\s\S]*)$/);

    if (match == null) {
      return null;
    }

    return {
      nome: match[1],
      texto: match[2]
    };
  }

  private normalizarTextoMensagem(texto: string): string {
    return (texto || "").replace(/\r\n/g, "\n").trim();
  }

  private getPayloadMensagem(mensagem: WhatsAppOfficialMensagem): any {
    if (mensagem == null || mensagem.payload_json == null || mensagem.payload_json == "") {
      return {};
    }

    try {
      return JSON.parse(mensagem.payload_json);
    } catch {
      return {};
    }
  }

  private isDocumentoPermitido(arquivo: File): boolean {
    if (arquivo == null || arquivo.name == null) {
      return false;
    }

    let extensao = arquivo.name.split(".").pop().toLowerCase();
    return ["pdf", "doc", "docx", "xls", "xlsx", "txt", "csv", "ppt", "pptx"].indexOf(extensao) >= 0;
  }

  private isImagemPermitida(arquivo: File): boolean {
    if (arquivo == null) {
      return false;
    }

    let mimeType = (arquivo.type || "").toLowerCase();

    if (["image/jpeg", "image/png", "image/webp"].indexOf(mimeType) >= 0) {
      return true;
    }

    if (arquivo.name == null || arquivo.name == "") {
      return false;
    }

    let extensao = arquivo.name.split(".").pop().toLowerCase();
    return ["jpg", "jpeg", "png", "webp"].indexOf(extensao) >= 0;
  }

  private normalizarImagemClipboard(arquivo: File): File {
    if (arquivo == null) {
      return arquivo;
    }

    let nomeAtual = arquivo.name || "";

    if (/\.(jpg|jpeg|png|webp)$/i.test(nomeAtual)) {
      return arquivo;
    }

    let extensao = this.getExtensaoImagemPorMimeType(arquivo.type);
    let nome = "recorte-tela-" + this.formatarDataArquivo(new Date()) + extensao;

    try {
      return new File([arquivo], nome, { type: arquivo.type || "image/png" });
    } catch {
      return arquivo;
    }
  }

  private getExtensaoImagemPorMimeType(mimeType: string): string {
    switch ((mimeType || "").toLowerCase()) {
      case "image/jpeg":
        return ".jpg";
      case "image/webp":
        return ".webp";
      case "image/png":
      default:
        return ".png";
    }
  }

  private formatarDataArquivo(data: Date): string {
    let pad = (valor: number) => valor < 10 ? "0" + valor : valor.toString();

    return data.getFullYear().toString() +
      pad(data.getMonth() + 1) +
      pad(data.getDate()) +
      "-" +
      pad(data.getHours()) +
      pad(data.getMinutes()) +
      pad(data.getSeconds());
  }

  private async carregarGravadorAudio() {
    if (this.recorderAudioModule != null) {
      return;
    }

    if (typeof MicRecorder != "undefined" && MicRecorder != null) {
      this.recorderAudioModule = MicRecorder;
      return;
    }

    const modulo = require("mic-recorder-to-mp3");
    this.recorderAudioModule = modulo.default || modulo.MicRecorder || modulo;

    if (this.recorderAudioModule != null && this.recorderAudioModule.default != null) {
      this.recorderAudioModule = this.recorderAudioModule.default;
    }

    if (this.recorderAudioModule == null || typeof this.recorderAudioModule != "function") {
      throw new Error("Gravador MP3 não foi carregado.");
    }
  }

  private async validarSuporteMicrofone() {
    if (window == null || navigator == null || navigator.mediaDevices == null || navigator.mediaDevices.getUserMedia == null) {
      throw new Error("Este navegador não suporta gravação de áudio ou a página não está em HTTPS/localhost.");
    }

    if (window.location.protocol != "https:" && window.location.hostname != "localhost" && window.location.hostname != "127.0.0.1") {
      throw new Error("O microfone só pode ser usado em HTTPS ou localhost.");
    }

    let stream = await navigator.mediaDevices.getUserMedia({ audio: true });

    if (stream != null) {
      stream.getTracks().forEach(track => track.stop());
    }
  }

  private async finalizarAudioMp3(): Promise<File> {
    let resultado = await this.recorderAudio.stop().getMp3();
    let buffer = resultado[0];
    let blob = resultado[1];

    return new File(buffer, "audio.mp3", {
      type: blob.type || "audio/mpeg",
      lastModified: Date.now()
    });
  }

  private atualizarUltimaMensagemClienteLocal(atendimentoId: number, dataMensagem: Date) {
    if (atendimentoId == null || dataMensagem == null) {
      return;
    }

    if (this.atendimentoSelecionado != null && this.atendimentoSelecionado.id == atendimentoId) {
      this.atendimentoSelecionado.dt_ultima_mensagem_cliente = dataMensagem;
      this.atendimentoSelecionado.dt_ultima_mensagem = dataMensagem;
      this.atendimentoSelecionado.janela_24h_aberta = true;
    }

    this.inbox = (this.inbox || []).map(atendimento => {
      if (atendimento.id == atendimentoId) {
        atendimento.dt_ultima_mensagem_cliente = dataMensagem;
        atendimento.dt_ultima_mensagem = dataMensagem;
        atendimento.janela_24h_aberta = true;
      }

      return atendimento;
    });

    if (this.kanban != null && this.kanban.atendimentos != null) {
      this.kanban.atendimentos = this.kanban.atendimentos.map(atendimento => {
        if (atendimento.id == atendimentoId) {
          atendimento.dt_ultima_mensagem_cliente = dataMensagem;
          atendimento.dt_ultima_mensagem = dataMensagem;
          atendimento.janela_24h_aberta = true;
        }

        return atendimento;
      });
    }
  }

  private parseDataAtendimento(valor: any): Date {
    if (valor == null || valor == "") {
      return null;
    }

    if (valor instanceof Date) {
      return valor;
    }

    let texto = valor.toString().trim();
    let matchDataBr = texto.match(/^(\d{2})\/(\d{2})\/(\d{4})(?:\s+(\d{2}):(\d{2})(?::(\d{2}))?)?$/);

    if (matchDataBr != null) {
      let dia = parseInt(matchDataBr[1], 10);
      let mes = parseInt(matchDataBr[2], 10) - 1;
      let ano = parseInt(matchDataBr[3], 10);
      let hora = matchDataBr[4] != null ? parseInt(matchDataBr[4], 10) : 0;
      let minuto = matchDataBr[5] != null ? parseInt(matchDataBr[5], 10) : 0;
      let segundo = matchDataBr[6] != null ? parseInt(matchDataBr[6], 10) : 0;

      return new Date(ano, mes, dia, hora, minuto, segundo);
    }

    let matchDataSql = texto.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T\s](\d{2}):(\d{2})(?::(\d{2}))?)?/);

    if (matchDataSql != null && texto.indexOf("Z") < 0 && texto.indexOf("+") < 0) {
      let ano = parseInt(matchDataSql[1], 10);
      let mes = parseInt(matchDataSql[2], 10) - 1;
      let dia = parseInt(matchDataSql[3], 10);
      let hora = matchDataSql[4] != null ? parseInt(matchDataSql[4], 10) : 0;
      let minuto = matchDataSql[5] != null ? parseInt(matchDataSql[5], 10) : 0;
      let segundo = matchDataSql[6] != null ? parseInt(matchDataSql[6], 10) : 0;

      return new Date(ano, mes, dia, hora, minuto, segundo);
    }

    return new Date(texto);
  }

  private iniciarTimerGravacaoAudio() {
    this.encerrarTimerGravacaoAudio();
    this.timerGravacaoAudio = setInterval(() => this.segundosGravacaoAudio++, 1000);
  }

  private encerrarTimerGravacaoAudio() {
    if (this.timerGravacaoAudio != null) {
      clearInterval(this.timerGravacaoAudio);
      this.timerGravacaoAudio = null;
    }
  }

  private cancelarGravacaoAudio() {
    this.encerrarGravacaoAudioLocal();
  }

  private encerrarGravacaoAudioLocal() {
    this.encerrarTimerGravacaoAudio();
    this.recorderAudio = null;
    this.gravandoAudio = false;
    this.processandoAudio = false;
    this.segundosGravacaoAudio = 0;
  }

  private criarPlayerAudio(chave: string, url: string): HTMLAudioElement {
    let player = new Audio(url);
    player.preload = "metadata";
    this.audioPlayers[chave] = player;

    player.addEventListener("loadedmetadata", () => {
      this.ngZone.run(() => this.audioDuracaoSegundos[chave] = isFinite(player.duration) ? player.duration : 0);
    });

    player.addEventListener("timeupdate", () => {
      this.ngZone.run(() => {
        this.audioProgressoSegundos[chave] = player.currentTime || 0;
        this.audioDuracaoSegundos[chave] = isFinite(player.duration) ? player.duration : (this.audioDuracaoSegundos[chave] || 0);
      });
    });

    player.addEventListener("pause", () => {
      this.ngZone.run(() => this.audioTocando[chave] = false);
    });

    player.addEventListener("ended", () => {
      this.ngZone.run(() => {
        this.audioTocando[chave] = false;
        this.audioProgressoSegundos[chave] = 0;
      });
    });

    return player;
  }

  private pausarOutrosAudios(chaveAtual: string) {
    Object.keys(this.audioPlayers).forEach(chave => {
      if (chave != chaveAtual && this.audioPlayers[chave] != null) {
        this.audioPlayers[chave].pause();
        this.audioTocando[chave] = false;
      }
    });
  }

  private encerrarPlayersAudio() {
    Object.keys(this.audioPlayers).forEach(chave => {
      if (this.audioPlayers[chave] != null) {
        this.audioPlayers[chave].pause();
        this.audioPlayers[chave].src = "";
      }
    });

    this.audioPlayers = {};
    this.audioTocando = {};
    this.audioProgressoSegundos = {};
    this.audioDuracaoSegundos = {};
  }

  private getChaveAudio(mensagem: WhatsAppOfficialMensagem): string {
    if (mensagem == null) {
      return "";
    }

    if (mensagem.id != null) {
      return mensagem.id.toString();
    }

    return this.getUrlAudio(mensagem);
  }

  private formatarTempoAudio(segundos: number): string {
    segundos = Math.max(0, Math.floor(segundos || 0));
    let minutos = Math.floor(segundos / 60);
    let segundosRestantes = segundos % 60;

    return `${minutos}:${segundosRestantes < 10 ? "0" : ""}${segundosRestantes}`;
  }

  private getMensagemErroMicrofone(error: any): string {
    let mensagem = this.extrairMensagemErro(error);
    let mensagemNormalizada = (mensagem || "").toLowerCase();

    if (mensagemNormalizada.indexOf("denied") >= 0 ||
      mensagemNormalizada.indexOf("permission") >= 0 ||
      mensagemNormalizada.indexOf("notallowed") >= 0 ||
      mensagemNormalizada.indexOf("permiss") >= 0) {
      return "O navegador bloqueou o microfone. Libere a permissão e tente novamente.";
    }

    if (mensagemNormalizada.indexOf("notfound") >= 0 ||
      mensagemNormalizada.indexOf("devicesnotfound") >= 0 ||
      mensagemNormalizada.indexOf("nenhum microfone") >= 0) {
      return "Nenhum microfone foi encontrado neste dispositivo.";
    }

    if (mensagemNormalizada.indexOf("notsupported") >= 0 ||
      mensagemNormalizada.indexOf("não suporta") >= 0 ||
      mensagemNormalizada.indexOf("nao suporta") >= 0) {
      return "Este navegador não suporta gravação de áudio.";
    }

    if (mensagemNormalizada.indexOf("https") >= 0 ||
      mensagemNormalizada.indexOf("localhost") >= 0 ||
      mensagemNormalizada.indexOf("secure") >= 0) {
      return "Para gravar áudio, acesse por HTTPS ou localhost e libere o microfone.";
    }

    if (mensagem != null && mensagem.trim() != "") {
      return mensagem;
    }

    return "Não foi possível iniciar a gravação do áudio.";
  }

  private extrairMensagemErro(error: any): string {
    if (error == null) {
      return "";
    }

    if (typeof error == "string") {
      return error;
    }

    if (error.message != null && error.message != "") {
      return error.message;
    }

    if (error.name != null && error.name != "") {
      return error.name;
    }

    if (error.error != null) {
      if (typeof error.error == "string") {
        return error.error;
      }

      if (error.error.message != null && error.error.message != "") {
        return error.error.message;
      }
    }

    try {
      return JSON.stringify(error);
    } catch {
      return "";
    }
  }

  private isMensagemOtimistaCorrespondente(mensagemLocal: WhatsAppOfficialMensagem, mensagemAtualizada: WhatsAppOfficialMensagem): boolean {
    if (mensagemLocal == null || mensagemAtualizada == null || mensagemLocal.id >= 0) {
      return false;
    }

    if (mensagemLocal.direction != mensagemAtualizada.direction && !(this.isMensagemInterna(mensagemLocal) && this.isMensagemInterna(mensagemAtualizada))) {
      return false;
    }

    if (this.normalizarTextoMensagem(mensagemLocal.texto) == this.normalizarTextoMensagem(mensagemAtualizada.texto)) {
      return true;
    }

    if (this.isMensagemDocumento(mensagemLocal) && this.isMensagemDocumento(mensagemAtualizada)) {
      return this.normalizarTextoMensagem(this.getNomeDocumento(mensagemLocal)) == this.normalizarTextoMensagem(this.getNomeDocumento(mensagemAtualizada));
    }

    if (this.isMensagemImagem(mensagemLocal) && this.isMensagemImagem(mensagemAtualizada)) {
      return true;
    }

    if (this.isMensagemAudio(mensagemLocal) && this.isMensagemAudio(mensagemAtualizada)) {
      return true;
    }

    return this.normalizarTextoMensagem(this.getTextoMensagemSemAtendente(mensagemLocal)) == this.normalizarTextoMensagem(this.getTextoMensagemSemAtendente(mensagemAtualizada));
  }

  private isMesmaMensagemLocal(mensagemLocal: WhatsAppOfficialMensagem, mensagemAtualizada: WhatsAppOfficialMensagem): boolean {
    if (mensagemLocal == null || mensagemAtualizada == null) {
      return false;
    }

    if (mensagemAtualizada.id != null && mensagemLocal.id == mensagemAtualizada.id) {
      return true;
    }

    if (!!mensagemAtualizada.wamid && mensagemLocal.wamid == mensagemAtualizada.wamid) {
      return true;
    }

    return this.isMensagemOtimistaCorrespondente(mensagemLocal, mensagemAtualizada);
  }

  private resolverTextoMensagemAtualizada(mensagemLocal: WhatsAppOfficialMensagem, mensagemAtualizada: WhatsAppOfficialMensagem): string {
    if (this.getNomeAtendenteMensagem(mensagemLocal) != null && this.getNomeAtendenteMensagem(mensagemAtualizada) == null) {
      let textoLocalSemAtendente = this.normalizarTextoMensagem(this.getTextoMensagemSemAtendente(mensagemLocal));
      let textoAtualizado = this.normalizarTextoMensagem(mensagemAtualizada != null ? mensagemAtualizada.texto : "");

      if (textoLocalSemAtendente == textoAtualizado) {
        return mensagemLocal.texto;
      }
    }

    return mensagemAtualizada != null ? mensagemAtualizada.texto : mensagemLocal.texto;
  }

  private resetarPaginacaoMensagens() {
    this.carregandoMensagens = false;
    this.versaoMensagens++;
    this.mensagens = [];
    this.temMaisMensagens = false;
    this.carregandoMaisMensagens = false;
  }

  private getQuantidadeMensagensPersistidasCarregadas(): number {
    return (this.mensagens || []).filter(mensagem => mensagem != null && mensagem.id != null && mensagem.id > 0).length;
  }

  private getMensagemPersistidaMaisAntiga(): WhatsAppOfficialMensagem {
    let mensagensPersistidas = (this.mensagens || []).filter(mensagem => mensagem != null && mensagem.id != null && mensagem.id > 0);

    if (mensagensPersistidas.length == 0) {
      return null;
    }

    return mensagensPersistidas.reduce((maisAntiga, mensagem) => {
      if (this.compararMensagensPorData(mensagem, maisAntiga) < 0) {
        return mensagem;
      }

      return maisAntiga;
    });
  }

  private getScrollMensagensAtual(): any {
    if (this.mensagensContainer == null || this.mensagensContainer.nativeElement == null) {
      return null;
    }

    let elemento = this.mensagensContainer.nativeElement;

    return {
      scrollTop: elemento.scrollTop,
      scrollHeight: elemento.scrollHeight
    };
  }

  private restaurarScrollAposCarregarHistorico(scrollAnterior: any) {
    setTimeout(() => {
      if (scrollAnterior == null || this.mensagensContainer == null || this.mensagensContainer.nativeElement == null) {
        return;
      }

      let elemento = this.mensagensContainer.nativeElement;
      elemento.scrollTop = elemento.scrollHeight - scrollAnterior.scrollHeight + scrollAnterior.scrollTop;
    }, 0);
  }

  private mesclarMensagensHistorico(mensagensAntigas: WhatsAppOfficialMensagem[]): WhatsAppOfficialMensagem[] {
    let mensagensCombinadas = [...(mensagensAntigas || []), ...(this.mensagens || [])];
    let mensagensUnicas: WhatsAppOfficialMensagem[] = [];

    mensagensCombinadas.forEach(mensagem => {
      let indice = mensagensUnicas.findIndex(item =>
        (mensagem.id != null && item.id == mensagem.id) ||
        (!!mensagem.wamid && item.wamid == mensagem.wamid)
      );

      if (indice > -1) {
        mensagensUnicas[indice] = mesclarEstadoMensagem(mensagensUnicas[indice], mensagem);
        return;
      }

      mensagensUnicas.push(mensagem);
    });

    return mensagensUnicas.sort((a, b) => this.compararMensagensPorData(a, b));
  }

  private compararMensagensPorData(a: WhatsAppOfficialMensagem, b: WhatsAppOfficialMensagem): number {
    let dataA = a != null && a.dt_mensagem != null ? new Date(a.dt_mensagem).getTime() : 0;
    let dataB = b != null && b.dt_mensagem != null ? new Date(b.dt_mensagem).getTime() : 0;

    if (dataA != dataB) {
      return dataA - dataB;
    }

    return (a != null && a.id != null ? a.id : 0) - (b != null && b.id != null ? b.id : 0);
  }

  private mesclarMensagensServidor(mensagensServidor: WhatsAppOfficialMensagem[]): WhatsAppOfficialMensagem[] {
    return (mensagensServidor || []).map(mensagemServidor => {
      let mensagemLocal = (this.mensagens || []).find(mensagem =>
        (mensagemServidor.id != null && mensagem.id == mensagemServidor.id) ||
        (!!mensagemServidor.wamid && mensagem.wamid == mensagemServidor.wamid) ||
        this.isMensagemOtimistaCorrespondente(mensagem, mensagemServidor)
      );

      if (mensagemLocal == null) {
        return mensagemServidor;
      }

      let mensagemMesclada = mesclarEstadoMensagem(mensagemLocal, mensagemServidor);
      if (!mensagemMesclada.dt_editada) mensagemMesclada.texto = this.resolverTextoMensagemAtualizada(mensagemLocal, mensagemServidor);

      return mensagemMesclada;
    });
  }

  private aplicarClienteVinculadoLocal(cliente: WhatsAppOfficialClienteVinculo) {
    if (this.atendimentoSelecionado == null || cliente == null) {
      return;
    }

    this.atendimentoSelecionado.client_id = cliente.id;
    this.atendimentoSelecionado.client_name_snapshot = cliente.name;
    this.atendimentoSelecionado.client_codigo_erp_snapshot = cliente.codigo_no_erp_do_cliente;
    this.atendimentoSelecionado.seller_id_sugerido = cliente.vendedor_interno_id;

    this.atualizarAtendimentoLocal(this.atendimentoSelecionado);
  }
}
